import { jsx as z, jsxs as ae, Fragment as fr } from "react/jsx-runtime";
import { useMemo as en } from "react";
function tn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function si(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function a() {
      var o = !1;
      try {
        o = this instanceof a;
      } catch {
      }
      return o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var o = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(r, a, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), r;
}
const rn = [
  8364,
  0,
  8218,
  402,
  8222,
  8230,
  8224,
  8225,
  710,
  8240,
  352,
  8249,
  338,
  0,
  381,
  0,
  0,
  8216,
  8217,
  8220,
  8221,
  8226,
  8211,
  8212,
  732,
  8482,
  353,
  8250,
  339,
  0,
  382,
  376
];
function ai(e) {
  return e === 0 || e >= 55296 && e <= 57343 || e > 1114111;
}
function nn(e) {
  return ai(e) ? 65533 : e >= 128 && e <= 159 && rn[e - 128] || e;
}
function sn(e) {
  return ai(e) ? 65533 : e;
}
const xe = /* @__PURE__ */ (() => {
  const e = new Uint8Array(127);
  let t = 0;
  for (let r = 33; r <= 126; r++)
    r !== 34 && r !== 36 && r !== 92 && (e[r] = t++);
  return e;
})();
function an(e, t, r, a, o, l) {
  const g = e.length, w = l * 90;
  let d = 0;
  const v = () => {
    const I = xe[e.charCodeAt(d++)];
    return I < l ? I : I * 91 - w + xe[e.charCodeAt(d++)];
  }, c = r - a, n = r + o, i = new Int32Array(n);
  i.fill(-1, a, l), i.fill(-1, l + c, n);
  const s = new Int32Array(n), u = new Int32Array(n);
  function f(I, E) {
    let q = 0, j = E;
    const K = E + I;
    for (; j < K; ) {
      const M = xe[e.charCodeAt(d++)];
      if (M < 89)
        q += M, i[j++] = q;
      else if (M === 89) {
        let A = xe[e.charCodeAt(d++)] + 2;
        for (; A--; )
          i[j++] = ++q;
      } else {
        const A = xe[e.charCodeAt(d++)];
        q += 89 + // eslint-disable-next-line unicorn/prefer-minimal-ternary -- branches read a different number of side-effecting input bytes
        (A < 90 ? A * 91 + xe[e.charCodeAt(d++)] : xe[e.charCodeAt(d++)] * 8281 + xe[e.charCodeAt(d++)] * 91 + xe[e.charCodeAt(d++)]), i[j++] = q;
      }
    }
  }
  f(a, 0), f(c, l);
  const x = new Int32Array(o * 2);
  let b = 0, y = 0;
  function m(I, E) {
    for (let q = 0; q < I; q++) {
      const j = E + q, K = v(), M = v();
      x[y * 2] = K, x[y * 2 + 1] = M, y += 1, s[j] = b;
      const A = (i[K] < 0 ? u[K] : 1) + (i[M] < 0 ? u[M] : 1);
      u[j] = A, b += A;
    }
  }
  m(o - l + a, l + c), m(l - a, a);
  const R = new Uint16Array(b);
  let p = 0;
  for (let I = 0; I < y; I++)
    for (let E = 0; E < 2; E++) {
      const q = x[I * 2 + E], j = i[q];
      if (j < 0) {
        let K = s[q];
        const M = K + u[q];
        for (; K < M; )
          R[p++] = R[K++];
      } else
        R[p++] = j;
    }
  const S = new Uint16Array(t);
  let C = 0;
  for (; d < g; ) {
    let I = xe[e.charCodeAt(d++)];
    I >= l && (I = I * 91 - w + xe[e.charCodeAt(d++)]);
    const E = i[I];
    if (E < 0) {
      let q = s[I];
      const j = q + u[I];
      for (; q < j; )
        S[C++] = R[q++];
    } else
      S[C++] = E;
  }
  return S;
}
const on = /* @__PURE__ */ an("!}.&u%}'&}*'~!6*)%&,~!J~!J~%L~y<~!R,~~%Lu~~#GD~~#|)1#%}^%}2%+#.##%##%}&%##%'#%##&%#%#'%#&#%#&#'#%%#&#%##%#)%''%&%#%#'%#%%#%%}%%%#%#&(23#%%#&-%0%('1#(##%#'##+%'*.:1}#%#6-+(%'%%#%%%}#L'2351&('%}&/N'(0(/*-%(%%}#'+&T%7.2}#&%&#%#36/5##%&%%#&#%%#))2%%##%&&'0~!#*+&'%1~!%).'3q?&%'1~!.##%6(~!+%%%(Gw'rT~!E#<nA%#jZ~!H%(~!42##~!*31&~!G%U~#)5~#`3~!J~!Z~%]~%Y~%C~!q~!u~#kz~%#~!6'~!D~!U~!?~#T~!c%~!G#'~%7|~!G~!J~!G&~#pb~(Df}#%}*&}#%##%##%##&#-}&'#'&%#.++}%mI,#,@&(}*%}*'%&##&#%##%}&0}#.},U},%}+%}&%}#%##&}B%(}(%}+%)})%##%#&}&%##%&}<%}>%#%&}*%}(%}9%}/%})%}*%}*%}?&}&%}3%}&*#%})%#%#)}#&#-#+*%E%%'%'#%}#*V##&##I}#&&##%&%#&&Qf%%))w/0+&%#(#.%-''''++++7}>%4'',##1,#%#&%##&#'##&#*#9)%&%}#*}%,#+P(%A&%#'&##wSD',9E00#y#@}(+}&%&>~!#~!X}#*}(&&}(&}(,%}%&#+&}#&}I%#%}%)#(},'%#*}4%%#%}(''}#/##(##),%-##%%)#&}(.}&%#&}%%}*&#%},&&}&%}#%*'#%})%}D&}&%}-&}6&#&}-,%}#%})-(~+`~,=?~I9'9%~!,#%})%})%}@%}?%}(~!?~#<~#pP~#BG~#=1#%K+~#?#~%;)~#A~#mF1~#A'~'X%'~#lR~#N~'N~#r~#m#-~#i'?%#'%~#B%##%,%#~#_%#0%~#]732~,w~2+#:&#%&'0%&>%}#>##F+)#%&&#(+_}4&}-%}(&}@&}O7Fdf0@+/v4}&WU##&/0#&'('B#%}.%}'+#%}#%%&#&%#%##+#&#)#6#'#.},%}c%},%#%##%&#&%#&~#>'*-.%##%##%}#%%}%'~#)D1}#%*&~#_%%'(~#S2%'.}#~#=##*'*-%}&'%'##&&~'E%.#&~#M4}%%##&'%#~#O1##%&#'+~#<B%##%%'%+~#;#@%}#&%#&&%#(~#H1}'%'##&&~#?A}&'~#D#%32}'&&&&~#[}'(#%}'~#;C})&}%%#%~#=&%,3}%'(#%%~#^'#&&)#%'~#Y%-~#d-%'~#^%%&#&&&}#~#b~2t*&'~&(~&@~0%~e~3}%*''0})&}+~!9##-}#%-hD*)1fC#%/&/fB#40~!+#)*4~!+~!K'&:~!/*7~!.#~!H~!L':~%x&~!H#~!*~%1~!I#~!+A~#p'~!F~~#-#~,,(~.Z~!V~%;'B'mq-W~!N~%I%#&&#&}#%},%%}'%}+X#%}#&}(%}'%}<%}#%}%%'}'%}:~![)9@~%>~#UA%-%##&~!C%~!-.9:~!1~!-^2/:a~!y,D*J#-5)/4~%23,~#G~!L1~!0X3`~!2+~!!0-~&E~!W~!o,>Y&]~%cZx_&~#O*9#A#'#+I'%#)~!0B*-5A+-((F&*M#)(-7-5+'-3a5Vi~!Y~!?+[)%3),ERHm~!+:D,VG.+)?fB%%*(%)'(#&80%1'8`K8?`+'Z#&O&'H5#*9)A%%5&3))0%39+.*7#()&&*=4@**L)<'_&*+..;(#*+)./&0#3)%')-8(4ixD(&.}%,('aI:,)%,k2231T)I'#/-W7,/'Q#.'Y24+h')37</31&83##&0#),H(?'&?/1##%#&&#%''-%&&&#(&''&#.-'%#%%(,')*'&#&#'##%(%(#%('#&##%%%%('%#%#%%#%#&%##h>w+v<ayvyvcg.uuhKr}g/v|g>u9i[~>g5uI~=RvdwEg;v/g;uk!!TTSx]@RT!U!#!@VBRUU!'UTe-d0c`e&gSdicedFcrdTaqb.kYcAohdYd@a3e+d}dMdtd.aJ#bqcK`dle/e.e'dwdPdodddjbEb}ogd^ofdpduc6j?l%d{drdqc)d7bacOdQ%T#Y)X.sR[yH>6Vyv3[xwLu>vo'!*.[yBacahoj>6Rew3[xqdZa#!a&#^(X-[yG>6Vyu3[xvg3sEr|g.u/Ri9db0T#^(Xa)!-[y;>6Vylg4wKs{JwNZt3@3r=c4Z([xlg;wKt!cpq's@v7A'*a(a+!-a#[y<3Dt?3Dt'>6Vym3[xmg9rxsNJwLZt4~?r?db1T#`-!(Xa,!0[yS>6Vz%NuQs.g4wKtnJwNZtS@3r>c4Z([y%g;wKtrdga8!a(!#&T*Y-Xa#!a0<or[yc3Dtq>6Vz43[y3JwNZtf@3s!Ju}!%Dti:pm3c_%X#tjB5pkd6q!r]u?voC'*-a.a2!0a&a+[yI3DtI3Ds~3DtH>6Vyw3[xx;:s#~<5pKJwNZtE@3r~d`a)!a2T#a.(!+U.X1[yT3Dt`3Dtv>6Vz&3[y&g9rxwzcxstPu.<rAJwLZtT~?r@dZa%!a.&^*Za(/Reu[ya>6Vz23[y1g3sEr}wkg{NuQRg{ci(U#5@b`~,cg#U(2WnH5wugcRh7dX#T(Y,a'Ta!!a,[yZ<]mj>6Vz,3[y+Pv#5ReZKu+=,%!H}7ABwkaS?Rh:BcW(X#<]mrj:ubv/ARekdg%!(!a.*Ta(Y.X1!#sP>Rl*Dt6[y>>6Vyo3Wf*jOvuumvuRgRJuq*!:9<B@bX~3jVv&v@s@5Re[d/rQt{uAvo&a&a*)a2!,0Wf!3Dt0=Bs'>6Re}3[xy~<5s%JwJZt1~Gs)c;&!#2sJkNuXvzq7rxu,Re8dka4!a8(aEZ+a@Y.X1Xa)[yd=Bs(3DtP>6Vz53[y4cX#X&Re:avRe9~<5s&JwJZtQ~Gs*i^rzvdRg+Jv{%!2sbB@bX}kdga,!Za?&^*T1/!a'Dt+[y6>6Vyf3Wf%g/u;s4hGu6?Rh-JvZ,!c%#&RoX54Rivj7uyvf8RgTKvZB%*!2sGh<vu5Rgq<=C::9bb~#dZ#T&Ta6Y.X*Dt>[y93Wf)coZ(T,6VyifluvRgC@95@B@bX~/hFu34cC#T,k/unq8w8Q5RkUklwQuzunq8w8Q5Rk8d/rJu?v8w9)-&!a0a;a&aIWejg3sEr/h1s<DtDJvyZqY5aws3Jvy!&Wei~Hr1:au5@Bag>23E~5c:Z&bX};kKv?w&unuVu5Rjc;>bs)#~@:Rh.=ay<a]C;b`}Vd6s/t{uAvoaxa()!a,a7%-a#a2Dt,[yF2Wo[>6Vyt3[xuNuPRi&NuPwpi#RoWh?vf8Ri%Jv]!%Ri:KvxD!.'2WeAjZu`q9rxu,Re7woeAg-unLq(qA_/*2Wg_g3u5q^9:4E}/jTrxrzv=Wkkd~0UX#^^Xa-a1a5T&a=U1a'*aEa]!a*aPaA-adok[y54Rn>;:p3~Dp5g9rpsFNvZqjg3uJp4~<5p0Pw;5qlJwNZt*@3p1Pw:5p/Ou!5p2JvG'!6Vye=<qnJvh_[xhg3v,Rh3kOwOw-sDuev/Re^dha[a%!%!a+#Ta7)-5TaCaO!aka!a)sf[yb2>Rl!9ARiq5E}Qg=ucRkBE|oJrJ_@Wk~@Wk{JrJ_@Wk|@WkyJrJ_@Wk}@WkzJvO_[y2g-vMRmiKuYC!)&>Ri;>Ri<@3RkNc](X#@9Rk=g5vuRmhKvDB!+'=]meg3u4Rmgd)#Y'Vz3CARmfd`a+!%T'!+#Ta1Ta6TaM-sTDt9[yA9sYd'%Y#s[[xpj:ueunaXRgEjRq,v-vuqdd2'`#6Rev<32@5>:2<E}5xIo9a*X#Y(;5RePJvD_g>vyRgNj8w)v8<wggs:RgXiZt|vjx,hSq3ah!-(~@:Ro/Ou!5RhWj^v(pyw8unRhUdx-UY#^Ua.a3a70!)%UX1TaDa)'omRiRRhE[y:3Dsz=Br,>6Vyj3[xkg6ruwjcqsrPw;5r*Ku]D'Zt-@3r(~?r.i[vwv]dU1a--U#`a4(g/vsRhPOu!5RhLj:rmu9Wo!~@:wdh@g/vsRiTjXuvvNr}:RhBj^v(pyw8unRn]dz1UYa'a+^Y(!aETZalaRY.Ta?a4[yDJw1!#qLsW>6Vyrfzq-pLflpwRe|Js>%!Dt@3Dt&Jvy_[xs~HrnjMuwpsw'RecKu+D#'!t<~Grl~?rjg5u-x,gwp{ah!-(~@:Rg~Ou!5Rh'jXuvvNr}:Rh#cW#X/c;&!#2sLi[v7u7RgpJv)(!iLrxu,Re6j7v@s@5Se[e7d`aW!Za(a`T.a#!a3!&aDa-!9)Dt_=6s+3[x~~DR|h~DS6avhGun5RkZj3w)v-]mkKunB!&*]kb97R|i<ARk<c:Z(6Vy}Juh'!wziMRoS:F|vkLuauJv5vtvQRh1d='T+Y#VyO~DR|jcF#T'7R|g97R|kJv3'!ay<Rj,Jvh&!:ReXcsa6*a+#a#_aIRf9aLRf?c,Z&Rf5Rf7c.Z&Rf;Rf>cQ#%T'p-Rf8Rf=ct#%'(*!,p,Rf4p+Rf6Rf:Rf<d~'Ua%U*^UYa(!a,-!#a4YaTalaEX0a8a<Weo3Dt/3Dsx=Br93Wen~Dr;~<5p<JwNZt2@3p=Pw:5p;Ou!5r3c7&!#:p>3Ds}KvGB)_6Vyk2sM=<r7x'eovA(!hFu1ARf}cV#X&@r5j6rvwQa^Rf3c=Za'wkghJv__g;unRggA53B9=b^}%j6uduo5Jq;!(hIv%2Re`Ou4ARe_e%a#^^^Xa&!a*a2!&a6YaP!*ad!#a:aE/5Rn?[y@>6Vyp;:pE~DrY~<5pBJwNZt8@3pCh=rt3rWPw:5pAJup_[xoNuPpF9c!#'45pD5ARn)d8#X'X*3@rU72s]h>v<<sSjJpqvewOJq/(!hNw'5ReBk0s2u3w/w'5ReE5@Jq.!a+JQ!&WeU23d(#Y&RjG5]jBk!u7w&u0udARjEe#+^^^Ub#!a2/a`Z(agT1!a-a;|@TaG!aS[yV=Re~fow'RguNuPRe?bz#'>RoUWeL>:Cbb|?JwPZtVg6ruRmzJvD'!6Vz(g/vmRh~Jvy_[y(g9voRgyx*cy(#2>Ri2B9b]~9kIw9u7rluJu3Rg]dI#a%UY'@=p%CAx.gQZ&RhwwygtRm{x5g_Z'+ABqR9Woa=Bp&dV#^*Xa'!&@o{g4v]Rk;Jv{!%Rk[wkkiA5RkiwwfUB=x,fUuqC&*!>RfTg8v0RfV~ARfSd;rJsAuAv9wR'ae+/aO!a@aza/a#[yQ@Wg!2Wemg3sEr0JvB_g>uvReWg2v+Re=KupB_+[y!2AbY~-~Hr2AJwD!(h<~El>h<~El?Kun@+_:9b`}Kg-v/Ri3g;vtwyk_9]k_d=&T#*U.6qh@Ab`|K9:H|CJv[!&3Dtex'fDwC%!Rf[9WlMd[(^X,!a%Z06Vz!@WgBg=v~Rgvg,QRe@awd,#Y+jTv|Q~EfWj]uNr|~FRfXdy#Y&^Ua%!aO.!(a)Ua;=!a@aKap!a-,a!Ta]a[rSa]p?[y82sK=Bq~;:p:~<5p8Pw:5p7d'#Y'Wf(;RnRi[u4w&RgJJvG'!6Vyh=<r#ijuuv/sIKuYD'ZtG@3p9~Gr&d2#`(g<vtRgFj`u5w&rqpxRf2CJuY!+:wfnTOu!5Rg}jNs1ucv&RfwJvA!&3@q|BDcC#T,k/unq8w8Q5RkTklwQuzunq8w8Q5Rk9dga#!a'!a=#a0!:+Tb*b@aO.a4!aba8aFJv^}?!VyR~Dr<g;u%Rn.~<5p[x'e`wNZtR@3p]Pw:5pZhNvjBp.woe_g5u-r4JwF!%DtO3:ooc7&!#:p^3DtpLuGw(!+%)Dtk6Vz#2sd=<r8d'#Y([y#<x3gJt`w@!)%}MRiowzikRij=]ilxAf3,U(#B2Rf#g0v-Rm[ck{`U#]giKv3>)!&6Ri154s,KuGB_%@r68r:dJ|t`#X(9<E|u2@H|rx3gJu?w'!+'1Nu7Reg4=H~+9<wxgY95Rm]xLggZ-`(X}U2:Ri4h<uOawRmsJv__5@bb{jbV~3dka#a'a]!,#a+U=a>b6a3b%!/aKa/)!arwve^VyJ;:pR~DpTg3uJpS~<5pOPw;5qmPw:5pNOu!5pQJvG'!6Vyx=<qoJvA!{~Jup!%@qk7Rn/KvyD!}''[xz;>wkh'?Rh,x8gyt`w5D!&),(SgyccRgztJ@3pPB5p#d'(Y#<]mmifubw&RgoJvE&!82s^JvF&!8Rf,ADb]~;x=h'rNu]vK!,%'*0RnORh)4Rh*AqQg-vaRnNg;wHwkh'ba~4cE#Ta*x3gctyw@'!+%RnFRnD<4Rn@hFvK5RnCxWg[#`&a0Ua()`1Rm75Rg[c]%X#qi8Rg^NvdRj>BwzgZauwji7Rm6A4wgg]d1#&(*,.0a#Rm;Rm<Rm=Rm>Rm?Rm@RmARmBe%#^^^Xaea?aC/b+(,!a+a#!a/!>a&Ta<aKbD!2wphBRnk[yPw}hE|.=Br-3Dtm>6Vy~g6urRf.x,hPrNav!%'RnqRo%Ro#Nu;q[Pw;5r+JwNZtM@3r)d'#Y'Weh;xChL#`&RnmRnoKu}>%(!Rne~Bs-;2wjcussJv+'!aYSO}6@B<5?ba~8LrNvj!.%*ROwungw~ng~:9;Ri^>wtnig;wHRnixDh@|(UZ.x1h@|)!#:2<H|*xHn]#-UX'3Ro)z=iT}6ARns=Bwsn_wpnaRncw]aR(#UXa&Ua*a/=]iPd'#Y&Ro'WnXf{QRm2hNvj]nZd`'T~&1`{|`#9b]{}c:'!#Wl{>@=be}]?cl{{U#:5Abb}Jds#^YaF!a*b4a#a3aPa>&Tb!bH!*a_!Eau?/a&RjY<]gj>6Vz*;:pe~DrZg,QRj1JwNZtX@wihspcJvZ&!VyX9WmOJu|!|N2WmHJvh&!]ht~Bpbcn&T(!#RmQ<s7Nu;padH#X'`+WmJ@>RmKCARhnKup=!)&Wf+:RhqNuPpf9c!#'45pd5AwghpARn(Ls@w!%,)!RmP@Wfe<E|IJva!&WmNg8vsRmLd`*.`#Y'Xa!axRn*]hrA8Rhug5s@rXg8u!RmMd8#X'X*3@rV72smdI*#UY&RmICARho~GsgxVgd)Ta'U-Y&Xa!T#RnEWnA@Wffg1uDRi0hFvK5RnBxGnG&#`%owp)@wsf+bX}Ze-*1!a*^^^Ua|!#a.aq&Ya2!a>.a6!a:aO`aJDtL[y`@Wg#>6Vz12@wzoYRoZNuPRi!NuPRhzg=ucRi,@=b`{Yg=ucRi-ACJvB!&Sh[ebSh]ebi`wUuFRm4Jw2_[y0JvB!.<Ju(!&SoG}6Shd}6<Ju(!&SoH}6She}6Kur@._g5vHRieJvx!{L2G{Kx6gd'T#?Rh82Wi5cZ#X(g1w)Rm5dW-Y(Ta#!a)!#aYa=wnfE=su2>>bU{0j9udv:<svj8uQv-7RgHdE%#^'sq9sp=>Bb_{TJv`!&g/r|snj6v(us5d,#Y(56H}[978H}]Jw5!&g1rushJvB!+j;v{u5?zDhd}6}bj;v{u5?zDhe}6}ce*#`(^^^a[aea!=!a6a*aoXb1a.!aAbL!b>,b'aL!aV@Wf|2Wlg3[y/JwNZt^@3piPw:5pgJunZou3@rsJva&!Vy_g<v~Rm#JvG'!6Vz0=<r{Ju{%!:pj@WfsiXuJu3Rm:JvZ&!WfA~Bph@c4Z&Dtwax5rubx(#:awRk1@d,#Y&RfjRfid1#,Y(@Wfp2Wlrg5s@ryKu[@!,'=]ig9wlk?Rk>g5u-rqJvy'!@9RkQcH(T#=>Ri~@<wkj(Wj(KuZB*!&<7rw@9RkRcH(T#=>Ri}@<wkj)Wj)dg(Ta2Xa9X#`-!a*CARhg@@=I}d9x;c~#X%so=<sj>2@@=aybb}XjWv0Q~EfEj3vLv;<d,#Y(56H}`978H}_dgaPaFa'a/!#a3Y0a_a;a|!1(a7-[yE3[xt;:pJNvZrrg3uJrvJwNZt=@3pIh=rt3rxPw:5pGOu!5rpJvG'!6Vys=<rz@c4Z&Dt(ax5rtJvZ!&~BpH@wsfNg-vaRlNci*U#=<wei<F}a5@Jq.!a*JQ!%@qZ23d(#Y&RjH5]jCk!u7w&u0udARjFd/prq=tyvpaEa(a:.!a1aZ(@@=I}:9wpd%=<sX55w_h}@@=I{t=ay<aU@@=I}T=ay<2@@=I})?C9:9au@9Cb]}DP~=x-fAZ(2Wl1=ay<aU@@=I}>5@d##Y+jTv|vV~EfFj]uNpn~FRfGdgaK!Z2&!a8a-Tb({E!acTbM*!a(DtY[yYd'%Y#sl[y*hHvh>Re5x2c{Z}.j4uCvcawRiMd+#X+_x&d!},<5RkX;2Hzw@x,gavfB-!{CcF&T#Roe;RodwWbBg5urRgaKvHC*_6Vz+<4opieuew&Rmq@d]&Y)X,T#X0Rh}<BqP=4qS9:ReMg/ujReNJw0!/<Jui%!bd{kawwnemRelAxUa?a3#*.&UX(Ya+a/RhvRnQ<o}9Wmtd-#Y&RgSRmw9;Rmxay=Rmyg-vaRmuxEhSrNu,v-voC!%(aR.a(a7+1Ro1>Ro5CE{A9b]{@;5x#eO{:g;urRi+KrNA!%(Ro3>Ro79;Ri_Ku@>{;&!x%gX|{KunA_+g5QRj/g3u5Rj#g>uERj%wio/xRhS&!,!#^1U}wba{8>>@=be}qC@:D5ba{7Ku+A&!}x?ba}t>>@=be}se(aA^^^Uat!b0#{pa+awUazbGa#aLb9bgaWac'a5TbS=Br!d1#`%scp_Jvl!#rT>Re0JvX&!VyN=H{Fcm#U&:pY=ReaJv2&!]h0=]nUJvG'!6Vy|=<r%JrM_=]h2@Wlud'#)U'Wf'b]{i=]h/Jvh!&~BpWg=v]RnMx+ny#'Nu;pVwjnu=]nwxJnx,T#`&Reqwjnt=]nvieu9vrRjLLuYwP(#+!th@wih5pX~Gr'g5v/Rh4KunA'!-CARnP@wwiN:Rm_9x'cvw>!|l=<saKvAA!0&3@q}>w^e1bp#&Re2Re3BDx7gH#T|f5H|eKuZ>!%(:qNAH{]Jv6!+3B2B9=b^{X<5<B92:E{ZLvhwA(a;a%!igQuyRmad+#Y}m@3Rh5d8#X'X*:AqUAHzmaxwbh<aXRnVcF}RT#Nw&cj#U(BWnug/vsRntdka)(a3+.Zb7aYYan1!bVa@Xa}[y^@b[{G=H{+hFu73Rj&Pv#5ReQcK%T#sig1v{Rj'Ku+D#'!t]~Grm~?rkKuMB!01d5#`'Vy.ta3Dtu~Hroc8#'{^45s85AwZbP&!#Rn!wghxWn#KvEA!)&2RlA2RlBx:h|#(T,=]j09Wobz>x]z/@awRoTd+#Y(az]hFhCrm4d,#Y+jTv|Q~EfMj]uNr|~FRfOdCa!Xa9_X#@<plJvf!%b`{(9;Rgwc;.!#2x7cw#T|UDb]|T5Ju={(!=@E{&Jv)&!Ab`{'awJvf!~*>>@=be{#KuY>!+&4Ezyi[ugv&RjIdea+T)#UXa&T-T&a!Rh9auRmW=]kLg5vuRn+g3u4Rn-Ow6ARn,hHus5xNk?#UX(U~)/g8v0RkD~AwkkF?Ri.OuNBwkkA?Ri/d|a2`a*^UYa.!aBTZaTa'Xa;!(!2!-a#b2[yC>6Vyq3[xr2Wi?g1rusVh%s?DtF~<5rbJs;%!DtBfswKtCj[uvuSsEu3RgVx3o:u+wN'*Zt;@3rd~Grh~?rfg8w)Lq)qE&-a%!>bI|`jWv0vV~EfCjTv|vV~Ef@j]uNpn~FRfBcK#T']gWNu7x,k7q4ai(0!hHv8<RhmkMu9vrsBuev/RhlCJvB!,g<v{wchh~@:Rhji[vrv{wchi~@:RhkdS&a5UY#Ta!RgPwwiI5BwciI~@:Rh`x'iJvj'!5]iJPu8Bwch]~@:Rhach)U#h3rp]gLh@t|Ax,hTq3ah!-(~@:Ro0Ou!5RhXj^v(pyw8unRhVd|)`,^UYas!a?/a2Z'a^Ta{Tb7Ta(a#!a,Wf&9sZ3DtAadamov=Bqt3[xig8vsRm~>waiL2b`{QJv*_Ouv2qgj<v]v2BqfdR'X*X#Y-@3qr~Gqv~?p6hHv-]glPup5Lq+q?_%*b_{qF{n9b^{rOu4ARhpKvCD!+&~Bqp:5Dbb}nwoiKl&unuTuBv]v+ueunaXRf0=Jvh!0nKufu8v1w&w7q%w&uHrz:Rgnj5w,uxDJq/(!hNw'5ReCk0s2u3w/w'5ReFd>Za&!*UaA=<wkgsRnSJv^!%Refifw3vyRgOKu_B'!,<]gkiiu:w&Rh<=C@a^<B57@2F{[<B5@aW:=3away9A5aW=<B=C@a^<B57@2F{Ie-#`(^^^bCara.b8aza6!/bZ,!adTbnTbOb+aFaS!aAT9@Wf~2Wli3Dtl2@d,#Y&RfnRfmJwJZtN~GqyJva&!VyMg<v~Rm%iXuJu3Rm9Jv[_=]ih9wlkDRkCd1#`(@Wg>2Wls3cH#T(@<Rj*=>Ri|b~'#23s9h<~El.d'#Y&Dtxi^rzvdRl#d*#U%(o|B2s`hJwSaxRmDKv4B&!1:Rmdd5#`'Vx}to~Hq{x'f1v3(!BA5ba|bJv_&!Wfug1v]ReIdO+U/Y#&G}-8wze=Rh{g1v]ReHg/uQRf/by#)ibQwERl/cH#T(@<Rj+=>Ri{cNu+vlax-!(#a0qa9<Rii2;;bU{H;x<i=&X#Rk`<4wwi=C9H~8xAI(Y#<azRi@45wXI<B9;5bb~7dL(X#Xa(+!aL6Vy{g5QqOau:5au2@ay547EzbxOcU(UX-T#Ta#:Cbb|A?wjh/b_|SOw6ARgtihr}u7Rhy<d1#T)X1@@=I|~=ay<2@@=aybb}Sj3vLv;<d,#Y(56H}A978H}@dGpvs@uAu`vcw9*!aFa+ai%(b!aXa8.a?a[ozWey=sU2@G}Nch&U#Rf_WexKu+D#'!t:~Gr`~?r^j]uNr|~FRg*j^psurwJt|RmcKv)@&!)7Rkv~Br[@wxfO:Rl3co#U'6Rezj_q#vIuavjRltwzeyh@vr5JqD0!>aY?C9:9au@9Cb]}9cl#U*5;5<H||jbuus1ucv&Rfvg1v~d/pppzqFr^a--a~!aMat1(hFv;Wiz@@=Izoj5uuv-7Rix~Cw`fk2WlVcZ#X,k)u3vWs@u2]ktg;wEx'fBq(_2Wg/jTv|vV~EfoJv]!15x'hzqG!(P~EfU~CRl_j6v(us5x4i-#T(2WmZ?C2F|d>Kq<aj1!*jTqIsBv=Wl`~Cw`fi2WlWj`v0u*~>RlR=c>Z,k#u3vWs@u2]kr<c1Z+jTqIsBv=Wla~Cw`fm2WlXdmb3!a{(arZa`bkTa%TbQTa-a9+c'!aM!/[yL=Bqug.w'RifhFvyDRj.g>vgwyk^9]k^Jv3_@WfbAARkhJw2_[x|JvB_wkoIRoKwkoJRoLd'(Y#<]gm=<9<H|yd'%_X#skDtb3awwqkgNulRkgdB#^',9:p'hJwSaxRmEBwVb8@4=H|qLu+w50&!)@3qs~?pU>Awwn;;Rn=c:Z'ARn<=<qwKvC@!/&~BqqJv6!&]eVb^z^xRge'/a%+^`#Sge}6<4Rn3=]n0Pw2>Rn8Jw0!&>Rn:>Rn6cY#a7+!a&=<wkaNw~h3z_c5Z{=wjh#=]nLKv^D!&)Vyz=bW|swYb<WetcG#T(2wxa@qVx@gD#Y&b^|V5JwG&!5bb|pg/w&RgD@x=kHs=uAvn!a%%/'+RmSRh694Ro`g-vaRmRhHv-]mlxCcS#`&ba~.5cD#Ta)P~=d,#Y(56H{>978H{Dd_#{2^Y%_+qbbb{6g3sERhsbU{?dfa.,`a(Xa<!aiX#(55RiG54RiHcI#T'WiU3RiVNvdwtfcRlKNvdd,#Y&RlHRlExQgf.1*^T'X#Sgf}6Wn4=]hfPrk>Rn7Jw0!&>Rn5>Rn9Lunw?&a2!,5<oq@@wqfdRlJj5Q~=d,#Y(~ARfcOuN]fdDKw;ay(}i!547E}j?cI#T(@5bV}iCbV}hdv(^^Tb?a40,b##Tbo!a*bR!a<b|a/!aKai!aU[yK=]o^g:v>ReGJwPZtK<7Rh+h<~El,Pv#5ReR@awwxjCg,ulRjDJv6&!]j!z?aQeeg>w=Sh<eeJw;!&axEzOg,Qosc!#*:wkeJ]eJ>x'h-u(!%Ro.w~h.zPdNZ(X,Ya![x{;9ReY;wkgxRiF:x?ap#Y&RmUg<s2Rkod]+UY0TZ'!a&A9sw<=bczLNvuw{gqzNhJwSaxRmCKuLay!#&s_Rf-55b^{uJvZa!!c%#(55Ri654wmiu5RiuawLu,vp!+}^%b_}Y9;wkgxba}o>A9:=b^}zKuh=a''!3awRk3c*'!#aHRk6c+Z&Rk5Rk4Jv)&!awRjSawd9*`#0?C2@EzMj8u<uJ5RmbjQrquJu3x,k>uq@_+=ayb^|W~ARkEOuN]k@7dhzV^X/X&a-#zRzSb`zXcJzTT#2WkVKvDBzW!%FzY9;5bbzWjQrquJu3Jw3%!b`zU=ayb^zQd:#X(T-a!6Vyywxh}=b]{Jg=u1RiAdGp~qHtzv!w(wA+a+a;<!aJaYai'anasb(=azRmV:Cbb{MLq2vb!%')RjuRjrRjtRjqx3jnqCw3!%')Rk(Rk+Rk&Rk)Lq2vb!%')Rj{RjxRjzRjwLq2vb!%')RjsRjpRjfRjex3jcqCw3!%')Rk'Rk*RjkRjl9<CbbzfOu4ARhxLq2vb!%')RjyRjvRjhRjgx=joq*uKvb!%')+-Rk.Rk%Rj~Rk-Rk#Rj}x=jdq*uKvb!%')+-Rk,Rk!Rj|RjmRjjRjidAq&qKs@uAv8Aa.'*-a@a&0!aM@a5[y73Dsy3Ds|3Dt):wxgI2sHJwJZt.~Gqxwsf0ikrzt}Rl0Jvy_[xj~HqzKv_A|D!&WfP8axRoVcf,U#k(v]v+ueunaXRf1Ju}'!g8u#Ri=jQw!sCunLprq>!,')~<5qeGzq9F{W=c##%s5au:5aU3CBE|;d4#X(D!a&6Vygx(b;#(=]ed?C2F{N<capoq2r[a&!aPa9,'Pw;5s:@@=I|,55w_h|@@=IzcP~=x'fCqB_2Wl2>aU@@=I|1OuNBc1Z+jTqIsBv=Wlc~Cw`fl2WlZ~AcTa%!Z+jTqIsBv=Wlb~Cw`fh2WlYk+uNqJsBv=WlSg,u3dca3#UXaMYa)TaB-=cM|7T#<bI}l5@B932:aV2G{BOuNBJq:|M!5Ezt=<B=C@a^<B57@2F{v>cB{/T#=ay<bI{3Jv6!a.6BKq0ah&+!5E}HP~Ef{978BaU@@=Iza<7d#.Y#978BaU@@=IzH~AJq0!(@@=IzG978BaU@@=IzFe,aU*Y&^^^bvJb,b:bFad!a,c2Ta>aL.bo6!a#CbTa'T#Re{2Wlh2@G{yg6t~Ro_NvdRfticuRQRllJv3&!x&c|zs@Jw3!%RflwpfkRlpKuL;%(!Re<@G|C2GzdhIvuBwgjAg-u0RjAKQB%!(GzZ@G|5NuuRl7d='T+Y#Vy[g<v~Rm!==G|>JvA!)@wma=]m1ifuaw&RmnLs@vT'!|/+[y,g:v>ReTJw1!#qX=x!eC{bLu+wT&)ZtZauq_~Graci&U#F|89:r_Lupvq!.)&2RlG8RfaC=x!eF{_h?rpWlmd&'!#X|&]k::xJey#`'T|+<E|&2@H|%dE#(^,g;u.RiEg6vjRiC9xCkA{O|zY#g=ucRmXKs0@!&*@G|m@awRknJuh!,3d(}gY}eJvj!%Rm):Jw3!%Rm+Rm-Ls0w(&!a(a#@b[|6cZ#X'7RkxWgAOu4ARn'dH'U#Y*Vz-Wm'CARm}d]*#a%^a*T'aK!a<9bV{PC=p*Jw4!&SgxcbB5r]idw(wBRmF7xFkt#&`(Rm/Rm8E|!JuY_9:Rl5=wrgr2:bbxd@xXfB(a*#T+!.X0X1Ta/a'T&RlDRfL>RlyARl9b[z[>RfZ:RlL:RfRwlg/ARl;9;RlxKv,A/!%7s69<74=BA5ba{-8Bde#`a<XaKYa1,a'P~=wxfB2bZ}}?C972@@=I}r8@55B9;5bb}G978B2@@=aybb}3j3vLv;<Jw3&!>Rfk=ayb^}4~Ad1#`*@@=aybb{w2@>==<bbz]dx+UY#^UaF!a9!bB'Ya1.!ajXa#%olRhD[y=3Dt#Ov5BrHKuMB%!(Rf^Wep~HrJwkiQjKr|~FRg)Ku+D#'!t5~GrF~?rDdV)UY,Z/_7RkuG{<~BrBg,rlsO:235B@bX}|d?a1!#`(6Vyn5@d##Y+jTv|vV~EfIj]uNpn~FRfH7Lq2vb1!a9-978BaU@@=Iz9978BbU}#~AJq0!(@@=Iz8978BaU@@=Iz7~AJQ|}!978BbU}!JvkaK!AdUa21-U#`a+(g/vsRn~Ou!5RPj:rmu9WhOjXuvvNr}:RhAj^v(pyw8unRn[kPr}p|u7vwv]RiSBd;pppzq@qHQa?(b.!a.a`@.|xa(hFv;Wiyj5uuv-7Riw~Cw`fg2WlU978BbU|wOuNBJqG!(P~EfD~CRlQcZ#X,k)u3vWs@u2]ksg;wEx'f@q1_2Wg.j]uNpn~FRfqJv]!15x'h{qG!(@@=IzK~CRl^j6v(us5x4i,#T(2WmY?C2F{1>Kq<aj1!*jTqIsBv=Wld~Cw`fj2Wl[j`v0u*~>RlT=c>Z,k#u3vWs@u2]kq<c1Z+jTqIsBv=Wle~Cw`fn2Wl]dn1#c(a(b^a2!b/bAT(bj!aDa7bu,a_a{c0!2T0g:v>ReD2@G{42@G{5~DpM~<5rc=Bx6i>{RT#RnI@zCx]y]z:2Jv[!zr5Awyk]9]k]dD(Y+X#6Vz.g=wKtgwhaCwgmTWj2Lu,w%_+/[y-B;b^xeg3u3Rj-2@bX{*KrJ<!+'@Wg(g?QRlC@Jv`!%b[zIwsfII}8JQ_@w|kW|=Jv(%!AqcOuNBJvEzh!bYzjLs@wP#(0!oy@>RkdJwMZtc3Dtd@BcG#T'9bWxg2@2Fznd*#Y+;2x'c}w<zizixNgwa#Z'U+!/!a'!a+w~g~z6wcn{Rn}wcnzRn|5Rh%=]nJg5vuRmvNvdRlvcprJu}w*az*a#!%.a.'Bot9qT]kj@Wg'ay2Gzv@Jv`!%b[zEwsfHI}1;ck#Ux`<Cbbx_Lu+w!a&0*!wko*wwo,So,}6Juqxf!E}PigQuyRm`d3(`#8>Rn%:A5B;bZ~%KvhCa!a2!x>k7#Uxb@b{#xaRk7Jw0!)>wwhlShl}6>wwhmShm}6CJvB!.x'hhvj{!!5Bwkhhbaz}x'hivjz~!5Bwkhibaz|xEhTrNu,v-vpD!a%&/)a3a.,%Ro2t[CE{)@3re9b]{%wjo09:rgc:Z&Ro6=<riifuaw&RmoKrNA!%(Ro4>Ro89;Ri`dSaL'UYzxZb)7Rka3xRhT&!,!#^1U}vbaz{>>@=be}yC@:D5bazzKu+A&!}{?ba}y>>@=be}wxBh[t`u~vJvr!%a!a()a,a0a4RoC=]o;Ju(!%RoGRhdwjh`=]oAg>w#Ro?g5vuRo=NvdRl|Ku]C.!&;RoEJvB!%RoORoMBx'h[v+_?w~h`}~5?w~hd~!xKh]oiptu-utv.vp!#%&a30a@a'a+(a/aOp(o~p!RoDJu(!%RoHRhewjha=]oBNvdRl}g>w#Ro@g5vuRo>c[#X']o<CauRoRAd-#Y':RkpauRoQKu]C.!&;RoFJvB!%RoNRoPBx'h]v+_?w~ha}t5?w~he}ue!/UbhYacXaW^Tc&a;b:a-c/#b&aja1(!cL+!bKbt!bmcRc9aIc?8[yW3Dtt94Rg`Jv}!&SiRMzBhEebShEMNuPRe>x7gL#TzuwjirRipc<Z&>on;>z=h-MSh.Mwqczx'a7vj&!>Re4@=ResJt__NuPRi*NuPRi)j]uNr|~FRfzKrJ>_+@Wfy@Wf]2WocKrJ<!+'@Wg%g/QRl@@Jv`!&awRl<wsfFIzgLu(w*!.*&ShBMwvhIRhI9;RhNx1hK'!#Sn]Mx1hK~0!#:2<H~7cNu+w7D*'1ZtW>Rn1~?rOc:Z&Rn2=<rQ<7wjh&=BSnLMc]#X(6Vz)w[b=a!U#9wzgMc3#&(RgMRitRis<x,gKt`ax!&+SioM=BSilMc3#&(RgKRinRimKurB,!&SiQMzBhDebShDM6BJQ!(P~Efx978B2@@=I}WLrJw!!,a*&@G}O@9wkibRid@@x'fKwC!&SlDMSfLMjUv~Q~EfKKv3@a+!(hFv-]mpx/hYZ(C5RiWz<o/MwkhY?So/M@x,gbvfB*&!SgEM:SoeeehFu3:Rgbda(,^TZa)X/7Sg[eb:2RgI~BrMC@wgkc:wwkcRerx3h(uUvK!&*,SnOM4Sh*MArRg;wHRh(x=h;rJvPwI!a4',a'0@Wg&=BSh/Mg>w=Rh=g3w*wwgGRgGcW(X#;Sg}M2Gzk@Jv`!&awRl=wsfGIz`dKZ*T'Y-:RhR7RhQg5u-p`j6v(us5d,#Y+~Awkia?RicOuNBwkibba}Ld6p~tyu_vbAa'a+!a/'a3aEa8a!>Sh,ebJv{!&Sh@ebSaReb9;SgwebNuPRi(NvdRl)NuPRi'hHu^<Rm^Jvv_@Wl(g;u1Si/ebKu'B&!*Sh?eb@Wl'z@aPeb95Si.ebcpputyvjB)!,&a+0a%ShAMWeK@G}C@WfJ9;RhMwvhH9w{ia}ix,hJvRA1(!zAn[MRhHx1hJ~*!#hFv(BSn[MBJQ!(@@=I~'978B2@@=I}2db.Ua<'X}+T#a0XaG2G}E;wkg|wuh!Rh!x,hZu,@)!&So0MVy)C5RiXACJvB!&5RiY5RiZg8w)cG}*T#2@bU}=KsA>(!a.3wkhZba~(x,h^u(A!&(SoCMRhb5Bz=h[eb?w~hb~6x,h_u(A!&(SoDMRhc5Bz=h]eb?w~hc~6e)aA1T#T,^^^c-bMb&blcPaP(a/!0!bA=b5c@a(!bfbrc#2afwmhARnjwchORnp2Wlf3DtsNvdRl-2@wpa<]m0bx(#:awRk2@Jw3!%RfhwpfgRlnKQB%!(G{V@G|'NuuRl6d='T+Y#VyUg<v~Rl~==G|<Jv+'!aYShC}6@B<5?ba~8@Jw3'!g2QRljhLrpWlOd+#Y'g.w'rIg>w*wgj@g-u0Rj@Lu+wT&)ZtUauq]~GrGci&U#F|39:rELrNvj!.%*RhCwunfw~nf~:9;Ri]>wtnhg;wHRnhx3hDs@v~!/+'@Wfr@9RkSNu&Rlo=@<5GzoKs0@_+@Wl+@awRkmJuh!-3d(}pY#qWJvj!%Rm(:Jw3!%Rm,Rm*de&!1U-U#`)Re;@G|.@9Ri82@wjfvRlq=@<5GzpLvOvr!).&2RlF8Rf`C=x!eE{.Jw3_g2QRlkhLrpWlPde(!#U{s,UXa*Ta'[y'g:v>ReS;x0PZ&RnlRnn~HrKJw1}f!=x!eB|2w]aP(#Xa&a*Ta.Ua2a7=]iOd'#Y&Ro&WnWg;u.RiDg6vjRiBNvdRlzhNvj]nYJuW_2Wm3x)kFze{9d])!a.!,Y01!#&aC!a3RndC=ox~BrC@2b^{pg,rlse7x'ksuq!%Rm.E{xidw(wBRmGx9o+)X#wwo-So-}69:Rl4@xSf@a#XZ'X)X,Ta(/ARl8b[xc>RfY:RlI:RfQwlg.ARl:9;Rlwdn'#^XafaQa1X1TaHTa)@b[{zcZ#X'7RkwWg@Ou4ARn&x)kG#{,g7u/RkGdH'U#Y*Vz'Wm&CARm|bx#(A]gUbUzJj9Q~=d,#Y(56H}l978H{U7d,0#U*2>ABb_xZ978BbU{e~AJQ{g!978BbU{hxMh?ad{oUYZ.x1h?{l!#:2<H{mx3n[t{vl!,&a%3Ro(z=iS}6ARnr=Bwsn^wvn`Rnbd`*T}B0!#^X'BG{c9b]{a>>@=be}F?JvS!&BG{d7BG}(Bde#`a1X,Ya@!a'P~=wxf@2bZ}I56B2@@=aybb}08@55B9;5bb}<j3vLv;<Jw3&!>Rfg=ayb^}&OuNBKuLA!)a!P~=x#fD{f2@>==<bbzl?C972@@=Ix^d6rSu,v7w*C(0a)a6#B+a%!sQ[y?3Dt%3[xn~<5rLOu!5p@Ku+D#'!t7~GrP~?rNKvlaya7'!h+v-5qMg=t|cd,U#5AAaa5Abb{S@52B5@a[@52B5Gx[iXueu;d<#`a(!/549C;ag>23ExY5@Dah89b^~689Jv)!~2b[~1Lv'w(%*!a#bX|aPrmawRe]keu7uhv-q6rxu,q`xTo]/a5aU!bNaDXbi!b-!ao!b<bwA!#5@B932:aV2G|:d-)Y#hJrL>RhG<7@C5<H|_=Cau:5aj5@B932:bJ|ng>vIbs)#?C2F|9jPv0w.vISh-MKvUaz(.!9ABbb|[5;5<H|Eg>unwfh;9:4E|YjQsBt|vjx'hYq3!(?C2F|J:2<BaY?C2F|GOu!5x,g|p{ah!-(?C2F|c9:4E|OjXuvvNr}:Rh&i[w*t|cd+U#jJvsu)vsSn~Mkfrmu9p}u7vwv]So!McW#Xa!ax5@A5aY:5;5<H|>kJv~vYrquJu3x4ib#T)2@SmZM?C2F|Bj:rmu9@xPhI(a*a#U#`a3-5Abb|L~@:RhK9:4E|0@52B5G|#C::aY?C2F|-:2<BaY?C2F|.5Jvk!a)javYrquJu3x4ia#T)2@SmYM?C2F|HAxPhH(!a#U#`a*-5Abb|4~@:RhJ9:4E|R@52B5G|F:2<BaY?C2F|Sc^#Xa2j=Qq5CJvB!-g<v{z;hhM?C2F|Zi[vrv{z;hiM?C2F|XKsA>!a)-g<v{z;h[eb?C2F|]i[vrv{z;h]eb?C2F|^iZu.vix,hZq3ah!.(?C2F|QOu!5ShXM:2<BaY?C2F|P", 13494, 2713, 49, 25, 61), oi = /* @__PURE__ */ new Uint16Array([
  512,
  26465,
  29036,
  7,
  0,
  2,
  4,
  116,
  24638,
  116,
  24636,
  8693,
  29807,
  24610,
  621,
  1,
  0,
  0,
  3,
  112,
  24614,
  111,
  115,
  24615
]);
var se;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.FLAG13 = 8192] = "FLAG13", e[e.BRANCH_LENGTH = 8064] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE", e[e.VALUE_MASK = 8191] = "VALUE_MASK";
})(se || (se = {}));
var le;
(function(e) {
  e[e.AMP = 38] = "AMP", e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_X = 120] = "LOWER_X";
})(le || (le = {}));
const Xe = 32;
function li(e) {
  return e - le.ZERO >>> 0 <= 9;
}
function ln(e) {
  return (e | Xe) - le.LOWER_A >>> 0 <= 5;
}
function un(e) {
  return (e | Xe) - le.LOWER_A >>> 0 <= 25;
}
function cn(e) {
  return e === le.EQUALS || un(e) || li(e);
}
var oe;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(oe || (oe = {}));
var Se;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Se || (Se = {}));
class hn {
  decodeTree;
  emitCodePoint;
  errors;
  /** The current state of the decoder. */
  state = oe.EntityStart;
  /** Characters that were consumed while parsing an entity. */
  consumed = 1;
  /**
   * The result of the entity.
   *
   * For named entities: the trie index of the best legacy match so far
   * (0 = none). For numeric entities: the accumulated code point.
   */
  result = 0;
  /** The current index in the decode tree. */
  treeIndex = 0;
  /**
   * Characters consumed since the last recorded legacy match, plus one.
   * Invariant at the top of the `stateNamedEntity` loop: `excess` equals
   * the number of unrecorded consumed characters + 1.
   */
  // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive (read via destructuring)
  excess = 1;
  /** The mode in which the decoder is operating. */
  decodeMode = Se.Strict;
  /** The number of characters that have been consumed in the current run. */
  // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive
  runConsumed = 0;
  constructor(t, r, a) {
    this.decodeTree = t, this.emitCodePoint = r, this.errors = a;
  }
  /**
   * Resets the instance to make it reusable.
   * @param decodeMode Entity decoding mode to use.
   */
  startEntity(t) {
    this.decodeMode = t, this.state = oe.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1, this.runConsumed = 0;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the non-streaming `decodeWithTrie`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, r) {
    switch (this.state) {
      case oe.EntityStart:
        return t.charCodeAt(r) === le.NUM ? (this.state = oe.NumericStart, this.consumed += 1, this.stateNumericStart(t, r + 1)) : (this.state = oe.NamedEntity, this.stateNamedEntity(t, r));
      case oe.NumericStart:
        return this.stateNumericStart(t, r);
      case oe.NumericDecimal:
        return this.stateNumericDecimal(t, r);
      case oe.NumericHex:
        return this.stateNumericHex(t, r);
      default:
        return this.stateNamedEntity(t, r);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  // eslint-disable-next-line unicorn/consistent-class-member-order
  stateNumericStart(t, r) {
    return r >= t.length ? -1 : (t.charCodeAt(r) | Xe) === le.LOWER_X ? (this.state = oe.NumericHex, this.consumed += 1, this.stateNumericHex(t, r + 1)) : (this.state = oe.NumericDecimal, this.stateNumericDecimal(t, r));
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML
   * spec. Digit parsing matches the hex loop in `parseNumericEntity`.
   * The accumulated value is preserved for numeric validation callbacks.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, r) {
    const a = t.length;
    let { result: o } = this, { consumed: l } = this;
    for (; r < a; ) {
      const h = t.charCodeAt(r);
      if (li(h) || ln(h)) {
        const g = h <= le.NINE ? h - le.ZERO : (h | Xe) - le.LOWER_A + 10;
        o = o * 16 + g, l += 1, r += 1;
      } else
        return this.result = o, this.consumed = l, this.emitNumericEntity(h, 3);
    }
    return this.result = o, this.consumed = l, -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML
   * spec. Digit parsing matches the decimal loop in `parseNumericEntity`.
   * The accumulated value is preserved for numeric validation callbacks.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, r) {
    const a = t.length;
    let { result: o } = this, { consumed: l } = this;
    for (; r < a; ) {
      const h = t.charCodeAt(r) - le.ZERO;
      if (h >>> 0 > 9)
        return this.result = o, this.consumed = l, this.emitNumericEntity(h + le.ZERO, 2);
      o = o * 10 + h, l += 1, r += 1;
    }
    return this.result = o, this.consumed = l, -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, r) {
    if (this.consumed <= r)
      return this.errors?.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === le.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Se.Strict)
      return 0;
    return this.emitCodePoint((this.decodeTree === oi ? sn : nn)(this.result), this.consumed), this.errors && (t !== le.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Flush locally-tracked walk state back to the fields, then emit the
   * recorded legacy match or reject (cold path — at most once per
   * entity). Called after failed navigation (leaf node, branch miss, or
   * compact-run mismatch). In attribute mode, reject if no legacy was
   * recorded at the current node, if we descended past it, or if the
   * pending input character is an invalid attribute terminator.
   * @param consumed Locally-tracked consumed count.
   * @param excess Locally-tracked excess count.
   * @param char Pending input character (may be the mismatching char).
   * @param valueLength Value length at the current trie node.
   */
  flushAndEmitLegacyOrReject(t, r, a, o) {
    return this.consumed = t, this.excess = r, this.result === 0 || this.decodeMode === Se.Attribute && (o === 0 || r > 1 || cn(a)) ? 0 : this.emitNotTerminatedNamedEntity();
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, r) {
    const { decodeTree: a } = this, o = t.length, l = this.decodeMode === Se.Strict;
    let { treeIndex: h } = this, { excess: g } = this, { consumed: w } = this, d = a[h];
    for (; r < o; ) {
      for (; (d & (se.VALUE_LENGTH | se.FLAG13)) === 0 && (d & se.JUMP_TABLE) !== 0; ) {
        const i = t.charCodeAt(r), s = d & se.JUMP_TABLE, u = (d & se.BRANCH_LENGTH) >> 7;
        if (u === 0) {
          if (i !== s)
            return this.flushAndEmitLegacyOrReject(w, g, i, 0);
          h += 1;
        } else {
          const f = i - s;
          if (f >>> 0 >= u)
            return this.flushAndEmitLegacyOrReject(w, g, i, 0);
          const x = a[h + 1 + f];
          if (x === 0)
            return this.flushAndEmitLegacyOrReject(w, g, i, 0);
          h = h + u + x & 65535;
        }
        if (d = a[h], r += 1, g += 1, r >= o)
          break;
      }
      if (r >= o)
        break;
      if ((d & (se.VALUE_LENGTH | se.FLAG13)) === se.FLAG13) {
        const i = (d & se.BRANCH_LENGTH) >> 7;
        let { runConsumed: s } = this;
        if (s === 0) {
          const u = t.charCodeAt(r);
          if (u !== (d & se.JUMP_TABLE))
            return this.flushAndEmitLegacyOrReject(w, g, u, 0);
          r += 1, g += 1, s = 1;
        }
        for (; s < i; ) {
          if (r >= o)
            return this.treeIndex = h, this.excess = g, this.consumed = w, this.runConsumed = s, -1;
          const u = s - 1, x = a[h + 1 + (u >> 1)] >> ((u & 1) << 3) & 255, b = t.charCodeAt(r);
          if (b !== x)
            return this.runConsumed = 0, this.flushAndEmitLegacyOrReject(w, g, b, 0);
          r += 1, g += 1, s += 1;
        }
        this.runConsumed = 0, h += 1 + (i >> 1), d = a[h];
        continue;
      }
      const v = d >>> 14, c = t.charCodeAt(r);
      if (v !== 0) {
        if (!l && (d & se.FLAG13) === 0 && (this.result = h, w += g - 1, g = 1), c === le.SEMI)
          return this.emitNamedEntityData(h, v, w + g);
        if (v === 1)
          return this.flushAndEmitLegacyOrReject(w, g, c, v);
      }
      const n = fn(a, d, h + (v || 1), c);
      if (n < 0)
        return this.flushAndEmitLegacyOrReject(w, g, c, v);
      h = n, d = a[h], r += 1, g += 1;
    }
    return !l && d >>> 14 && (d & se.FLAG13) === 0 && (this.result = h, w += g - 1, g = 1), this.treeIndex = h, this.excess = g, this.consumed = w, -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    const { result: t, decodeTree: r } = this, a = r[t] >>> 14;
    return this.emitNamedEntityData(t, a, this.consumed), this.errors?.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   * @param result The index of the entity in the decode tree.
   * @param valueLength Encoded value length (header plus any value words).
   * @param consumed The number of characters consumed.
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, r, a) {
    const { decodeTree: o } = this;
    return this.emitCodePoint(r === 1 ? o[t] & se.VALUE_MASK : o[t + 1], a), r === 3 && this.emitCodePoint(o[t + 2], a), a;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   * @returns The number of characters consumed.
   */
  end() {
    switch (this.state) {
      case oe.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Se.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case oe.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case oe.NumericHex:
        return this.emitNumericEntity(0, 3);
      case oe.NumericStart:
        return this.errors?.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      default:
        return 0;
    }
  }
}
function fn(e, t, r, a) {
  const o = (t & se.BRANCH_LENGTH) >> 7, l = t & se.JUMP_TABLE;
  if (l) {
    if (o === 0)
      return a === l ? r : -1;
    const w = a - l;
    if (w >>> 0 >= o)
      return -1;
    const d = e[r + w];
    return d === 0 ? -1 : r + o + d - 1 & 65535;
  }
  if (o === 0)
    return -1;
  const h = o + 1 >> 1, g = r + h + o;
  for (let w = 0; w < o; w++) {
    const v = e[r + (w >> 1)] >> ((w & 1) << 3) & 255;
    if (v === a) {
      const c = r + h + w;
      return g + e[c] & 65535;
    }
    if (v > a)
      return -1;
  }
  return -1;
}
var _;
(function(e) {
  e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(_ || (_ = {}));
var T;
(function(e) {
  e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.DeclarationSequence = 20] = "DeclarationSequence", e[e.InSpecialComment = 21] = "InSpecialComment", e[e.InCommentLike = 22] = "InCommentLike", e[e.SpecialStartSequence = 23] = "SpecialStartSequence", e[e.InSpecialTag = 24] = "InSpecialTag", e[e.InPlainText = 25] = "InPlainText", e[e.InEntity = 26] = "InEntity";
})(T || (T = {}));
function Ce(e) {
  return e === _.Space || e === _.NewLine || e === _.Tab || e === _.FormFeed || e === _.CarriageReturn;
}
function De(e) {
  return e === _.Slash || e === _.Gt || Ce(e);
}
function dn(e) {
  return e >= _.LowerA && e <= _.LowerZ || e >= _.UpperA && e <= _.UpperZ;
}
var ye;
(function(e) {
  e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
})(ye || (ye = {}));
const F = {
  Empty: new Uint8Array(0),
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 33, 62]),
  // `--!>`
  Doctype: new Uint8Array([100, 111, 99, 116, 121, 112, 101]),
  // `doctype`
  IframeEnd: new Uint8Array([60, 47, 105, 102, 114, 97, 109, 101]),
  // `</iframe`
  NoembedEnd: new Uint8Array([
    60,
    47,
    110,
    111,
    101,
    109,
    98,
    101,
    100
  ]),
  // `</noembed`
  NoframesEnd: new Uint8Array([
    60,
    47,
    110,
    111,
    102,
    114,
    97,
    109,
    101,
    115
  ]),
  // `</noframes`
  Plaintext: new Uint8Array([
    60,
    47,
    112,
    108,
    97,
    105,
    110,
    116,
    101,
    120,
    116
  ]),
  // `</plaintext`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ]),
  // `</textarea`
  XmpEnd: new Uint8Array([60, 47, 120, 109, 112])
  // `</xmp`
}, pn = /* @__PURE__ */ new Map([
  [F.IframeEnd[2], F.IframeEnd],
  [F.NoembedEnd[2], F.NoembedEnd],
  [F.Plaintext[2], F.Plaintext],
  [F.ScriptEnd[2], F.ScriptEnd],
  [F.TitleEnd[2], F.TitleEnd],
  [F.XmpEnd[2], F.XmpEnd]
]);
class ui {
  cbs;
  /** The current state the tokenizer is in. */
  state = T.Text;
  /** The read buffer. */
  buffer = "";
  /** The beginning of the section that is currently being read. */
  sectionStart = 0;
  /** The index within the buffer that we are currently looking at. */
  index = 0;
  /** The start of the last entity. */
  entityStart = 0;
  /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
  baseState = T.Text;
  /** For special parsing behavior inside of script and style tags. */
  isSpecial = !1;
  /** Indicates whether the tokenizer has been paused. */
  running = !0;
  /** The offset of the current buffer. */
  offset = 0;
  xmlMode;
  decodeEntities;
  recognizeSelfClosing;
  entityDecoder;
  constructor({ xmlMode: t = !1, decodeEntities: r = !0, recognizeSelfClosing: a = t }, o) {
    this.cbs = o, this.xmlMode = t, this.decodeEntities = r, this.recognizeSelfClosing = a, this.entityDecoder = new hn(t ? oi : on, (l, h) => this.emitCodePoint(l, h));
  }
  reset() {
    this.state = T.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = T.Text, this.isSpecial = !1, this.currentSequence = F.Empty, this.sequenceIndex = 0, this.running = !0, this.offset = 0;
  }
  write(t) {
    this.offset += this.buffer.length, this.buffer = t, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  stateText(t) {
    t === _.Lt || !this.decodeEntities && this.fastForwardTo(_.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = T.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === _.Amp && this.startEntity();
  }
  currentSequence = F.Empty;
  sequenceIndex = 0;
  enterTagBody() {
    this.currentSequence === F.Plaintext ? (this.currentSequence = F.Empty, this.state = T.InPlainText) : this.isSpecial ? (this.state = T.InSpecialTag, this.sequenceIndex = 0) : this.state = T.Text;
  }
  /**
   * Match the opening tag name against an HTML text-only tag sequence.
   *
   * Some tags share an initial prefix (`script`/`style`, `title`/`textarea`,
   * `noembed`/`noframes`), so we may switch to an alternate sequence at the
   * first distinguishing byte.  On a successful full match we fall back to
   * the normal tag-name state; a later `>` will enter raw-text, RCDATA, or
   * plaintext mode based on `currentSequence` / `isSpecial`.
   * @param c Current character code point.
   */
  stateSpecialStartSequence(t) {
    const r = t | 32;
    if (this.sequenceIndex < this.currentSequence.length) {
      if (r === this.currentSequence[this.sequenceIndex]) {
        this.sequenceIndex++;
        return;
      }
      if (this.sequenceIndex === 3) {
        if (this.currentSequence === F.ScriptEnd && r === F.StyleEnd[3]) {
          this.currentSequence = F.StyleEnd, this.sequenceIndex = 4;
          return;
        }
        if (this.currentSequence === F.TitleEnd && r === F.TextareaEnd[3]) {
          this.currentSequence = F.TextareaEnd, this.sequenceIndex = 4;
          return;
        }
      } else if (this.sequenceIndex === 4 && this.currentSequence === F.NoembedEnd && r === F.NoframesEnd[4]) {
        this.currentSequence = F.NoframesEnd, this.sequenceIndex = 5;
        return;
      }
    } else if (De(t)) {
      this.sequenceIndex = 0, this.state = T.InTagName, this.stateInTagName(t);
      return;
    }
    this.isSpecial = !1, this.currentSequence = F.Empty, this.sequenceIndex = 0, this.state = T.InTagName, this.stateInTagName(t);
  }
  stateCDATASequence(t) {
    t === F.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === F.Cdata.length && (this.state = T.InCommentLike, this.currentSequence = F.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.xmlMode ? (this.state = T.InDeclaration, this.stateInDeclaration(t)) : (this.state = T.InSpecialComment, this.stateInSpecialComment(t)));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   * @param c Current character code point.
   * @returns Whether the character was found.
   */
  fastForwardTo(t) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === t)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Emit a comment token and return to the text state.
   * @param offset Number of characters in the end sequence that have already been matched.
   */
  emitComment(t) {
    this.cbs.oncomment(this.sectionStart, this.index, t), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = T.Text;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   * @param c Current character code point.
   */
  stateInCommentLike(t) {
    !this.xmlMode && this.currentSequence === F.CommentEnd && this.sequenceIndex <= 1 && /*
     * We're still at the very start of the comment: the only
     * characters consumed since `<!--` are the dashes that
     * advanced sequenceIndex (0 for `<!-->`, 1 for `<!--->`).
     */
    this.index === this.sectionStart + this.sequenceIndex && t === _.Gt ? this.emitComment(this.sequenceIndex) : this.currentSequence === F.CommentEnd && this.sequenceIndex === 2 && t === _.Gt ? this.emitComment(2) : this.currentSequence === F.CommentEnd && this.sequenceIndex === this.currentSequence.length - 1 && t !== _.Gt ? this.sequenceIndex = +(t === _.Dash) : t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === F.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 3), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = T.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   * @param c Current character code point.
   */
  isTagStartChar(t) {
    return this.xmlMode ? !De(t) : dn(t);
  }
  /**
   * Scan raw-text / RCDATA content for the matching end tag.
   *
   * For RCDATA tags (`<title>`, `<textarea>`) entities are decoded inline.
   * For raw-text tags (`<script>`, `<style>`, etc.) we fast-forward to `<`.
   * @param c Current character code point.
   */
  stateInSpecialTag(t) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (De(t)) {
        const r = this.index - this.currentSequence.length;
        if (this.sectionStart < r) {
          const a = this.index;
          this.index = r, this.cbs.ontext(this.sectionStart, r), this.index = a;
        }
        this.isSpecial = !1, this.sectionStart = r + 2, this.stateInClosingTagName(t);
        return;
      }
      this.sequenceIndex = 0;
    }
    (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === F.TitleEnd || this.currentSequence === F.TextareaEnd ? this.decodeEntities && t === _.Amp && this.startEntity() : this.fastForwardTo(_.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === _.Lt);
  }
  stateBeforeTagName(t) {
    if (t === _.ExclamationMark)
      this.state = T.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (t === _.Questionmark)
      this.xmlMode ? (this.state = T.InProcessingInstruction, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.state = T.InSpecialComment, this.sectionStart = this.index);
    else if (this.isTagStartChar(t)) {
      this.sectionStart = this.index;
      const r = this.xmlMode || this.cbs.isInForeignContext?.() ? void 0 : pn.get(t | 32);
      r === void 0 ? this.state = T.InTagName : (this.isSpecial = !0, this.currentSequence = r, this.sequenceIndex = 3, this.state = T.SpecialStartSequence);
    } else t === _.Slash ? this.state = T.BeforeClosingTagName : (this.state = T.Text, this.stateText(t));
  }
  stateInTagName(t) {
    De(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = T.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateBeforeClosingTagName(t) {
    Ce(t) ? this.xmlMode || (this.state = T.InSpecialComment, this.sectionStart = this.index) : t === _.Gt ? (this.state = T.Text, this.xmlMode || (this.sectionStart = this.index + 1)) : (this.state = this.isTagStartChar(t) ? T.InClosingTagName : T.InSpecialComment, this.sectionStart = this.index);
  }
  stateInClosingTagName(t) {
    De(t) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = T.AfterClosingTagName, this.stateAfterClosingTagName(t));
  }
  stateAfterClosingTagName(t) {
    (t === _.Gt || this.fastForwardTo(_.Gt)) && (this.state = T.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(t) {
    t === _.Gt ? (this.cbs.onopentagend(this.index), this.enterTagBody(), this.sectionStart = this.index + 1) : t === _.Slash ? this.state = T.InSelfClosingTag : Ce(t) || (this.state = T.InAttributeName, this.sectionStart = this.index);
  }
  /**
   * Handle `/` before `>` in an opening tag.
   *
   * In HTML mode, text-only tags ignore the self-closing flag and still enter
   * their raw-text/RCDATA/plaintext state unless self-closing tags are being
   * recognized. In XML mode, or for ordinary tags, the tokenizer returns to
   * regular text parsing after emitting the self-closing callback.
   * @param c Current character code point.
   */
  stateInSelfClosingTag(t) {
    if (t === _.Gt) {
      if (this.cbs.onselfclosingtag(this.index), this.sectionStart = this.index + 1, !this.recognizeSelfClosing) {
        this.enterTagBody();
        return;
      }
      this.state = T.Text, this.isSpecial = !1, this.currentSequence = F.Empty;
    } else Ce(t) || (this.state = T.BeforeAttributeName, this.stateBeforeAttributeName(t));
  }
  stateInAttributeName(t) {
    (t === _.Eq || De(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = T.AfterAttributeName, this.stateAfterAttributeName(t));
  }
  stateAfterAttributeName(t) {
    t === _.Eq ? this.state = T.BeforeAttributeValue : t === _.Slash || t === _.Gt ? (this.cbs.onattribend(ye.NoValue, this.sectionStart), this.sectionStart = -1, this.state = T.BeforeAttributeName, this.stateBeforeAttributeName(t)) : Ce(t) || (this.cbs.onattribend(ye.NoValue, this.sectionStart), this.state = T.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(t) {
    t === _.DoubleQuote ? (this.state = T.InAttributeValueDq, this.sectionStart = this.index + 1) : t === _.SingleQuote ? (this.state = T.InAttributeValueSq, this.sectionStart = this.index + 1) : Ce(t) || (this.sectionStart = this.index, this.state = T.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
  }
  handleInAttributeValue(t, r) {
    t === r || !this.decodeEntities && this.fastForwardTo(r) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(r === _.DoubleQuote ? ye.Double : ye.Single, this.index + 1), this.state = T.BeforeAttributeName) : this.decodeEntities && t === _.Amp && this.startEntity();
  }
  stateInAttributeValueDoubleQuotes(t) {
    this.handleInAttributeValue(t, _.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(t) {
    this.handleInAttributeValue(t, _.SingleQuote);
  }
  stateInAttributeValueNoQuotes(t) {
    Ce(t) || t === _.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(ye.Unquoted, this.index), this.state = T.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === _.Amp && this.startEntity();
  }
  /**
   * Distinguish between CDATA, declarations, HTML comments, and HTML bogus
   * comments after `<!`.
   *
   * In HTML mode, only real comments and doctypes stay on declaration paths;
   * everything else becomes a bogus comment terminated by the next `>`.
   * @param c Current character code point.
   */
  stateBeforeDeclaration(t) {
    t === _.OpeningSquareBracket ? (this.state = T.CDATASequence, this.sequenceIndex = 0) : this.xmlMode ? this.state = t === _.Dash ? T.BeforeComment : T.InDeclaration : (t | 32) === F.Doctype[0] ? (this.state = T.DeclarationSequence, this.currentSequence = F.Doctype, this.sequenceIndex = 1) : t === _.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = T.Text, this.sectionStart = this.index + 1) : t === _.Dash ? this.state = T.BeforeComment : this.state = T.InSpecialComment;
  }
  /**
   * Continue matching `doctype` after `<!d`.
   *
   * A full `doctype` match stays on the declaration path; any other name falls
   * back to an HTML bogus comment, which matches browser behavior for
   * non-doctype `<!...>` constructs.
   * @param c Current character code point.
   */
  stateDeclarationSequence(t) {
    this.sequenceIndex === this.currentSequence.length ? (this.state = T.InDeclaration, this.stateInDeclaration(t)) : (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : t === _.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = T.Text, this.sectionStart = this.index + 1) : this.state = T.InSpecialComment;
  }
  stateInDeclaration(t) {
    (t === _.Gt || this.fastForwardTo(_.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = T.Text, this.sectionStart = this.index + 1);
  }
  /**
   * XML processing instructions (`<?...?>`).
   *
   * In HTML mode `<?` is routed to `InSpecialComment` instead, so this
   * state is only reachable in XML mode.
   * @param c Current character code point.
   */
  stateInProcessingInstruction(t) {
    t === _.Questionmark ? this.sequenceIndex = 1 : t === _.Gt && this.sequenceIndex === 1 ? (this.cbs.onprocessinginstruction(this.sectionStart, this.index - 1), this.sequenceIndex = 0, this.state = T.Text, this.sectionStart = this.index + 1) : this.sequenceIndex = Number(this.fastForwardTo(_.Questionmark));
  }
  stateBeforeComment(t) {
    t === _.Dash ? (this.state = T.InCommentLike, this.currentSequence = F.CommentEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : this.xmlMode ? this.state = T.InDeclaration : t === _.Gt ? (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = T.Text, this.sectionStart = this.index + 1) : this.state = T.InSpecialComment;
  }
  stateInSpecialComment(t) {
    (t === _.Gt || this.fastForwardTo(_.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = T.Text, this.sectionStart = this.index + 1);
  }
  startEntity() {
    this.baseState = this.state, this.state = T.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? Se.Strict : this.baseState === T.Text || this.baseState === T.InSpecialTag ? Se.Legacy : Se.Attribute);
  }
  stateInEntity() {
    const t = this.index - this.offset, r = this.entityDecoder.write(this.buffer, t);
    if (r >= 0)
      this.state = this.baseState, r === 0 && (this.index -= 1);
    else {
      if (t < this.buffer.length && this.buffer.charCodeAt(t) === _.Amp) {
        this.state = this.baseState, this.index -= 1;
        return;
      }
      this.index = this.offset + this.buffer.length - 1;
    }
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === T.Text || this.state === T.InPlainText || this.state === T.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === T.InAttributeValueDq || this.state === T.InAttributeValueSq || this.state === T.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const t = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case T.Text: {
          this.stateText(t);
          break;
        }
        case T.InPlainText: {
          this.index = this.buffer.length + this.offset - 1;
          break;
        }
        case T.SpecialStartSequence: {
          this.stateSpecialStartSequence(t);
          break;
        }
        case T.InSpecialTag: {
          this.stateInSpecialTag(t);
          break;
        }
        case T.CDATASequence: {
          this.stateCDATASequence(t);
          break;
        }
        case T.DeclarationSequence: {
          this.stateDeclarationSequence(t);
          break;
        }
        case T.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(t);
          break;
        }
        case T.InAttributeName: {
          this.stateInAttributeName(t);
          break;
        }
        case T.InCommentLike: {
          this.stateInCommentLike(t);
          break;
        }
        case T.InSpecialComment: {
          this.stateInSpecialComment(t);
          break;
        }
        case T.BeforeAttributeName: {
          this.stateBeforeAttributeName(t);
          break;
        }
        case T.InTagName: {
          this.stateInTagName(t);
          break;
        }
        case T.InClosingTagName: {
          this.stateInClosingTagName(t);
          break;
        }
        case T.BeforeTagName: {
          this.stateBeforeTagName(t);
          break;
        }
        case T.AfterAttributeName: {
          this.stateAfterAttributeName(t);
          break;
        }
        case T.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(t);
          break;
        }
        case T.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(t);
          break;
        }
        case T.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(t);
          break;
        }
        case T.AfterClosingTagName: {
          this.stateAfterClosingTagName(t);
          break;
        }
        case T.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(t);
          break;
        }
        case T.InSelfClosingTag: {
          this.stateInSelfClosingTag(t);
          break;
        }
        case T.InDeclaration: {
          this.stateInDeclaration(t);
          break;
        }
        case T.BeforeDeclaration: {
          this.stateBeforeDeclaration(t);
          break;
        }
        case T.BeforeComment: {
          this.stateBeforeComment(t);
          break;
        }
        case T.InProcessingInstruction: {
          this.stateInProcessingInstruction(t);
          break;
        }
        case T.InEntity: {
          this.stateInEntity();
          break;
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === T.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
  }
  handleTrailingCommentLikeData(t) {
    if (this.state !== T.InCommentLike)
      return !1;
    if (this.currentSequence === F.CdataEnd)
      if (this.xmlMode)
        this.sectionStart < t && this.cbs.oncdata(this.sectionStart, t, 0);
      else {
        const r = this.sectionStart - F.Cdata.length - 1;
        this.cbs.oncomment(r, t, 0);
      }
    else {
      const r = this.xmlMode ? 0 : Math.min(this.sequenceIndex, F.CommentEnd.length - 1);
      this.cbs.oncomment(this.sectionStart, t, r);
    }
    return !0;
  }
  handleTrailingMarkupDeclaration(t) {
    if (this.xmlMode)
      switch (this.state) {
        case T.InSpecialComment:
        case T.BeforeComment:
        case T.CDATASequence:
        case T.DeclarationSequence:
        case T.InDeclaration:
          return this.cbs.ontext(this.sectionStart, t), !0;
        default:
          return !1;
      }
    switch (this.state) {
      case T.BeforeDeclaration:
      case T.InSpecialComment:
      case T.BeforeComment:
      case T.CDATASequence:
        return this.cbs.oncomment(this.sectionStart, t, 0), !0;
      case T.DeclarationSequence:
        return this.sequenceIndex !== F.Doctype.length && this.cbs.oncomment(this.sectionStart, t, 0), !0;
      case T.InDeclaration:
        return !0;
      default:
        return !1;
    }
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const t = this.buffer.length + this.offset;
    if (!(this.handleTrailingCommentLikeData(t) || this.handleTrailingMarkupDeclaration(t)) && !(this.sectionStart >= t))
      switch (this.state) {
        case T.InTagName:
        case T.BeforeAttributeName:
        case T.BeforeAttributeValue:
        case T.AfterAttributeName:
        case T.InAttributeName:
        case T.InAttributeValueSq:
        case T.InAttributeValueDq:
        case T.InAttributeValueNq:
        case T.InClosingTagName:
          break;
        default:
          this.cbs.ontext(this.sectionStart, t);
      }
  }
  emitCodePoint(t, r) {
    this.baseState !== T.Text && this.baseState !== T.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.onattribentity(t)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + r, this.index = this.sectionStart - 1, this.cbs.ontextentity(t, this.sectionStart));
  }
}
const { fromCodePoint: dr } = String, Oe = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), ee = /* @__PURE__ */ new Set(["p"]), Le = /* @__PURE__ */ new Set(["h1", "h2", "h3", "h4", "h5", "h6", "p"]), pr = /* @__PURE__ */ new Set(["thead", "tbody"]), gr = /* @__PURE__ */ new Set(["dd", "dt"]), mr = /* @__PURE__ */ new Set(["rt", "rp"]), gn = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["a", /* @__PURE__ */ new Set(["a"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", ee],
  ["h1", Le],
  ["h2", Le],
  ["h3", Le],
  ["h4", Le],
  ["h5", Le],
  ["h6", Le],
  ["select", Oe],
  ["input", Oe],
  ["output", Oe],
  ["button", Oe],
  ["datalist", Oe],
  ["textarea", Oe],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", gr],
  ["dt", gr],
  ["address", ee],
  ["article", ee],
  ["aside", ee],
  ["blockquote", ee],
  ["details", ee],
  ["div", ee],
  ["dl", ee],
  ["fieldset", ee],
  ["figcaption", ee],
  ["figure", ee],
  ["footer", ee],
  ["form", ee],
  ["header", ee],
  ["hr", ee],
  ["main", ee],
  ["nav", ee],
  ["ol", ee],
  ["pre", ee],
  ["section", ee],
  ["table", ee],
  ["ul", ee],
  ["rt", mr],
  ["rp", mr],
  ["tbody", pr],
  ["tfoot", pr]
]), br = "doctype", mn = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), bn = /* @__PURE__ */ new Set(["math", "svg"]), wr = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), xr = /* @__PURE__ */ new Map([
  ["altglyph", "altGlyph"],
  ["altglyphdef", "altGlyphDef"],
  ["altglyphitem", "altGlyphItem"],
  ["animatecolor", "animateColor"],
  ["animatemotion", "animateMotion"],
  ["animatetransform", "animateTransform"],
  ["clippath", "clipPath"],
  ["feblend", "feBlend"],
  ["fecolormatrix", "feColorMatrix"],
  ["fecomponenttransfer", "feComponentTransfer"],
  ["fecomposite", "feComposite"],
  ["feconvolvematrix", "feConvolveMatrix"],
  ["fediffuselighting", "feDiffuseLighting"],
  ["fedisplacementmap", "feDisplacementMap"],
  ["fedistantlight", "feDistantLight"],
  ["fedropshadow", "feDropShadow"],
  ["feflood", "feFlood"],
  ["fefunca", "feFuncA"],
  ["fefuncb", "feFuncB"],
  ["fefuncg", "feFuncG"],
  ["fefuncr", "feFuncR"],
  ["fegaussianblur", "feGaussianBlur"],
  ["feimage", "feImage"],
  ["femerge", "feMerge"],
  ["femergenode", "feMergeNode"],
  ["femorphology", "feMorphology"],
  ["feoffset", "feOffset"],
  ["fepointlight", "fePointLight"],
  ["fespecularlighting", "feSpecularLighting"],
  ["fespotlight", "feSpotLight"],
  ["fetile", "feTile"],
  ["feturbulence", "feTurbulence"],
  ["foreignobject", "foreignObject"],
  ["glyphref", "glyphRef"],
  ["lineargradient", "linearGradient"],
  ["radialgradient", "radialGradient"],
  ["textpath", "textPath"]
]);
var Ee;
(function(e) {
  e[e.None = 0] = "None", e[e.Svg = 1] = "Svg", e[e.MathML = 2] = "MathML";
})(Ee || (Ee = {}));
const wn = /\s|\//;
class Zt {
  options;
  /** The start index of the last event. */
  startIndex = 0;
  /** The end index of the last event. */
  endIndex = 0;
  /**
   * Store the start index of the current open tag,
   * so we can update the start index for attributes.
   */
  openTagStart = 0;
  tagname = "";
  attribname = "";
  attribvalue = "";
  attribs = null;
  stack = [];
  foreignContext;
  cbs;
  lowerCaseTagNames;
  lowerCaseAttributeNames;
  recognizeSelfClosing;
  /** We are parsing HTML. Inverse of the `xmlMode` option. */
  htmlMode;
  tokenizer;
  buffers = [];
  bufferOffset = 0;
  /** The index of the last written buffer. Used when resuming after a `pause()`. */
  writeIndex = 0;
  /** Indicates whether the parser has finished running / `.end` has been called. */
  ended = !1;
  constructor(t, r = {}) {
    this.options = r, this.cbs = t ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = r.lowerCaseTags ?? this.htmlMode, this.lowerCaseAttributeNames = r.lowerCaseAttributeNames ?? this.htmlMode, this.recognizeSelfClosing = r.recognizeSelfClosing ?? !this.htmlMode, this.tokenizer = new (r.Tokenizer ?? ui)(this.options, this), this.foreignContext = [Ee.None], this.cbs.onparserinit?.(this);
  }
  // Tokenizer event handlers
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ontext(t, r) {
    const a = this.getSlice(t, r);
    this.endIndex = r - 1, this.cbs.ontext?.(a), this.startIndex = r;
  }
  /**
   * @param cp Current Unicode code point.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ontextentity(t, r) {
    this.endIndex = r - 1, this.cbs.ontext?.(dr(t)), this.startIndex = r;
  }
  /** @internal */
  isInForeignContext() {
    return this.foreignContext[0] !== Ee.None;
  }
  /**
   * Checks if the current tag is a void element. Override this if you want
   * to specify your own additional void elements.
   * @param name Name of the pseudo selector.
   */
  isVoidElement(t) {
    return this.htmlMode && mn.has(t);
  }
  /**
   * Read a tag name from the buffer.
   *
   * When `lowerCaseTagNames` is enabled (the default in HTML mode), the name
   * is lowercased and may be adjusted for SVG casing or the `image` → `img`
   * alias.
   * @param start Start index of the tag name in the buffer.
   * @param endIndex End index of the tag name in the buffer.
   */
  readTagName(t, r) {
    const a = this.lowerCaseTagNames ? this.getSlice(t, r).toLowerCase() : this.getSlice(t, r);
    if (!(this.lowerCaseTagNames && this.htmlMode))
      return a;
    if (this.foreignContext[0] === Ee.Svg)
      return xr.get(a) ?? a;
    if (this.foreignContext.length > 1) {
      const o = xr.get(a);
      if (o !== void 0 && this.stack.includes(o))
        return o;
    }
    return this.isInForeignContext() ? a : a === "image" ? "img" : a;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onopentagname(t, r) {
    this.endIndex = r, this.emitOpenTag(this.readTagName(t, r));
  }
  emitOpenTag(t) {
    if (this.openTagStart = this.startIndex, this.tagname = t, this.htmlMode && t === "form" && this.stack.includes("form")) {
      this.tagname = "";
      return;
    }
    const r = this.htmlMode && gn.get(t);
    if (r)
      for (; this.stack.length > 0 && r.has(this.stack[0]); )
        this.popElement(!0);
    this.isVoidElement(t) || (this.stack.unshift(t), this.htmlMode && (t === "svg" ? this.foreignContext.unshift(Ee.Svg) : t === "math" ? this.foreignContext.unshift(Ee.MathML) : wr.has(t) && this.foreignContext.unshift(Ee.None))), this.cbs.onopentagname?.(t), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(t) {
    this.startIndex = this.openTagStart, this.attribs && (this.cbs.onopentag?.(this.tagname, this.attribs, t), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /**
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onopentagend(t) {
    this.endIndex = t, this.endOpenTag(!1), this.startIndex = t + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onclosetag(t, r) {
    this.endIndex = r;
    const a = this.readTagName(t, r);
    if (this.isVoidElement(a))
      this.htmlMode && a === "br" && (this.cbs.onopentagname?.("br"), this.cbs.onopentag?.("br", {}, !0), this.cbs.onclosetag?.("br", !1));
    else {
      const o = this.stack.indexOf(a);
      if (o !== -1) {
        for (let l = 0; l < o; l++)
          this.popElement(!0);
        this.popElement(!1);
      } else this.htmlMode && a === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = r + 1;
  }
  /**
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onselfclosingtag(t) {
    this.endIndex = t, this.recognizeSelfClosing || this.isInForeignContext() ? (this.closeCurrentTag(!1), this.startIndex = t + 1) : this.onopentagend(t);
  }
  /**
   * Pop the top element off the stack, emit a close event, and maintain
   * the foreign context stack.
   * @param implied Whether this close is implied (not from an explicit end tag).
   */
  popElement(t) {
    const r = this.stack.shift();
    this.htmlMode && (bn.has(r) || wr.has(r)) && this.foreignContext.shift(), this.cbs.onclosetag?.(r, t);
  }
  closeCurrentTag(t) {
    const r = this.tagname;
    this.endOpenTag(t), this.stack[0] === r && this.popElement(!t);
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribname(t, r) {
    this.startIndex = t;
    const a = this.getSlice(t, r);
    this.attribname = this.lowerCaseAttributeNames ? a.toLowerCase() : a;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribdata(t, r) {
    this.attribvalue += this.getSlice(t, r);
  }
  /**
   * @param cp Current Unicode code point.
   * @internal
   */
  onattribentity(t) {
    this.attribvalue += dr(t);
  }
  /**
   * @param quote Quote type used for the current attribute.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onattribend(t, r) {
    this.endIndex = r, this.cbs.onattribute?.(this.attribname, this.attribvalue, t === ye.Double ? '"' : t === ye.Single ? "'" : t === ye.NoValue ? void 0 : null), this.attribs && !Object.hasOwn(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(t) {
    const r = t.search(wn);
    let a = r < 0 ? t : t.substr(0, r);
    return this.lowerCaseTagNames && (a = a.toLowerCase()), a;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  ondeclaration(t, r) {
    this.endIndex = r;
    const a = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const o = this.htmlMode ? this.lowerCaseTagNames ? br : a.slice(0, br.length) : this.getInstructionName(a);
      this.cbs.onprocessinginstruction(`!${o}`, `!${a}`);
    }
    this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @internal
   */
  onprocessinginstruction(t, r) {
    this.endIndex = r;
    const a = this.getSlice(t, r);
    if (this.cbs.onprocessinginstruction) {
      const o = this.getInstructionName(a);
      this.cbs.onprocessinginstruction(`?${o}`, `?${a}`);
    }
    this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @param offset Offset applied when computing parser indices.
   * @internal
   */
  oncomment(t, r, a) {
    this.endIndex = r, this.cbs.oncomment?.(this.getSlice(t, r - a)), this.cbs.oncommentend?.(), this.startIndex = r + 1;
  }
  /**
   * @param start Start index for the current parser event.
   * @param endIndex End index for the current parser event.
   * @param offset Offset applied when computing parser indices.
   * @internal
   */
  oncdata(t, r, a) {
    this.endIndex = r;
    const o = this.getSlice(t, r - a);
    !this.htmlMode || this.options.recognizeCDATA ? (this.cbs.oncdatastart?.(), this.cbs.ontext?.(o), this.cbs.oncdataend?.()) : this.isInForeignContext() ? this.cbs.ontext?.(o) : (this.cbs.oncomment?.(`[CDATA[${o}]]`), this.cbs.oncommentend?.()), this.startIndex = r + 1;
  }
  /** @internal */
  onend() {
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let t = 0; t < this.stack.length; t++)
        this.cbs.onclosetag(this.stack[t], !0);
    }
    this.cbs.onend?.();
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    this.cbs.onreset?.(), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, this.cbs.onparserinit?.(this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(Ee.None), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   * @param data Document to parse.
   */
  parseComplete(t) {
    this.reset(), this.end(t);
  }
  getSlice(t, r) {
    if (t === r)
      return "";
    for (; t - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let a = this.buffers[0].slice(t - this.bufferOffset, r - this.bufferOffset);
    for (; r - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), a += this.buffers[0].slice(0, r - this.bufferOffset);
    return a;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   * @param chunk Chunk to parse.
   */
  write(t) {
    if (this.ended) {
      this.cbs.onerror?.(new Error(".write() after done!"));
      return;
    }
    this.buffers.push(t), this.tokenizer.running && (this.tokenizer.write(t), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   * @param chunk Optional final chunk to parse.
   */
  end(t) {
    if (this.ended) {
      this.cbs.onerror?.(new Error(".end() after done!"));
      return;
    }
    t && this.write(t), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
}
var Y;
(function(e) {
  e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
})(Y || (Y = {}));
function ci(e) {
  return e.type === Y.Tag || e.type === Y.Script || e.type === Y.Style;
}
const hi = Y.Root, fi = Y.Text, di = Y.Directive, pi = Y.Comment, gi = Y.Script, mi = Y.Style, bi = Y.Tag, wi = Y.CDATA, xn = Y.Doctype, yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CDATA: wi,
  Comment: pi,
  Directive: di,
  Doctype: xn,
  get ElementType() {
    return Y;
  },
  Root: hi,
  Script: gi,
  Style: mi,
  Tag: bi,
  Text: fi,
  isTag: ci
}, Symbol.toStringTag, { value: "Module" }));
class xi {
  /** Parent of the node */
  parent = null;
  /** Previous sibling */
  prev = null;
  /** Next sibling */
  next = null;
  /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
  startIndex = null;
  /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
  endIndex = null;
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(t) {
    this.parent = t;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(t) {
    this.prev = t;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(t) {
    this.next = t;
  }
  /**
   * Clone this node, and optionally its children.
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(t = !1) {
    return Ti(this, t);
  }
}
class Xt extends xi {
  data;
  /**
   * @param data The content of the data node
   */
  constructor(t) {
    super(), this.data = t;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(t) {
    this.data = t;
  }
}
class Ht extends Xt {
  type = Y.Text;
  get nodeType() {
    return 3;
  }
}
class yi extends Xt {
  type = Y.Comment;
  get nodeType() {
    return 8;
  }
}
class vi extends Xt {
  type = Y.Directive;
  name;
  constructor(t, r) {
    super(r), this.name = t;
  }
  get nodeType() {
    return 1;
  }
  /** If this is a doctype, the document type name (parse5 only). */
  "x-name";
  /** If this is a doctype, the document type public identifier (parse5 only). */
  "x-publicId";
  /** If this is a doctype, the document type system identifier (parse5 only). */
  "x-systemId";
}
class Kt extends xi {
  children;
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(t) {
    super(), this.children = t;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    return this.children[0] ?? null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(t) {
    this.children = t;
  }
}
class Ri extends Kt {
  type = Y.CDATA;
  get nodeType() {
    return 4;
  }
}
class Yt extends Kt {
  type = Y.Root;
  get nodeType() {
    return 9;
  }
}
class Si extends Kt {
  name;
  attribs;
  type;
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   * @param type Node type used for the new node instance.
   */
  constructor(t, r, a = [], o = t === "script" ? Y.Script : t === "style" ? Y.Style : Y.Tag) {
    super(a), this.name = t, this.attribs = r, this.type = o;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(t) {
    this.name = t;
  }
  get attributes() {
    return Object.keys(this.attribs).map((t) => ({
      name: t,
      value: this.attribs[t],
      namespace: this["x-attribsNamespace"]?.[t],
      prefix: this["x-attribsPrefix"]?.[t]
    }));
  }
  /** Element namespace (parse5 only). */
  namespace;
  /** Element attribute namespaces (parse5 only). */
  "x-attribsNamespace";
  /** Element attribute namespace-related prefixes (parse5 only). */
  "x-attribsPrefix";
}
function me(e) {
  return ci(e);
}
function Qt(e) {
  return e.type === Y.CDATA;
}
function Me(e) {
  return e.type === Y.Text;
}
function Ai(e) {
  return e.type === Y.Comment;
}
function vn(e) {
  return e.type === Y.Directive;
}
function Rn(e) {
  return e.type === Y.Root;
}
function Ae(e) {
  return Object.hasOwn(e, "children");
}
function Ti(e, t = !1) {
  let r;
  if (Me(e))
    r = new Ht(e.data);
  else if (Ai(e))
    r = new yi(e.data);
  else if (me(e)) {
    const a = t ? ht(e.children) : [], o = new Si(e.name, { ...e.attribs }, a);
    for (const l of a)
      l.parent = o;
    e.namespace != null && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = { ...e["x-attribsNamespace"] }), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = { ...e["x-attribsPrefix"] }), r = o;
  } else if (Qt(e)) {
    const a = t ? ht(e.children) : [], o = new Ri(a);
    for (const l of a)
      l.parent = o;
    r = o;
  } else if (Rn(e)) {
    const a = t ? ht(e.children) : [], o = new Yt(a);
    for (const l of a)
      l.parent = o;
    e["x-mode"] && (o["x-mode"] = e["x-mode"]), r = o;
  } else if (vn(e)) {
    const a = new vi(e.name, e.data);
    e["x-name"] != null && (a["x-name"] = e["x-name"], a["x-publicId"] = e["x-publicId"], a["x-systemId"] = e["x-systemId"]), r = a;
  } else
    throw new Error(`Not implemented yet: ${e.type}`);
  return r.startIndex = e.startIndex, r.endIndex = e.endIndex, e.sourceCodeLocation != null && (r.sourceCodeLocation = e.sourceCodeLocation), r;
}
function ht(e) {
  const t = e.map((r) => Ti(r, !0));
  for (let r = 1; r < t.length; r++)
    t[r].prev = t[r - 1], t[r - 1].next = t[r];
  return t;
}
const yr = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class Ke {
  /** The elements of the DOM */
  dom = [];
  /** The root element for the DOM */
  root = new Yt(this.dom);
  /** Called once parsing has completed. */
  callback;
  /** Settings for the handler. */
  options;
  /** Callback whenever a tag is closed. */
  elementCB;
  /** Indicated whether parsing has been completed. */
  done = !1;
  /** Stack of open tags. */
  tagStack = [this.root];
  /** A data node that is still being written to. */
  lastNode = null;
  /** Reference to the parser instance. Used for location information. */
  parser = null;
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(t, r, a) {
    typeof r == "function" && (a = r, r = yr), typeof t == "object" && (r = t, t = void 0), this.callback = t ?? null, this.options = r ?? yr, this.elementCB = a ?? null;
  }
  onparserinit(t) {
    this.parser = t;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new Yt(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(t) {
    this.handleCallback(t);
  }
  onclosetag() {
    this.lastNode = null;
    const t = this.tagStack.pop();
    this.options.withEndIndices && this.parser && (t.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(t);
  }
  onopentag(t, r) {
    const a = this.options.xmlMode ? Y.Tag : void 0, o = new Si(t, r, void 0, a);
    this.addNode(o), this.tagStack.push(o);
  }
  ontext(t) {
    const { lastNode: r } = this;
    if (r && r.type === Y.Text)
      r.data += t, this.options.withEndIndices && this.parser && (r.endIndex = this.parser.endIndex);
    else {
      const a = new Ht(t);
      this.addNode(a), this.lastNode = a;
    }
  }
  oncomment(t) {
    if (this.lastNode && this.lastNode.type === Y.Comment) {
      this.lastNode.data += t;
      return;
    }
    const r = new yi(t);
    this.addNode(r), this.lastNode = r;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const t = new Ht(""), r = new Ri([t]);
    this.addNode(r), t.parent = r, this.lastNode = t;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(t, r) {
    const a = new vi(t, r);
    this.addNode(a);
  }
  handleCallback(t) {
    if (typeof this.callback == "function")
      this.callback(t, this.dom);
    else if (t)
      throw t;
  }
  addNode(t) {
    const r = this.tagStack[this.tagStack.length - 1], a = r.children[r.children.length - 1];
    this.options.withStartIndices && this.parser && (t.startIndex = this.parser.startIndex), this.options.withEndIndices && this.parser && (t.endIndex = this.parser.endIndex), r.children.push(t), a && (t.prev = a, a.next = t), t.parent = r, this.lastNode = null;
  }
}
function Je(e, t, r = !0, a = Number.POSITIVE_INFINITY) {
  return Ei(e, Array.isArray(t) ? t : [t], r, a);
}
function Ei(e, t, r, a) {
  const o = [], l = [Array.isArray(t) ? t : [t]], h = [0];
  for (; ; ) {
    if (h[0] >= l[0].length) {
      if (h.length === 1)
        return o;
      l.shift(), h.shift();
      continue;
    }
    const g = l[0][h[0]++];
    if (e(g) && (o.push(g), --a <= 0))
      return o;
    r && Ae(g) && g.children.length > 0 && (h.unshift(0), l.unshift(g.children));
  }
}
function er(e, t, r = !0) {
  const a = Array.isArray(t) ? t : [t];
  for (const o of a) {
    if (me(o) && e(o))
      return o;
    if (r && Ae(o) && o.children.length > 0) {
      const l = er(e, o.children, !0);
      if (l)
        return l;
    }
  }
  return null;
}
function Ni(e, t) {
  return (Array.isArray(t) ? t : [t]).some((r) => me(r) && e(r) || Ae(r) && Ni(e, r.children));
}
function Sn(e, t) {
  const r = [], a = [Array.isArray(t) ? t : [t]], o = [0];
  for (; ; ) {
    if (o[0] >= a[0].length) {
      if (a.length === 1)
        return r;
      a.shift(), o.shift();
      continue;
    }
    const l = a[0][o[0]++];
    me(l) && e(l) && r.push(l), Ae(l) && l.children.length > 0 && (o.unshift(0), a.unshift(l.children));
  }
}
const Qe = {
  tag_name(e) {
    return typeof e == "function" ? (t) => me(t) && e(t.name) : e === "*" ? me : (t) => me(t) && t.name === e;
  },
  tag_type(e) {
    return typeof e == "function" ? (t) => e(t.type) : (t) => t.type === e;
  },
  tag_contains(e) {
    return typeof e == "function" ? (t) => Me(t) && e(t.data) : (t) => Me(t) && t.data === e;
  }
};
function tr(e, t) {
  return typeof t == "function" ? (r) => me(r) && t(r.attribs[e]) : (r) => me(r) && r.attribs[e] === t;
}
function An(e, t) {
  return (r) => e(r) || t(r);
}
function Ii(e) {
  const t = Object.keys(e).map((r) => {
    const a = e[r];
    return Object.hasOwn(Qe, r) ? Qe[r](a) : tr(r, a);
  });
  return t.length === 0 ? null : t.reduce(An);
}
function Tn(e, t) {
  const r = Ii(e);
  return r ? r(t) : !0;
}
function En(e, t, r, a = Number.POSITIVE_INFINITY) {
  const o = Ii(e);
  return o ? Je(o, t, r, a) : [];
}
function Nn(e, t, r = !0) {
  return Array.isArray(t) || (t = [t]), er(tr("id", e), t, r);
}
function je(e, t, r = !0, a = Number.POSITIVE_INFINITY) {
  return Je(Qe.tag_name(e), t, r, a);
}
function In(e, t, r = !0, a = Number.POSITIVE_INFINITY) {
  return Je(tr("class", e), t, r, a);
}
function qn(e, t, r = !0, a = Number.POSITIVE_INFINITY) {
  return Je(Qe.tag_type(e), t, r, a);
}
function qi(e) {
  return e === 34 ? "&quot;" : e === 38 ? "&amp;" : e === 39 ? "&apos;" : e === 60 ? "&lt;" : e === 62 ? "&gt;" : "&nbsp;";
}
const Cn = 1342177476, ft = /["&'<>\u0080-\uFFFF]/g;
function vr(e) {
  return e >= 128 || e >= 32 && e < 64 && (Cn >>> e & 1) === 1;
}
function Ci(e) {
  const { length: t } = e;
  let r, a = 0, o = 0;
  for (; o < t; ) {
    const l = e.charCodeAt(o);
    if (!vr(l)) {
      const g = Math.min(o + 32, t);
      let w = o + 1;
      for (; w < g && !vr(e.charCodeAt(w)); )
        w++;
      if (w < g) {
        o = w;
        continue;
      }
      if (w >= t || (ft.lastIndex = w, !ft.test(e)))
        break;
      o = ft.lastIndex - 1;
      continue;
    }
    if (r === void 0 ? r = e.substring(0, o) : a !== o && (r += e.substring(a, o)), l < 64) {
      r += qi(l), a = o += 1;
      continue;
    }
    const h = e.codePointAt(o);
    r += `&#x${h.toString(16)};`, h !== l && o++, a = o += 1;
  }
  return r === void 0 ? e : (a < t && (r += e.substr(a)), r);
}
function ki(e, t) {
  if (e.lastIndex = 0, !e.test(t))
    return t;
  let r = "", a = 0;
  do {
    const o = e.lastIndex - 1;
    a !== o && (r += t.substring(a, o));
    const l = t.charCodeAt(o);
    r += qi(l), a = o + 1;
  } while (e.test(t));
  return r + t.substring(a);
}
const kn = /["&\u{A0}]/gu;
function Dn(e) {
  return ki(kn, e);
}
const On = /[&<>\u{A0}]/gu;
function Ln(e) {
  return ki(On, e);
}
const Bn = new Map("altGlyph altGlyphDef altGlyphItem animateColor animateMotion animateTransform clipPath feBlend feColorMatrix feComponentTransfer feComposite feConvolveMatrix feDiffuseLighting feDisplacementMap feDistantLight feDropShadow feFlood feFuncA feFuncB feFuncG feFuncR feGaussianBlur feImage feMerge feMergeNode feMorphology feOffset fePointLight feSpecularLighting feSpotLight feTile feTurbulence foreignObject glyphRef linearGradient radialGradient textPath".split(" ").map((e) => [e.toLowerCase(), e])), Mn = new Map("definitionURL attributeName attributeType baseFrequency baseProfile calcMode clipPathUnits diffuseConstant edgeMode filterUnits glyphRef gradientTransform gradientUnits kernelMatrix kernelUnitLength keyPoints keySplines keyTimes lengthAdjust limitingConeAngle markerHeight markerUnits markerWidth maskContentUnits maskUnits numOctaves pathLength patternContentUnits patternTransform patternUnits pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits refX refY repeatCount repeatDur requiredExtensions requiredFeatures specularConstant specularExponent spreadMethod startOffset stdDeviation stitchTiles surfaceScale systemLanguage tableValues targetX targetY textLength viewBox viewTarget xChannelSelector yChannelSelector zoomAndPan".split(" ").map((e) => [e.toLowerCase(), e])), Pn = new Set("style script xmp iframe noembed noframes plaintext noscript".split(" ")), Un = new Set("area base basefont br col command embed frame hr img input isindex keygen link meta param source track wbr".split(" ")), jn = /* @__PURE__ */ new Set(["svg", "math"]), _n = new Set("mi mo mn ms mtext annotation-xml foreignObject desc title".split(" "));
function Jn(e, t = {}) {
  const r = "length" in e ? e : [e], a = t.xmlMode ?? !1;
  let o = "";
  for (let l = 0; l < r.length; l++)
    o += Oi(r[l], t, a);
  return o;
}
function Di(e, t, r) {
  let a = "";
  for (let o = 0; o < e.length; o++)
    a += Oi(e[o], t, r);
  return a;
}
function Oi(e, t, r) {
  switch (e.type) {
    case hi:
      return Di(e.children, t, r);
    case di:
      return `<${e.data}>`;
    case pi:
      return `<!--${e.data}-->`;
    case wi:
      return `<![CDATA[${e.children[0].data}]]>`;
    case gi:
    case mi:
    case bi:
      return zn(e, t, r);
    case fi: {
      const a = e, o = a.data || "";
      return (t.encodeEntities ?? t.decodeEntities) !== !1 && !(!r && a.parent && Pn.has(a.parent.name)) ? r || t.encodeEntities !== "utf8" ? Ci(o) : Ln(o) : o;
    }
  }
}
function zn(e, t, r) {
  r === "foreign" && (e.name = Bn.get(e.name) ?? e.name, e.parent && _n.has(e.parent.name) && (r = !1)), !r && jn.has(e.name) && (r = "foreign");
  const { name: a, children: o } = e, l = !r && Un.has(a);
  let h = `<${a}${Vn(e.attribs, t, r)}`;
  return o.length === 0 && (r ? t.selfClosingTags !== !1 : t.selfClosingTags && l) ? h += r ? "/>" : " />" : (h += ">", o.length > 0 && (h += Di(o, t, r)), l || (h += `</${a}>`)), h;
}
function Fn(e) {
  return e.replaceAll('"', "&quot;");
}
function Vn(e, t, r) {
  if (!e)
    return "";
  const a = (t.encodeEntities ?? t.decodeEntities) === !1 ? Fn : r || t.encodeEntities !== "utf8" ? Ci : Dn, o = r === "foreign", l = !!(t.emptyAttrs ?? r);
  let h = "";
  for (const g in e) {
    if (!Object.hasOwn(e, g))
      continue;
    const w = e[g], d = o ? Mn.get(g) ?? g : g;
    h += !l && (w == null || w === "") ? ` ${d}` : ` ${d}="${a(w == null ? "" : String(w))}"`;
  }
  return h;
}
function Li(e, t) {
  return Jn(e, t);
}
function Wn(e, t) {
  return Ae(e) ? e.children.map((r) => Li(r, t)).join("") : "";
}
function Ye(e) {
  return Array.isArray(e) ? e.map(Ye).join("") : me(e) ? e.name === "br" ? `
` : Ye(e.children) : Qt(e) ? Ye(e.children) : Me(e) ? e.data : "";
}
function et(e) {
  return Array.isArray(e) ? e.map(et).join("") : Ae(e) && !Ai(e) ? et(e.children) : Me(e) ? e.data : "";
}
function $t(e) {
  return Array.isArray(e) ? e.map($t).join("") : Ae(e) && (e.type === Y.Tag || Qt(e)) ? $t(e.children) : Me(e) ? e.data : "";
}
function rr(e) {
  const t = tt(Zn, e);
  return t ? t.name === "feed" ? Gn(t) : Hn(t) : null;
}
function Gn(e) {
  const t = e.children, r = {
    type: "atom",
    items: je("entry", t).map((l) => {
      const { children: h } = l, g = { media: Bi(h) };
      he(g, "id", "id", h), he(g, "title", "title", h);
      const w = tt("link", h)?.attribs.href;
      w && (g.link = w);
      const d = Ne("summary", h) || Ne("content", h);
      d && (g.description = d);
      const v = Ne("updated", h);
      return v && (g.pubDate = new Date(v)), g;
    })
  };
  he(r, "id", "id", t), he(r, "title", "title", t);
  const a = tt("link", t)?.attribs.href;
  a && (r.link = a), he(r, "description", "subtitle", t);
  const o = Ne("updated", t);
  return o && (r.updated = new Date(o)), he(r, "author", "email", t, !0), r;
}
function Hn(e) {
  const t = tt("channel", e.children)?.children ?? [], r = {
    type: e.name.substr(0, 3),
    id: "",
    items: je("item", e.children).map((o) => {
      const { children: l } = o, h = { media: Bi(l) };
      he(h, "id", "guid", l), he(h, "title", "title", l), he(h, "link", "link", l), he(h, "description", "description", l);
      const g = Ne("pubDate", l) || Ne("dc:date", l);
      return g && (h.pubDate = new Date(g)), h;
    })
  };
  he(r, "title", "title", t), he(r, "link", "link", t), he(r, "description", "description", t);
  const a = Ne("lastBuildDate", t);
  return a && (r.updated = new Date(a)), he(r, "author", "managingEditor", t, !0), r;
}
const Yn = ["url", "type", "lang"], $n = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function Bi(e) {
  return je("media:content", e).map((t) => {
    const { attribs: r } = t, a = {
      medium: r.medium,
      isDefault: !!r.isDefault
    };
    for (const o of Yn)
      r[o] && (a[o] = r[o]);
    for (const o of $n)
      r[o] && (a[o] = Number.parseInt(r[o], 10));
    return r.expression && (a.expression = r.expression), a;
  });
}
function tt(e, t) {
  return je(e, t, !0, 1)[0];
}
function Ne(e, t, r = !1) {
  return et(je(e, t, r, 1)).trim();
}
function he(e, t, r, a, o = !1) {
  const l = Ne(r, a, o);
  l && (e[t] = l);
}
function Zn(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
function Xn(e) {
  let t = e.length;
  for (; --t >= 0; ) {
    const r = e[t];
    if (t > 0 && e.lastIndexOf(r, t - 1) >= 0) {
      e.splice(t, 1);
      continue;
    }
    for (let a = r.parent; a; a = a.parent)
      if (e.includes(a)) {
        e.splice(t, 1);
        break;
      }
  }
  return e;
}
var ge;
(function(e) {
  e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
})(ge || (ge = {}));
function Mi(e, t) {
  const r = [], a = [];
  if (e === t)
    return 0;
  let o = Ae(e) ? e : e.parent;
  for (; o; )
    r.unshift(o), o = o.parent;
  for (o = Ae(t) ? t : t.parent; o; )
    a.unshift(o), o = o.parent;
  const l = Math.min(r.length, a.length);
  let h = 0;
  for (; h < l && r[h] === a[h]; )
    h++;
  if (h === 0)
    return ge.DISCONNECTED;
  const g = r[h - 1], w = g.children, d = r[h], v = a[h];
  return w.indexOf(d) > w.indexOf(v) ? g === t ? ge.FOLLOWING | ge.CONTAINED_BY : ge.FOLLOWING : g === e ? ge.PRECEDING | ge.CONTAINS : ge.PRECEDING;
}
function Kn(e) {
  return e = e.filter((t, r, a) => !a.includes(t, r + 1)), e.sort((t, r) => {
    const a = Mi(t, r);
    return a & ge.PRECEDING ? -1 : a & ge.FOLLOWING ? 1 : 0;
  }), e;
}
function ze(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    const t = e.parent.children, r = t.lastIndexOf(e);
    r !== -1 && t.splice(r, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
function Qn(e, t) {
  if (t.prev = e.prev, t.prev && (t.prev.next = t), t.next = e.next, t.next && (t.next.prev = t), t.parent = e.parent, t.parent) {
    const { children: r } = t.parent, a = r.lastIndexOf(e);
    if (a === -1)
      return;
    r[a] = t, e.parent = null;
  }
}
function es(e, t) {
  if (ze(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    const r = e.children[e.children.length - 2];
    r.next = t, t.prev = r;
  } else
    t.prev = null;
}
function ts(e, t) {
  ze(t);
  const { parent: r } = e, a = e.next;
  if (t.next = a, t.prev = e, e.next = t, t.parent = r, a) {
    if (a.prev = t, r) {
      const o = r.children;
      o.splice(o.lastIndexOf(a), 0, t);
    }
  } else r && r.children.push(t);
}
function rs(e, t) {
  if (ze(t), t.parent = e, t.prev = null, e.children.unshift(t) === 1)
    t.next = null;
  else {
    const r = e.children[1];
    r.prev = t, t.next = r;
  }
}
function is(e, t) {
  ze(t);
  const { parent: r } = e;
  if (r) {
    const a = r.children;
    a.splice(a.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
}
function Pi(e) {
  return Ae(e) ? e.children : [];
}
function Ui(e) {
  return e.parent || null;
}
function ns(e) {
  const t = Ui(e);
  if (t != null)
    return Pi(t);
  const r = [e];
  let { prev: a, next: o } = e;
  for (; a != null; )
    r.unshift(a), { prev: a } = a;
  for (; o != null; )
    r.push(o), { next: o } = o;
  return r;
}
function ss(e, t) {
  const { attribs: r } = e;
  return r?.[t];
}
function as(e, t) {
  const { attribs: r } = e;
  return r != null && Object.hasOwn(r, t) && r[t] != null;
}
function os(e) {
  return e.name;
}
function ls(e) {
  let { next: t } = e;
  for (; t !== null && !me(t); )
    ({ next: t } = t);
  return t;
}
function us(e) {
  let { prev: t } = e;
  for (; t !== null && !me(t); )
    ({ prev: t } = t);
  return t;
}
const cs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DocumentPosition() {
    return ge;
  },
  append: ts,
  appendChild: es,
  compareDocumentPosition: Mi,
  existsOne: Ni,
  filter: Je,
  find: Ei,
  findAll: Sn,
  findOne: er,
  getAttributeValue: ss,
  getChildren: Pi,
  getElementById: Nn,
  getElements: En,
  getElementsByClassName: In,
  getElementsByTagName: je,
  getElementsByTagType: qn,
  getFeed: rr,
  getInnerHTML: Wn,
  getName: os,
  getOuterHTML: Li,
  getParent: Ui,
  getSiblings: ns,
  getText: Ye,
  hasAttrib: as,
  innerText: $t,
  nextElementSibling: ls,
  prepend: is,
  prependChild: rs,
  prevElementSibling: us,
  removeElement: ze,
  removeSubsets: Xn,
  replaceElement: Qn,
  testElement: Tn,
  textContent: et,
  uniqueSort: Kn
}, Symbol.toStringTag, { value: "Module" }));
function ji(e, t) {
  const r = new Ke(void 0, t);
  return new Zt(r, t).end(e), r.root;
}
function hs(e, t, r) {
  const a = new Ke((o) => e(o, a.root), t, r);
  return new Zt(a, t);
}
const fs = { xmlMode: !0 };
function ds(e, t = fs) {
  return rr(ji(e, t).children);
}
const ps = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultHandler: Ke,
  DomHandler: Ke,
  DomUtils: cs,
  ElementType: yn,
  Parser: Zt,
  get QuoteType() {
    return ye;
  },
  Tokenizer: ui,
  createDocumentStream: hs,
  getFeed: rr,
  parseDocument: ji,
  parseFeed: ds
}, Symbol.toStringTag, { value: "Module" })), gs = /* @__PURE__ */ si(ps);
var dt, Rr;
function ms() {
  return Rr || (Rr = 1, dt = (e) => {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), dt;
}
var pt = {}, Sr;
function bs() {
  if (Sr) return pt;
  Sr = 1;
  function e(r) {
    return Object.prototype.toString.call(r) === "[object Object]";
  }
  function t(r) {
    var a, o;
    return e(r) === !1 ? !1 : (a = r.constructor, a === void 0 ? !0 : (o = a.prototype, !(e(o) === !1 || o.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return pt.isPlainObject = t, pt;
}
var gt, Ar;
function ws() {
  if (Ar) return gt;
  Ar = 1;
  var e = function(b) {
    return t(b) && !r(b);
  };
  function t(x) {
    return !!x && typeof x == "object";
  }
  function r(x) {
    var b = Object.prototype.toString.call(x);
    return b === "[object RegExp]" || b === "[object Date]" || l(x);
  }
  var a = typeof Symbol == "function" && Symbol.for, o = a ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
  function l(x) {
    return x.$$typeof === o;
  }
  function h(x) {
    return Array.isArray(x) ? [] : {};
  }
  function g(x, b) {
    return b.clone !== !1 && b.isMergeableObject(x) ? u(h(x), x, b) : x;
  }
  function w(x, b, y) {
    return x.concat(b).map(function(m) {
      return g(m, y);
    });
  }
  function d(x, b) {
    if (!b.customMerge)
      return u;
    var y = b.customMerge(x);
    return typeof y == "function" ? y : u;
  }
  function v(x) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(x).filter(function(b) {
      return Object.propertyIsEnumerable.call(x, b);
    }) : [];
  }
  function c(x) {
    return Object.keys(x).concat(v(x));
  }
  function n(x, b) {
    try {
      return b in x;
    } catch {
      return !1;
    }
  }
  function i(x, b) {
    return n(x, b) && !(Object.hasOwnProperty.call(x, b) && Object.propertyIsEnumerable.call(x, b));
  }
  function s(x, b, y) {
    var m = {};
    return y.isMergeableObject(x) && c(x).forEach(function(R) {
      m[R] = g(x[R], y);
    }), c(b).forEach(function(R) {
      i(x, R) || (n(x, R) && y.isMergeableObject(b[R]) ? m[R] = d(R, y)(x[R], b[R], y) : m[R] = g(b[R], y));
    }), m;
  }
  function u(x, b, y) {
    y = y || {}, y.arrayMerge = y.arrayMerge || w, y.isMergeableObject = y.isMergeableObject || e, y.cloneUnlessOtherwiseSpecified = g;
    var m = Array.isArray(b), R = Array.isArray(x), p = m === R;
    return p ? m ? y.arrayMerge(x, b, y) : s(x, b, y) : g(b, y);
  }
  u.all = function(b, y) {
    if (!Array.isArray(b))
      throw new Error("first argument should be an array");
    return b.reduce(function(m, R) {
      return u(m, R, y);
    }, {});
  };
  var f = u;
  return gt = f, gt;
}
var $e = { exports: {} }, xs = $e.exports, Tr;
function ys() {
  return Tr || (Tr = 1, (function(e) {
    (function(t, r) {
      e.exports ? e.exports = r() : t.parseSrcset = r();
    })(xs, function() {
      return function(t) {
        function r(m) {
          return m === " " || // space
          m === "	" || // horizontal tab
          m === `
` || // new line
          m === "\f" || // form feed
          m === "\r";
        }
        function a(m) {
          var R, p = m.exec(t.substring(f));
          if (p)
            return R = p[0], f += R.length, R;
        }
        for (var o = t.length, l = /^[ \t\n\r\u000c]+/, h = /^[, \t\n\r\u000c]+/, g = /^[^ \t\n\r\u000c]+/, w = /[,]+$/, d = /^\d+$/, v = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, c, n, i, s, u, f = 0, x = []; ; ) {
          if (a(h), f >= o)
            return x;
          c = a(g), n = [], c.slice(-1) === "," ? (c = c.replace(w, ""), y()) : b();
        }
        function b() {
          for (a(l), i = "", s = "in descriptor"; ; ) {
            if (u = t.charAt(f), s === "in descriptor")
              if (r(u))
                i && (n.push(i), i = "", s = "after descriptor");
              else if (u === ",") {
                f += 1, i && n.push(i), y();
                return;
              } else if (u === "(")
                i = i + u, s = "in parens";
              else if (u === "") {
                i && n.push(i), y();
                return;
              } else
                i = i + u;
            else if (s === "in parens")
              if (u === ")")
                i = i + u, s = "in descriptor";
              else if (u === "") {
                n.push(i), y();
                return;
              } else
                i = i + u;
            else if (s === "after descriptor" && !r(u))
              if (u === "") {
                y();
                return;
              } else
                s = "in descriptor", f -= 1;
            f += 1;
          }
        }
        function y() {
          var m = !1, R, p, S, C, I = {}, E, q, j, K, M;
          for (C = 0; C < n.length; C++)
            E = n[C], q = E[E.length - 1], j = E.substring(0, E.length - 1), K = parseInt(j, 10), M = parseFloat(j), d.test(j) && q === "w" ? ((R || p) && (m = !0), K === 0 ? m = !0 : R = K) : v.test(j) && q === "x" ? ((R || p || S) && (m = !0), M < 0 ? m = !0 : p = M) : d.test(j) && q === "h" ? ((S || p) && (m = !0), K === 0 ? m = !0 : S = K) : m = !0;
          m ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + E + "'.") : (I.url = c, R && (I.w = R), p && (I.d = p), S && (I.h = S), x.push(I));
        }
      };
    });
  })($e)), $e.exports;
}
var We = { exports: {} }, Er;
function vs() {
  if (Er) return We.exports;
  Er = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return We.exports = t(), We.exports.createColors = t, We.exports;
}
const Rs = {}, Ss = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rs
}, Symbol.toStringTag, { value: "Module" })), ve = /* @__PURE__ */ si(Ss);
var mt, Nr;
function ir() {
  if (Nr) return mt;
  Nr = 1;
  let e = /* @__PURE__ */ vs(), t = ve;
  class r extends Error {
    constructor(o, l, h, g, w, d) {
      super(o), this.name = "CssSyntaxError", this.reason = o, w && (this.file = w), g && (this.source = g), d && (this.plugin = d), typeof l < "u" && typeof h < "u" && (typeof l == "number" ? (this.line = l, this.column = h) : (this.line = l.line, this.column = l.column, this.endLine = h.line, this.endColumn = h.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, r);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(o) {
      if (!this.source) return "";
      let l = this.source;
      o == null && (o = e.isColorSupported);
      let h = (i) => i, g = (i) => i, w = (i) => i;
      if (o) {
        let { bold: i, gray: s, red: u } = e.createColors(!0);
        g = (f) => i(u(f)), h = (f) => s(f), t && (w = (f) => t(f));
      }
      let d = l.split(/\r?\n/), v = Math.max(this.line - 3, 0), c = Math.min(this.line + 2, d.length), n = String(c).length;
      return d.slice(v, c).map((i, s) => {
        let u = v + 1 + s, f = " " + (" " + u).slice(-n) + " | ";
        if (u === this.line) {
          if (i.length > 160) {
            let b = 20, y = Math.max(0, this.column - b), m = Math.max(
              this.column + b,
              this.endColumn + b
            ), R = i.slice(y, m), p = h(f.replace(/\d/g, " ")) + i.slice(0, Math.min(this.column - 1, b - 1)).replace(/[^\t]/g, " ");
            return g(">") + h(f) + w(R) + `
 ` + p + g("^");
          }
          let x = h(f.replace(/\d/g, " ")) + i.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return g(">") + h(f) + w(i) + `
 ` + x + g("^");
        }
        return " " + h(f) + w(i);
      }).join(`
`);
    }
    toString() {
      let o = this.showSourceCode();
      return o && (o = `

` + o + `
`), this.name + ": " + this.message + o;
    }
  }
  return mt = r, r.default = r, mt;
}
var bt, Ir;
function _i() {
  if (Ir) return bt;
  Ir = 1;
  const e = /(<)(\/?style\b)/gi, t = /(<)(!--)/g, r = /[\t\n\f\r "#'()/;[\\\]{}]/;
  function a(c) {
    return typeof c != "string" || !c.includes("<") ? c : c.replace(e, "\\3c $2").replace(t, "\\3c $2");
  }
  const o = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function l(c) {
    return c[0].toUpperCase() + c.slice(1);
  }
  function h(c, n) {
    let i = "@" + n.name, s = n.params ? c.rawValue(n, "params") : "", u = n.raws.afterName;
    return typeof u > "u" ? u = s ? " " : "" : u === "" && s && !r.test(s[0]) && (u = " "), i + u + s;
  }
  function g(c) {
    if (!c.prop.startsWith("--")) return !1;
    let n = c.raws.before;
    return typeof n > "u" || !/\S$/.test(n);
  }
  function w(c, n, i) {
    let s = i.nodes, u = s.length - 1;
    for (; u > 0 && s[u].type === "comment"; )
      u -= 1;
    let f = c.raw(i, "semicolon"), x = i.type === "document";
    for (let b = s.length - 1; b >= 0; b--) {
      let y = s[b], m = u !== b || f;
      !m && b < s.length - 1 && (y.type === "atrule" && !y.nodes || y.type === "decl" && g(y)) && (m = !0), n.push({
        document: x,
        node: y,
        semicolon: m
      });
    }
  }
  function d(c, n, i, s) {
    let u = c.raw(i, "between", "beforeOpen");
    c.builder(a(s + u) + "{", i, "start");
    let f = i.nodes && i.nodes.length, x = () => {
      let b = f ? c.raw(i, "after") : c.raw(i, "after", "emptyBody");
      b && c.builder(a(b)), c.builder("}", i, "end"), i.type === "rule" && i.raws.ownSemicolon && c.builder(a(i.raws.ownSemicolon), i, "end");
    };
    f ? (n.push(x), w(c, n, i)) : x();
  }
  class v {
    constructor(n) {
      this.builder = n;
    }
    atrule(n, i) {
      let s = h(this, n);
      if (n.nodes)
        this.block(n, s);
      else {
        let u = (n.raws.between || "") + (i ? ";" : "");
        this.builder(a(s + u), n);
      }
    }
    beforeAfter(n, i) {
      let s;
      n.type === "decl" ? s = this.raw(n, null, "beforeDecl") : n.type === "comment" ? s = this.raw(n, null, "beforeComment") : i === "before" ? s = this.raw(n, null, "beforeRule") : s = this.raw(n, null, "beforeClose");
      let u = n.parent, f = 0;
      for (; u && u.type !== "root"; )
        f += 1, u = u.parent;
      if (s.includes(`
`)) {
        let x = this.raw(n, null, "indent");
        if (x.length)
          for (let b = 0; b < f; b++) s += x;
      }
      return s;
    }
    block(n, i) {
      let s = this.raw(n, "between", "beforeOpen");
      this.builder(a(i + s) + "{", n, "start");
      let u;
      n.nodes && n.nodes.length ? (this.body(n), u = this.raw(n, "after")) : u = this.raw(n, "after", "emptyBody"), u && this.builder(a(u)), this.builder("}", n, "end");
    }
    body(n) {
      let i = v.prototype, s = ["atrule", "block", "body", "rule", "stringify"].every(
        (f) => this[f] === i[f]
      ), u = [];
      for (w(this, u, n); u.length > 0; ) {
        let f = u.pop();
        if (typeof f == "function") {
          f();
          continue;
        }
        let x = f.node, b = this.raw(x, "before");
        b && this.builder(f.document ? b : a(b)), s && x.type === "rule" ? d(this, u, x, this.rawValue(x, "selector")) : s && x.type === "atrule" && x.nodes ? d(this, u, x, h(this, x)) : this.stringify(x, f.semicolon);
      }
    }
    comment(n) {
      let i = this.raw(n, "left", "commentLeft"), s = this.raw(n, "right", "commentRight");
      this.builder(a("/*" + i + n.text + s + "*/"), n);
    }
    decl(n, i) {
      let s = n.raws, u = this.raw(n, "between", "colon"), f = n.prop + u + this.rawValue(n, "value");
      n.important && (f += s.important || " !important"), i && (f += ";"), this.builder(a(f), n);
    }
    document(n) {
      this.body(n);
    }
    raw(n, i, s) {
      let u;
      if (s || (s = i), i && (u = n.raws[i], typeof u < "u"))
        return u;
      let f = n.parent;
      if (s === "before" && (!f || f.type === "root" && f.first === n || f && f.type === "document"))
        return "";
      if (!f) return o[s];
      let x = n.root(), b = x.rawCache || (x.rawCache = {});
      if (typeof b[s] < "u")
        return b[s];
      if (s === "before" || s === "after")
        return this.beforeAfter(n, s);
      {
        let y = "raw" + l(s);
        this[y] ? u = this[y](x, n) : x.walk((m) => {
          if (u = m.raws[i], typeof u < "u") return !1;
        });
      }
      return typeof u > "u" && (u = o[s]), b[s] = u, u;
    }
    rawBeforeClose(n) {
      let i;
      return n.walk((s) => {
        if (s.nodes && s.nodes.length > 0 && typeof s.raws.after < "u")
          return i = s.raws.after, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
      }), i && (i = i.replace(/\S/g, "")), i;
    }
    rawBeforeComment(n, i) {
      let s;
      return n.walkComments((u) => {
        if (typeof u.raws.before < "u")
          return s = u.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
      }), typeof s > "u" ? s = this.raw(i, null, "beforeDecl") : s && (s = s.replace(/\S/g, "")), s;
    }
    rawBeforeDecl(n, i) {
      let s;
      return n.walkDecls((u) => {
        if (typeof u.raws.before < "u")
          return s = u.raws.before, s.includes(`
`) && (s = s.replace(/[^\n]+$/, "")), !1;
      }), typeof s > "u" ? s = this.raw(i, null, "beforeRule") : s && (s = s.replace(/\S/g, "")), s;
    }
    rawBeforeOpen(n) {
      let i;
      return n.walk((s) => {
        if (s.type !== "decl" && (i = s.raws.between, typeof i < "u"))
          return !1;
      }), i;
    }
    rawBeforeRule(n) {
      let i;
      return n.walk((s) => {
        if (s.nodes && (s.parent !== n || n.first !== s) && typeof s.raws.before < "u")
          return i = s.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
      }), i && (i = i.replace(/\S/g, "")), i;
    }
    rawColon(n) {
      let i;
      return n.walkDecls((s) => {
        if (typeof s.raws.between < "u")
          return i = s.raws.between.replace(/[^\s:]/g, ""), !1;
      }), i;
    }
    rawEmptyBody(n) {
      let i;
      return n.walk((s) => {
        if (s.nodes && s.nodes.length === 0 && (i = s.raws.after, typeof i < "u"))
          return !1;
      }), i;
    }
    rawIndent(n) {
      if (n.raws.indent) return n.raws.indent;
      let i;
      return n.walk((s) => {
        let u = s.parent;
        if (u && u !== n && u.parent && u.parent === n && typeof s.raws.before < "u") {
          let f = s.raws.before.split(`
`);
          return i = f[f.length - 1], i = i.replace(/\S/g, ""), !1;
        }
      }), i;
    }
    rawSemicolon(n) {
      let i;
      return n.walk((s) => {
        if (s.nodes && s.nodes.length && s.last.type === "decl" && (i = s.raws.semicolon, typeof i < "u"))
          return !1;
      }), i;
    }
    rawValue(n, i) {
      let s = n[i], u = n.raws[i];
      return u && u.value === s ? u.raw : s;
    }
    root(n) {
      if (n.source && n.source.input.hasBOM && this.builder("\uFEFF", n, "start"), this.body(n), n.raws.after) {
        let i = n.raws.after, s = n.parent && n.parent.type === "document";
        this.builder(s ? i : a(i));
      }
    }
    rule(n) {
      this.block(n, this.rawValue(n, "selector")), n.raws.ownSemicolon && this.builder(a(n.raws.ownSemicolon), n, "end");
    }
    stringify(n, i) {
      if (!this[n.type])
        throw new Error(
          "Unknown AST node type " + n.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[n.type](n, i);
    }
  }
  return bt = v, v.default = v, bt;
}
var wt, qr;
function nt() {
  if (qr) return wt;
  qr = 1;
  let e = _i();
  function t(r, a) {
    new e(a).stringify(r);
  }
  return wt = t, t.default = t, wt;
}
var Ge = {}, Cr;
function st() {
  return Cr || (Cr = 1, Ge.isClean = /* @__PURE__ */ Symbol("isClean"), Ge.my = /* @__PURE__ */ Symbol("my")), Ge;
}
var xt, kr;
function at() {
  if (kr) return xt;
  kr = 1;
  let e = ir(), t = _i(), r = nt(), { isClean: a, my: o } = st();
  function l(w, d) {
    let v = new w.constructor(), c = [[w, v, d]];
    for (; c.length > 0; ) {
      let [n, i, s] = c.pop();
      for (let u in n) {
        if (!Object.prototype.hasOwnProperty.call(n, u) || u === "proxyCache") continue;
        let f = n[u], x = typeof f;
        if (u === "parent" && x === "object")
          s && (i[u] = s);
        else if (u === "source")
          i[u] = f;
        else if (Array.isArray(f)) {
          let b = [];
          i[u] = b;
          for (let y of f) {
            let m = new y.constructor();
            b.push(m), c.push([y, m, i]);
          }
        } else {
          if (x === "object" && f !== null) {
            let b = new f.constructor();
            c.push([f, b, void 0]), f = b;
          }
          i[u] = f;
        }
      }
    }
    return v;
  }
  function h(w, d) {
    if (d && typeof d.offset < "u")
      return d.offset;
    let v = 1, c = 1, n = 0;
    for (let i = 0; i < w.length; i++) {
      if (c === d.line && v === d.column) {
        n = i;
        break;
      }
      w[i] === `
` ? (v = 1, c += 1) : v += 1;
    }
    return n;
  }
  class g {
    get proxyOf() {
      return this;
    }
    constructor(d = {}) {
      this.raws = {}, this[a] = !1, this[o] = !0;
      for (let v of Object.keys(d))
        if (v !== "__proto__")
          if (v === "nodes") {
            this.nodes = [];
            for (let c of d[v])
              typeof c.clone == "function" && c.parent ? this.append(c.clone()) : this.append(c);
          } else
            this[v] = d[v];
    }
    addToError(d) {
      if (d.postcssNode = this, d.stack && this.source && /\n\s{4}at /.test(d.stack)) {
        let v = this.source;
        d.stack = d.stack.replace(
          /\n\s{4}at /,
          `$&${v.input.from}:${v.start.line}:${v.start.column}$&`
        );
      }
      return d;
    }
    after(d) {
      return this.parent.insertAfter(this, d), this;
    }
    assign(d = {}) {
      for (let v in d)
        this[v] = d[v];
      return this;
    }
    before(d) {
      return this.parent.insertBefore(this, d), this;
    }
    cleanRaws(d) {
      delete this.raws.before, delete this.raws.after, d || delete this.raws.between;
    }
    clone(d = {}) {
      let v = l(this);
      for (let c in d)
        v[c] = d[c];
      return v;
    }
    cloneAfter(d = {}) {
      let v = this.clone(d);
      return this.parent.insertAfter(this, v), v;
    }
    cloneBefore(d = {}) {
      let v = this.clone(d);
      return this.parent.insertBefore(this, v), v;
    }
    error(d, v = {}) {
      if (this.source) {
        let { end: c, start: n } = this.rangeBy(v);
        return this.source.input.error(
          d,
          { column: n.column, line: n.line },
          { column: c.column, line: c.line },
          v
        );
      }
      return new e(d);
    }
    getProxyProcessor() {
      return {
        get(d, v) {
          return v === "proxyOf" ? d : v === "root" ? () => d.root().toProxy() : d[v];
        },
        set(d, v, c) {
          return d[v] === c || (d[v] = c, (v === "prop" || v === "value" || v === "name" || v === "params" || v === "important" || /* c8 ignore next */
          v === "text") && d.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[a] = !0;
    }
    markDirty() {
      if (this[a]) {
        this[a] = !1;
        let d = this;
        for (; d = d.parent; )
          d[a] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let d = this.parent.index(this);
      return this.parent.nodes[d + 1];
    }
    positionBy(d = {}) {
      let v = "document" in this.source.input ? this.source.input.document : this.source.input.css, c = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: h(v, this.source.start)
      };
      if (d.index)
        c = this.positionInside(d.index);
      else if (d.word) {
        let i = v.slice(
          h(v, this.source.start),
          h(v, this.source.end)
        ).indexOf(d.word);
        i !== -1 && (c = this.positionInside(i));
      }
      return c;
    }
    positionInside(d) {
      let v = this.source.start.column, c = this.source.start.line, n = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = h(n, this.source.start), s = i + d;
      for (let u = i; u < s; u++)
        n[u] === `
` ? (v = 1, c += 1) : v += 1;
      return { column: v, line: c, offset: s };
    }
    prev() {
      if (!this.parent) return;
      let d = this.parent.index(this);
      return this.parent.nodes[d - 1];
    }
    rangeBy(d = {}) {
      let v = "document" in this.source.input ? this.source.input.document : this.source.input.css, c = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: h(v, this.source.start)
      }, n = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          h(v, this.source.end) + 1
        )
      } : {
        column: c.column + 1,
        line: c.line,
        offset: c.offset + 1
      };
      if (d.word) {
        let s = v.slice(
          h(v, this.source.start),
          h(v, this.source.end)
        ).indexOf(d.word);
        s !== -1 && (c = this.positionInside(s), n = this.positionInside(s + d.word.length));
      } else
        d.start ? c = {
          column: d.start.column,
          line: d.start.line,
          offset: h(v, d.start)
        } : typeof d.index == "number" && (c = this.positionInside(d.index)), d.end ? n = {
          column: d.end.column,
          line: d.end.line,
          offset: h(v, d.end)
        } : typeof d.endIndex == "number" ? n = this.positionInside(d.endIndex) : typeof d.index == "number" && (n = this.positionInside(d.index + 1));
      return (n.line < c.line || n.line === c.line && n.column <= c.column) && (n = {
        column: c.column + 1,
        line: c.line,
        offset: c.offset + 1
      }), { end: n, start: c };
    }
    raw(d, v) {
      return new t().raw(this, d, v);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...d) {
      if (this.parent) {
        let v = this, c = !1;
        for (let n of d)
          n === this ? c = !0 : c ? (this.parent.insertAfter(v, n), v = n) : this.parent.insertBefore(v, n);
        c || this.remove();
      }
      return this;
    }
    root() {
      let d = this;
      for (; d.parent && d.parent.type !== "document"; )
        d = d.parent;
      return d;
    }
    toJSON(d, v) {
      let c = v == null;
      v = v || /* @__PURE__ */ new Map();
      let n = [], i = [[this, n, 0]];
      for (let u = 0; u < i.length; u++) {
        let [f, x, b] = i[u], y = {};
        x[b] = y;
        for (let m in f) {
          if (!Object.prototype.hasOwnProperty.call(f, m) || m === "parent" || m === "proxyCache") continue;
          let R = f[m];
          if (Array.isArray(R)) {
            let p = [];
            y[m] = p;
            for (let S = 0; S < R.length; S++) {
              let C = R[S];
              typeof C == "object" && C.toJSON ? C.toJSON === g.prototype.toJSON ? i.push([C, p, S]) : p[S] = C.toJSON(null, v) : p[S] = C;
            }
          } else if (typeof R == "object" && R.toJSON)
            R.toJSON === g.prototype.toJSON ? i.push([R, y, m]) : y[m] = R.toJSON(null, v);
          else if (m === "source") {
            if (R == null) continue;
            let p = v.get(R.input);
            p == null && (p = v.size, v.set(R.input, p)), y[m] = {
              end: R.end,
              inputId: p,
              start: R.start
            };
          } else
            y[m] = R;
        }
      }
      let s = n[0];
      return c && (s.inputs = [...v.keys()].map((u) => u.toJSON())), s;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(d = r) {
      d.stringify && (d = d.stringify);
      let v = "";
      return d(this, (c) => {
        v += c;
      }), v;
    }
    warn(d, v, c = {}) {
      let n = { node: this };
      for (let i in c) n[i] = c[i];
      return d.warn(v, n);
    }
  }
  return xt = g, g.default = g, xt;
}
var yt, Dr;
function ot() {
  if (Dr) return yt;
  Dr = 1;
  let e = at();
  class t extends e {
    constructor(a) {
      super(a), this.type = "comment";
    }
  }
  return yt = t, t.default = t, yt;
}
var vt, Or;
function lt() {
  if (Or) return vt;
  Or = 1;
  let e = at();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(a) {
      a && typeof a.value < "u" && typeof a.value != "string" && (a = { ...a, value: String(a.value) }), super(a), this.type = "decl";
    }
  }
  return vt = t, t.default = t, vt;
}
var Rt, Lr;
function Ie() {
  if (Lr) return Rt;
  Lr = 1;
  let e = ot(), t = lt(), r = at(), { isClean: a, my: o } = st(), l, h, g, w;
  function d(n) {
    let i = n.slice();
    for (; i.length > 0; ) {
      let s = i.pop();
      if (delete s.source, s.nodes) {
        s.nodes = s.nodes.slice();
        for (let u of s.nodes) i.push(u);
      }
    }
    return n.slice();
  }
  function v(n) {
    let i = [n];
    for (; i.length > 0; ) {
      let s = i.pop();
      if (s[a] = !1, s.proxyOf.nodes)
        for (let u of s.proxyOf.nodes) i.push(u);
    }
  }
  class c extends r {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...i) {
      for (let s of i) {
        let u = this.normalize(s, this.last);
        for (let f of u) this.proxyOf.nodes.push(f);
      }
      return this.markDirty(), this;
    }
    cleanRaws(i) {
      let s = [this];
      for (; s.length > 0; ) {
        let u = s.pop();
        if (u !== this && u.cleanRaws !== c.prototype.cleanRaws) {
          u.cleanRaws(i);
          continue;
        }
        if (r.prototype.cleanRaws.call(u, i), u.nodes)
          for (let f of u.nodes) s.push(f);
      }
    }
    each(i) {
      if (!this.proxyOf.nodes) return;
      let s = this.getIterator(), u, f;
      for (; this.indexes[s] < this.proxyOf.nodes.length && (u = this.indexes[s], f = i(this.proxyOf.nodes[u], u), f !== !1); )
        this.indexes[s] += 1;
      return delete this.indexes[s], f;
    }
    every(i) {
      return this.nodes.every(i);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let i = this.lastEach;
      return this.indexes[i] = 0, i;
    }
    getProxyProcessor() {
      return {
        get(i, s) {
          return s === "proxyOf" ? i : i[s] ? s === "each" || typeof s == "string" && s.startsWith("walk") ? (...u) => i[s](
            ...u.map((f) => typeof f == "function" ? (x, b) => f(x.toProxy(), b) : f)
          ) : s === "every" || s === "some" ? (u) => i[s](
            (f, ...x) => u(f.toProxy(), ...x)
          ) : s === "root" ? () => i.root().toProxy() : s === "nodes" ? i.nodes.map((u) => u.toProxy()) : s === "first" || s === "last" ? i[s].toProxy() : i[s] : i[s];
        },
        set(i, s, u) {
          return i[s] === u || (i[s] = u, (s === "name" || s === "params" || s === "selector") && i.markDirty()), !0;
        }
      };
    }
    index(i) {
      return typeof i == "number" ? i : (i.proxyOf && (i = i.proxyOf), this.proxyOf.nodes.indexOf(i));
    }
    insertAfter(i, s) {
      let u = this.index(i), f = this.normalize(s, this.proxyOf.nodes[u]).reverse();
      u = this.index(i);
      for (let b of f) this.proxyOf.nodes.splice(u + 1, 0, b);
      let x;
      for (let b in this.indexes)
        x = this.indexes[b], u < x && (this.indexes[b] = x + f.length);
      return this.markDirty(), this;
    }
    insertBefore(i, s) {
      let u = this.index(i), f = u === 0 ? "prepend" : !1, x = this.normalize(
        s,
        this.proxyOf.nodes[u],
        f
      ).reverse();
      u = this.index(i);
      for (let y of x) this.proxyOf.nodes.splice(u, 0, y);
      let b;
      for (let y in this.indexes)
        b = this.indexes[y], u <= b && (this.indexes[y] = b + x.length);
      return this.markDirty(), this;
    }
    normalize(i, s) {
      if (typeof i == "string")
        i = d(h(i).nodes);
      else if (typeof i > "u")
        i = [];
      else if (Array.isArray(i)) {
        i = i.slice(0);
        for (let f of i)
          f.parent && f.parent.removeChild(f, "ignore");
      } else if (i.type === "root" && this.type !== "document") {
        i = i.nodes.slice(0);
        for (let f of i)
          f.parent && f.parent.removeChild(f, "ignore");
      } else if (i.type)
        i = [i];
      else if (i.prop) {
        if (typeof i.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof i.value != "string" && (i.value = String(i.value)), i = [new t(i)];
      } else if (i.selector || i.selectors)
        i = [new w(i)];
      else if (i.name)
        i = [new l(i)];
      else if (i.text)
        i = [new e(i)];
      else
        throw new Error("Unknown node type in node creation");
      return i.map((f) => (f[o] || c.rebuild(f), f = f.proxyOf, f.parent && f.parent.removeChild(f), f[a] && v(f), f.raws || (f.raws = {}), typeof f.raws.before > "u" && s && typeof s.raws.before < "u" && (f.raws.before = s.raws.before.replace(/\S/g, "")), f.parent = this.proxyOf, f));
    }
    prepend(...i) {
      i = i.reverse();
      for (let s of i) {
        let u = this.normalize(s, this.first, "prepend").reverse();
        for (let f of u) this.proxyOf.nodes.unshift(f);
        for (let f in this.indexes)
          this.indexes[f] = this.indexes[f] + u.length;
      }
      return this.markDirty(), this;
    }
    push(i) {
      return i.parent = this, this.proxyOf.nodes.push(i), this;
    }
    removeAll() {
      for (let i of this.proxyOf.nodes) i.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(i) {
      i = this.index(i), this.proxyOf.nodes[i].parent = void 0, this.proxyOf.nodes.splice(i, 1);
      let s;
      for (let u in this.indexes)
        s = this.indexes[u], s >= i && (this.indexes[u] = s - 1);
      return this.markDirty(), this;
    }
    replaceValues(i, s, u) {
      return u || (u = s, s = {}), this.walkDecls((f) => {
        s.props && !s.props.includes(f.prop) || s.fast && !f.value.includes(s.fast) || (f.value = f.value.replace(i, u));
      }), this.markDirty(), this;
    }
    some(i) {
      return this.nodes.some(i);
    }
    walk(i) {
      if (!this.proxyOf.nodes) return;
      let s = [{ iterator: this.getIterator(), node: this.proxyOf }];
      for (; s.length > 0; ) {
        let { iterator: u, node: f } = s[s.length - 1], x = f.indexes[u];
        if (x >= f.proxyOf.nodes.length) {
          delete f.indexes[u], s.pop();
          let m = s[s.length - 1];
          m && (m.node.indexes[m.iterator] += 1);
          continue;
        }
        let b = f.proxyOf.nodes[x], y;
        try {
          y = i(b, x);
        } catch (m) {
          throw b.addToError(m);
        }
        if (y === !1) {
          for (let m of s)
            delete m.node.indexes[m.iterator];
          return !1;
        }
        b.walk && b.proxyOf.nodes ? s.push({ iterator: b.getIterator(), node: b }) : f.indexes[u] += 1;
      }
    }
    walkAtRules(i, s) {
      return s ? i instanceof RegExp ? this.walk((u, f) => {
        if (u.type === "atrule" && i.test(u.name))
          return s(u, f);
      }) : this.walk((u, f) => {
        if (u.type === "atrule" && u.name === i)
          return s(u, f);
      }) : (s = i, this.walk((u, f) => {
        if (u.type === "atrule")
          return s(u, f);
      }));
    }
    walkComments(i) {
      return this.walk((s, u) => {
        if (s.type === "comment")
          return i(s, u);
      });
    }
    walkDecls(i, s) {
      return s ? i instanceof RegExp ? this.walk((u, f) => {
        if (u.type === "decl" && i.test(u.prop))
          return s(u, f);
      }) : this.walk((u, f) => {
        if (u.type === "decl" && u.prop === i)
          return s(u, f);
      }) : (s = i, this.walk((u, f) => {
        if (u.type === "decl")
          return s(u, f);
      }));
    }
    walkRules(i, s) {
      return s ? i instanceof RegExp ? this.walk((u, f) => {
        if (u.type === "rule" && i.test(u.selector))
          return s(u, f);
      }) : this.walk((u, f) => {
        if (u.type === "rule" && u.selector === i)
          return s(u, f);
      }) : (s = i, this.walk((u, f) => {
        if (u.type === "rule")
          return s(u, f);
      }));
    }
  }
  return c.registerParse = (n) => {
    h = n;
  }, c.registerRule = (n) => {
    w = n;
  }, c.registerAtRule = (n) => {
    l = n;
  }, c.registerRoot = (n) => {
    g = n;
  }, Rt = c, c.default = c, c.rebuild = (n) => {
    let i = [n];
    for (; i.length > 0; ) {
      let s = i.pop();
      if (s.type === "atrule" ? Object.setPrototypeOf(s, l.prototype) : s.type === "rule" ? Object.setPrototypeOf(s, w.prototype) : s.type === "decl" ? Object.setPrototypeOf(s, t.prototype) : s.type === "comment" ? Object.setPrototypeOf(s, e.prototype) : s.type === "root" && Object.setPrototypeOf(s, g.prototype), s[o] = !0, s.nodes)
        for (let u of s.nodes) i.push(u);
    }
  }, Rt;
}
var St, Br;
function nr() {
  if (Br) return St;
  Br = 1;
  let e = Ie();
  class t extends e {
    constructor(a) {
      super(a), this.type = "atrule";
    }
    append(...a) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...a);
    }
    prepend(...a) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...a);
    }
  }
  return St = t, t.default = t, e.registerAtRule(t), St;
}
var At, Mr;
function sr() {
  if (Mr) return At;
  Mr = 1;
  let e = Ie(), t, r;
  class a extends e {
    constructor(l) {
      super({ type: "document", ...l }), this.nodes || (this.nodes = []);
    }
    toResult(l = {}) {
      return new t(new r(), this, l).stringify();
    }
  }
  return a.registerLazyResult = (o) => {
    t = o;
  }, a.registerProcessor = (o) => {
    r = o;
  }, At = a, a.default = a, At;
}
var Tt, Pr;
function As() {
  if (Pr) return Tt;
  Pr = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return Tt = { nanoid: (a = 21) => {
    let o = "", l = a | 0;
    for (; l-- > 0; )
      o += e[Math.random() * 64 | 0];
    return o;
  }, customAlphabet: (a, o = 21) => (l = o) => {
    let h = "", g = l | 0;
    for (; g-- > 0; )
      h += a[Math.random() * a.length | 0];
    return h;
  } }, Tt;
}
var Et, Ur;
function Ji() {
  if (Ur) return Et;
  Ur = 1;
  let { existsSync: e, readFileSync: t, realpathSync: r } = ve, { dirname: a, isAbsolute: o, join: l, relative: h, sep: g } = ve, { SourceMapConsumer: w, SourceMapGenerator: d } = ve;
  function v(i) {
    try {
      return r(i);
    } catch {
      return i;
    }
  }
  function c(i) {
    return Buffer ? Buffer.from(i, "base64").toString() : window.atob(i);
  }
  class n {
    constructor(s, u) {
      if (u.map === !1) return;
      u.unsafeMap && (this.unsafeMap = !0), this.loadAnnotation(s), this.inline = this.startWith(this.annotation, "data:");
      let f = u.map ? u.map.prev : void 0, x = this.loadMap(u.from, f);
      !this.mapFile && u.from && (this.mapFile = u.from), this.mapFile && (this.root = a(this.mapFile)), x && (this.text = x);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new w(this.json || this.text)), this.consumerCache;
    }
    decodeInline(s) {
      let u = /^data:application\/json;charset=utf-?8;base64,/, f = /^data:application\/json;base64,/, x = /^data:application\/json;charset=utf-?8,/, b = /^data:application\/json,/, y = s.match(x) || s.match(b);
      if (y)
        return decodeURIComponent(s.substr(y[0].length));
      let m = s.match(u) || s.match(f);
      if (m)
        return c(s.substr(m[0].length));
      let R = s.slice(22);
      throw R = R.slice(0, R.indexOf(",")), new Error("Unsupported source map encoding " + R);
    }
    getAnnotationURL(s) {
      return s.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(s) {
      return typeof s != "object" ? !1 : typeof s.mappings == "string" || typeof s._mappings == "string" || Array.isArray(s.sections);
    }
    loadAnnotation(s) {
      let u = s.match(/\/\*\s*# sourceMappingURL=/g);
      if (!u) return;
      let f = s.lastIndexOf(u.pop()), x = s.indexOf("*/", f);
      f > -1 && x > -1 && (this.annotation = this.getAnnotationURL(s.substring(f, x)));
    }
    loadFile(s, u, f) {
      if (!f && !this.unsafeMap) {
        if (!/\.map$/i.test(s) || !u) return;
        let x = h(v(a(u)), v(s));
        if (x === ".." || x.startsWith(".." + g) || o(x))
          return;
      }
      if (this.root = a(s), e(s))
        return this.mapFile = s, t(s, "utf-8").toString().trim();
    }
    loadMap(s, u) {
      if (u === !1) return !1;
      if (u) {
        if (typeof u == "string")
          return u;
        if (typeof u == "function") {
          let f = u(s);
          if (f) {
            let x = this.loadFile(f, s, !0);
            if (!x)
              throw new Error(
                "Unable to load previous source map: " + f.toString()
              );
            return x;
          }
        } else {
          if (u instanceof w)
            return d.fromSourceMap(u).toString();
          if (u instanceof d)
            return u.toString();
          if (this.isMap(u))
            return JSON.stringify(u);
          throw new Error(
            "Unsupported previous source map format: " + u.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let f = this.annotation;
          s && (f = l(a(s), f));
          let x = this.loadFile(f, s, !1);
          if (x)
            try {
              this.json = JSON.parse(x.replace(/^\)]}'[^\n]*\n/, ""));
            } catch {
              return;
            }
          return x;
        }
      }
    }
    startWith(s, u) {
      return s ? s.substr(0, u.length) === u : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return Et = n, n.default = n, Et;
}
var Nt, jr;
function ut() {
  if (jr) return Nt;
  jr = 1;
  let { nanoid: e } = /* @__PURE__ */ As(), { isAbsolute: t, resolve: r } = ve, { SourceMapConsumer: a, SourceMapGenerator: o } = ve, { fileURLToPath: l, pathToFileURL: h } = ve, g = ir(), w = Ji(), d = ve, v = /* @__PURE__ */ Symbol("lineToIndexCache"), c = !!(a && o), n = !!(r && t);
  function i(u) {
    if (u[v]) return u[v];
    let f = u.css.split(`
`), x = new Array(f.length), b = 0;
    for (let y = 0, m = f.length; y < m; y++)
      x[y] = b, b += f[y].length + 1;
    return u[v] = x, x;
  }
  class s {
    get from() {
      return this.file || this.id;
    }
    constructor(f, x = {}) {
      if (f === null || typeof f > "u" || typeof f == "object" && !f.toString)
        throw new Error(`PostCSS received ${f} instead of CSS string`);
      if (this.css = f.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, x.document && (this.document = x.document.toString()), x.from && (!n || /^\w+:\/\//.test(x.from) || t(x.from) ? this.file = x.from : this.file = r(x.from)), n && c) {
        let b = new w(this.css, x);
        if (b.text) {
          this.map = b;
          let y = b.consumer().file;
          !this.file && y && (this.file = this.mapResolve(y));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(f, x, b, y = {}) {
      let m, R, p, S, C;
      if (x && typeof x == "object") {
        let E = x, q = b;
        if (typeof E.offset == "number") {
          S = E.offset;
          let j = this.fromOffset(S);
          x = j.line, b = j.col;
        } else
          x = E.line, b = E.column, S = this.fromLineAndColumn(x, b);
        if (typeof q.offset == "number") {
          p = q.offset;
          let j = this.fromOffset(p);
          R = j.line, m = j.col;
        } else
          R = q.line, m = q.column, p = this.fromLineAndColumn(q.line, q.column);
      } else if (b)
        S = this.fromLineAndColumn(x, b);
      else {
        S = x;
        let E = this.fromOffset(S);
        x = E.line, b = E.col;
      }
      let I = this.origin(x, b, R, m);
      return I ? C = new g(
        f,
        I.endLine === void 0 ? I.line : { column: I.column, line: I.line },
        I.endLine === void 0 ? I.column : { column: I.endColumn, line: I.endLine },
        I.source,
        I.file,
        y.plugin
      ) : C = new g(
        f,
        R === void 0 ? x : { column: b, line: x },
        R === void 0 ? b : { column: m, line: R },
        this.css,
        this.file,
        y.plugin
      ), C.input = {
        column: b,
        endColumn: m,
        endLine: R,
        endOffset: p,
        line: x,
        offset: S,
        source: this.css
      }, this.file && (h && (C.input.url = h(this.file).toString()), C.input.file = this.file), C;
    }
    fromLineAndColumn(f, x) {
      return i(this)[f - 1] + x - 1;
    }
    fromOffset(f) {
      let x = i(this), b = x[x.length - 1], y = 0;
      if (f >= b)
        y = x.length - 1;
      else {
        let m = x.length - 2, R;
        for (; y < m; )
          if (R = y + (m - y >> 1), f < x[R])
            m = R - 1;
          else if (f >= x[R + 1])
            y = R + 1;
          else {
            y = R;
            break;
          }
      }
      return {
        col: f - x[y] + 1,
        line: y + 1
      };
    }
    mapResolve(f) {
      return /^\w+:\/\//.test(f) ? f : r(this.map.consumer().sourceRoot || this.map.root || ".", f);
    }
    origin(f, x, b, y) {
      if (!this.map) return !1;
      let m = this.map.consumer(), R = m.originalPositionFor({ column: x - 1, line: f });
      if (!R.source) return !1;
      let p;
      if (typeof b == "number") {
        let E = m.originalPositionFor({
          column: y - 1,
          line: b
        });
        E.source && (p = E);
      }
      let S;
      t(R.source) ? S = h(R.source) : S = new URL(
        R.source,
        this.map.consumer().sourceRoot || h(this.map.mapFile)
      );
      let C = {
        column: R.column + 1,
        endColumn: p && p.column + 1,
        endLine: p && p.line,
        line: R.line,
        url: S.toString()
      };
      if (S.protocol === "file:")
        if (l)
          C.file = l(S);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let I = m.sourceContentFor(R.source);
      return I && (C.source = I), C;
    }
    toJSON() {
      let f = {};
      for (let x of ["hasBOM", "css", "file", "id"])
        this[x] != null && (f[x] = this[x]);
      return this.map && (f.map = { ...this.map }, f.map.consumerCache && (f.map.consumerCache = void 0)), f;
    }
  }
  return Nt = s, s.default = s, d && d.registerInput && d.registerInput(s), Nt;
}
var It, _r;
function Fe() {
  if (_r) return It;
  _r = 1;
  let e = Ie(), t, r;
  class a extends e {
    constructor(l) {
      super(l), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(l, h, g) {
      let w = /* @__PURE__ */ new Set();
      for (let v of Array.isArray(l) ? l : [l])
        v && typeof v == "object" && !v.parent && v.raws && typeof v.raws.before < "u" && w.add(v.raws);
      let d = super.normalize(l);
      if (h) {
        if (g === "prepend")
          this.nodes.length > 1 ? h.raws.before = this.nodes[1].raws.before : delete h.raws.before;
        else if (this.first !== h)
          for (let v of d)
            w.has(v.raws) || (v.raws.before = h.raws.before);
      }
      return d;
    }
    removeChild(l, h) {
      let g = this.index(l);
      return !h && g === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[g].raws.before), super.removeChild(l);
    }
    toResult(l = {}) {
      return new t(new r(), this, l).stringify();
    }
  }
  return a.registerLazyResult = (o) => {
    t = o;
  }, a.registerProcessor = (o) => {
    r = o;
  }, It = a, a.default = a, e.registerRoot(a), It;
}
var qt, Jr;
function zi() {
  if (Jr) return qt;
  Jr = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let r = [" ", `
`, "	"];
      return e.split(t, r);
    },
    split(t, r, a) {
      if (typeof t != "string") return [];
      let o = [], l = "", h = !1, g = 0, w = !1, d = "", v = !1;
      for (let n of t)
        if (v ? v = !1 : n === "\\" ? v = !0 : w ? n === d && (w = !1) : n === '"' || n === "'" ? (w = !0, d = n) : n === "(" ? g += 1 : n === ")" ? g > 0 && (g -= 1) : g === 0 && r.includes(n) && (h = !0), h) {
          let i = l.trim();
          (a || i !== "") && o.push(i), l = "", h = !1;
        } else
          l += n;
      let c = l.trim();
      return (a || c !== "") && o.push(c), o;
    }
  };
  return qt = e, e.default = e, qt;
}
var Ct, zr;
function ar() {
  if (zr) return Ct;
  zr = 1;
  let e = Ie(), t = zi();
  class r extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(o) {
      let l = this.selector ? this.selector.match(/,\s*/) : null, h = l ? l[0] : "," + this.raw("between", "beforeOpen");
      this.selector = o.join(h);
    }
    constructor(o) {
      super(o), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return Ct = r, r.default = r, e.registerRule(r), Ct;
}
var kt, Fr;
function Ts() {
  if (Fr) return kt;
  Fr = 1;
  let e = nr(), t = ot(), r = lt(), a = ut(), o = Ji(), l = Fe(), h = ar();
  function g(v, c) {
    return v.inputs ? v.inputs.map((n) => {
      let i = { ...n, __proto__: a.prototype };
      return i.map && (i.map = {
        ...i.map,
        __proto__: o.prototype
      }), i;
    }) : c;
  }
  function w(v, c, n) {
    let i = { ...v };
    if (delete i.inputs, delete i.nodes, i.source) {
      let { inputId: u, ...f } = i.source;
      i.source = f, u != null && (i.source.input = c[u]);
    }
    let s;
    if (i.type === "root")
      s = new l(i);
    else if (i.type === "decl")
      s = new r(i);
    else if (i.type === "rule")
      s = new h(i);
    else if (i.type === "comment")
      s = new t(i);
    else if (i.type === "atrule")
      s = new e(i);
    else
      throw new Error("Unknown node type: " + v.type);
    if (n) {
      s.nodes = n;
      for (let u of n) u.parent = s;
    }
    return s;
  }
  function d(v, c) {
    if (Array.isArray(v)) return v.map((s) => d(s));
    let n, i = [
      { childIndex: 0, children: [], inputs: g(v, c), json: v }
    ];
    for (; i.length > 0; ) {
      let s = i[i.length - 1], u = s.json.nodes;
      if (u && s.childIndex < u.length) {
        let x = u[s.childIndex];
        s.childIndex += 1, i.push({
          childIndex: 0,
          children: [],
          inputs: g(x, s.inputs),
          json: x
        });
        continue;
      }
      i.pop();
      let f = w(
        s.json,
        s.inputs,
        u ? s.children : void 0
      );
      i.length > 0 ? i[i.length - 1].children.push(f) : n = f;
    }
    return n;
  }
  return kt = d, d.default = d, kt;
}
var Dt, Vr;
function Fi() {
  if (Vr) return Dt;
  Vr = 1;
  let { dirname: e, relative: t, resolve: r, sep: a } = ve, { SourceMapConsumer: o, SourceMapGenerator: l } = ve, { pathToFileURL: h } = ve, g = ut(), w = !!(o && l), d = !!(e && r && t && a);
  class v {
    constructor(n, i, s, u) {
      this.stringify = n, this.mapOpts = s.map || {}, this.root = i, this.opts = s, this.css = u, this.originalCSS = u, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let n;
      this.isInline() ? n = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? n = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? n = this.mapOpts.annotation(this.opts.to, this.root) : n = this.outputFile() + ".map";
      let i = `
`;
      this.css.includes(`\r
`) && (i = `\r
`), this.css += i + "/*# sourceMappingURL=" + n + " */";
    }
    applyPrevMaps() {
      for (let n of this.previous()) {
        let i = this.toUrl(this.path(n.file)), s = n.root || e(n.file), u;
        this.mapOpts.sourcesContent === !1 ? (u = new o(n.text), u.sourcesContent && (u.sourcesContent = null)) : u = n.consumer(), this.map.applySourceMap(u, i, this.toUrl(this.path(s)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1) {
        if (this.root) {
          let n;
          for (let i = this.root.nodes.length - 1; i >= 0; i--)
            n = this.root.nodes[i], n.type === "comment" && n.text.startsWith("# sourceMappingURL=") && this.root.removeChild(i);
        } else if (this.css) {
          let n = "/*# sourceMappingURL=", i;
          for (; (i = this.css.lastIndexOf(n)) !== -1; ) {
            let s = this.css.indexOf("*/", i + n.length);
            if (s === -1) break;
            for (; i > 0 && this.css[i - 1] === `
`; )
              i--;
            this.css = this.css.slice(0, i) + this.css.slice(s + 2);
          }
        }
      }
    }
    generate() {
      if (this.clearAnnotation(), d && w && this.isMap())
        return this.generateMap();
      {
        let n = "";
        return this.stringify(this.root, (i) => {
          n += i;
        }), [n];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let n = this.previous()[0].consumer();
        n.file = this.outputFile(), this.map = l.fromSourceMap(n, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new l({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new l({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let n = 1, i = 1, s = "<no source>", u = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, f, x;
      this.stringify(this.root, (b, y, m) => {
        if (this.css += b, y && m !== "end" && (u.generated.line = n, u.generated.column = i - 1, y.source && y.source.start ? (u.source = this.sourcePath(y), u.original.line = y.source.start.line, u.original.column = y.source.start.column - 1, this.map.addMapping(u)) : (u.source = s, u.original.line = 1, u.original.column = 0, this.map.addMapping(u))), x = b.match(/\n/g), x ? (n += x.length, f = b.lastIndexOf(`
`), i = b.length - f) : i += b.length, y && m !== "start") {
          let R = y.parent || { raws: {} };
          (!(y.type === "decl" || y.type === "atrule" && !y.nodes) || y !== R.last || R.raws.semicolon) && (y.source && y.source.end ? (u.source = this.sourcePath(y), u.original.line = y.source.end.line, u.original.column = y.source.end.column - 1, u.generated.line = n, u.generated.column = i - 2, this.map.addMapping(u)) : (u.source = s, u.original.line = 1, u.original.column = 0, u.generated.line = n, u.generated.column = i - 1, this.map.addMapping(u)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((n) => n.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let n = this.mapOpts.annotation;
      return typeof n < "u" && n !== !0 ? !1 : this.previous().length ? this.previous().some((i) => i.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((n) => n.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(n) {
      if (this.mapOpts.absolute || n.charCodeAt(0) === 60 || /^\w+:\/\//.test(n)) return n;
      let i = this.memoizedPaths.get(n);
      if (i) return i;
      let s = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (s = e(r(s, this.mapOpts.annotation)));
      let u = t(s, n);
      return this.memoizedPaths.set(n, u), u;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((n) => {
            if (n.source && n.source.input.map) {
              let i = n.source.input.map;
              this.previousMaps.includes(i) || this.previousMaps.push(i);
            }
          });
        else {
          let n = new g(this.originalCSS, this.opts);
          n.map && this.previousMaps.push(n.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let n = {};
      if (this.root)
        this.root.walk((i) => {
          if (i.source) {
            let s = i.source.input.from;
            if (s && !n[s]) {
              n[s] = !0;
              let u = this.usesFileUrls ? this.toFileUrl(s) : this.toUrl(this.path(s));
              this.map.setSourceContent(u, i.source.input.css);
            }
          }
        });
      else if (this.css) {
        let i = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(i, this.css);
      }
    }
    sourcePath(n) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(n.source.input.from) : this.toUrl(this.path(n.source.input.from));
    }
    toBase64(n) {
      return Buffer ? Buffer.from(n).toString("base64") : window.btoa(unescape(encodeURIComponent(n)));
    }
    toFileUrl(n) {
      let i = this.memoizedFileURLs.get(n);
      if (i) return i;
      if (h) {
        let s = h(n).toString();
        return this.memoizedFileURLs.set(n, s), s;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(n) {
      let i = this.memoizedURLs.get(n);
      if (i) return i;
      a === "\\" && (n = n.replace(/\\/g, "/"));
      let s = encodeURI(n).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(n, s), s;
    }
  }
  return Dt = v, Dt;
}
var Ot, Wr;
function Es() {
  if (Wr) return Ot;
  Wr = 1;
  const e = 39, t = 34, r = 92, a = 47, o = 10, l = 32, h = 12, g = 9, w = 13, d = 91, v = 93, c = 40, n = 41, i = 123, s = 125, u = 59, f = 42, x = 58, b = 64, y = /[\t\n\f\r "#'()/;[\\\]{}]/g, m = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, R = /.[\r\n"'(/\\]/, p = /[\da-f]/i;
  return Ot = function(C, I = {}) {
    let E = C.css.valueOf(), q = I.ignoreErrors, j, K, M, A, O, L, D, U, J, W, G = E.length, B = 0, Q = [], te = [], fe = -1;
    function re() {
      return B;
    }
    function de(ce) {
      throw C.error("Unclosed " + ce, B);
    }
    function be() {
      return te.length === 0 && B >= G;
    }
    function ie(ce) {
      if (te.length) return te.pop();
      if (B >= G) return;
      let Re = ce ? ce.ignoreUnclosed : !1;
      switch (j = E.charCodeAt(B), j) {
        case o:
        case l:
        case g:
        case w:
        case h: {
          A = B;
          do
            A += 1, j = E.charCodeAt(A);
          while (j === l || j === o || j === g || j === w || j === h);
          L = ["space", E.slice(B, A)], B = A - 1;
          break;
        }
        case d:
        case v:
        case i:
        case s:
        case x:
        case u:
        case n: {
          let _e = String.fromCharCode(j);
          L = [_e, _e, B];
          break;
        }
        case c: {
          if (W = Q.length ? Q.pop()[1] : "", J = E.charCodeAt(B + 1), W === "url" && J !== e && J !== t && J !== l && J !== o && J !== g && J !== h && J !== w) {
            A = B;
            do {
              if (D = !1, A = E.indexOf(")", A + 1), A === -1)
                if (q || Re) {
                  A = B;
                  break;
                } else
                  de("bracket");
              for (U = A; E.charCodeAt(U - 1) === r; )
                U -= 1, D = !D;
            } while (D);
            L = ["brackets", E.slice(B, A + 1), B, A], B = A;
          } else B <= fe ? L = ["(", "(", B] : (A = E.indexOf(")", B + 1), K = E.slice(B, A + 1), A === -1 || R.test(K) ? (fe = A === -1 ? G : A, L = ["(", "(", B]) : (L = ["brackets", K, B, A], B = A));
          break;
        }
        case e:
        case t: {
          O = j === e ? "'" : '"', A = B;
          do {
            if (D = !1, A = E.indexOf(O, A + 1), A === -1)
              if (q || Re) {
                A = B + 1;
                break;
              } else
                de("string");
            for (U = A; E.charCodeAt(U - 1) === r; )
              U -= 1, D = !D;
          } while (D);
          L = ["string", E.slice(B, A + 1), B, A], B = A;
          break;
        }
        case b: {
          y.lastIndex = B + 1, y.test(E), y.lastIndex === 0 ? A = E.length - 1 : A = y.lastIndex - 2, L = ["at-word", E.slice(B, A + 1), B, A], B = A;
          break;
        }
        case r: {
          for (A = B, M = !0; E.charCodeAt(A + 1) === r; )
            A += 1, M = !M;
          if (j = E.charCodeAt(A + 1), M && j !== a && j !== l && j !== o && j !== g && j !== w && j !== h && (A += 1, p.test(E.charAt(A)))) {
            for (; p.test(E.charAt(A + 1)); )
              A += 1;
            E.charCodeAt(A + 1) === l && (A += 1);
          }
          L = ["word", E.slice(B, A + 1), B, A], B = A;
          break;
        }
        default: {
          j === a && E.charCodeAt(B + 1) === f ? (A = E.indexOf("*/", B + 2) + 1, A === 0 && (q || Re ? A = E.length : de("comment")), L = ["comment", E.slice(B, A + 1), B, A], B = A) : (m.lastIndex = B + 1, m.test(E), m.lastIndex === 0 ? A = E.length - 1 : A = m.lastIndex - 2, L = ["word", E.slice(B, A + 1), B, A], Q.push(L), B = A);
          break;
        }
      }
      return B++, L;
    }
    function pe(ce) {
      te.push(ce);
    }
    return {
      back: pe,
      endOfFile: be,
      nextToken: ie,
      position: re
    };
  }, Ot;
}
var Lt, Gr;
function Ns() {
  if (Gr) return Lt;
  Gr = 1;
  let e = nr(), t = ot(), r = lt(), a = Fe(), o = ar(), l = Es();
  const h = {
    empty: !0,
    space: !0
  };
  function g(v) {
    for (let c = v.length - 1; c >= 0; c--) {
      let n = v[c], i = n[3] || n[2];
      if (i) return i;
    }
  }
  function w(v, c, n) {
    let i = "";
    for (let s = c; s < n; s++) i += v[s][1];
    return i;
  }
  class d {
    constructor(c) {
      this.input = c, this.root = new a(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: c, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(c) {
      let n = new e();
      n.name = c[1].slice(1), n.name === "" && this.unnamedAtrule(n, c), this.init(n, c[2]);
      let i, s, u, f = !1, x = !1, b = [], y = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (c = this.tokenizer.nextToken(), i = c[0], i === "(" || i === "[" ? y.push(i === "(" ? ")" : "]") : i === "{" && y.length > 0 ? y.push("}") : i === y[y.length - 1] && y.pop(), y.length === 0)
          if (i === ";") {
            n.source.end = this.getPosition(c[2]), n.source.end.offset++, this.semicolon = !0;
            break;
          } else if (i === "{") {
            x = !0;
            break;
          } else if (i === "}") {
            if (b.length > 0) {
              for (u = b.length - 1, s = b[u]; s && s[0] === "space"; )
                s = b[--u];
              s && (n.source.end = this.getPosition(s[3] || s[2]), n.source.end.offset++);
            }
            this.end(c);
            break;
          } else
            b.push(c);
        else
          b.push(c);
        if (this.tokenizer.endOfFile()) {
          f = !0;
          break;
        }
      }
      n.raws.between = this.spacesAndCommentsFromEnd(b), b.length ? (n.raws.afterName = this.spacesAndCommentsFromStart(b), this.raw(n, "params", b), f && (c = b[b.length - 1], n.source.end = this.getPosition(c[3] || c[2]), n.source.end.offset++, this.spaces = n.raws.between, n.raws.between = "")) : (n.raws.afterName = "", n.params = ""), x && (n.nodes = [], this.current = n);
    }
    checkMissedSemicolon(c) {
      let n = this.colon(c);
      if (n === !1) return;
      let i = 0, s;
      for (let u = n - 1; u >= 0 && (s = c[u], !(s[0] !== "space" && (i += 1, i === 2))); u--)
        ;
      throw this.input.error(
        "Missed semicolon",
        s[0] === "word" ? s[3] + 1 : s[2]
      );
    }
    colon(c) {
      let n = 0, i, s, u;
      for (let [f, x] of c.entries()) {
        if (s = x, u = s[0], u === "(" && (n += 1), u === ")" && (n -= 1), n === 0 && u === ":")
          if (!i)
            this.doubleColon(s);
          else {
            if (i[0] === "word" && i[1] === "progid")
              continue;
            return f;
          }
        i = s;
      }
      return !1;
    }
    comment(c) {
      let n = new t();
      this.init(n, c[2]), n.source.end = this.getPosition(c[3] || c[2]), n.source.end.offset++;
      let i = c[1].slice(2, -2);
      if (!i.trim())
        n.text = "", n.raws.left = i, n.raws.right = "";
      else {
        let s = i.match(/^(\s*)([^]*\S)(\s*)$/);
        n.text = s[2], n.raws.left = s[1], n.raws.right = s[3];
      }
    }
    createTokenizer() {
      this.tokenizer = l(this.input);
    }
    decl(c, n) {
      let i = new r();
      this.init(i, c[0][2]);
      let s = c[c.length - 1];
      s[0] === ";" && (this.semicolon = !0, c.pop()), i.source.end = this.getPosition(
        s[3] || s[2] || g(c)
      ), i.source.end.offset++;
      let u = 0;
      for (; c[u][0] !== "word"; )
        u === c.length - 1 && this.unknownWord([c[u]]), u++;
      i.raws.before += w(c, 0, u), i.source.start = this.getPosition(c[u][2]);
      let f = u;
      for (; u < c.length; ) {
        let p = c[u][0];
        if (p === ":" || p === "space" || p === "comment")
          break;
        u++;
      }
      i.prop = w(c, f, u);
      let x = u, b;
      for (; u < c.length && (b = c[u], u++, b[0] !== ":"); )
        b[0] === "word" && /\w/.test(b[1]) && this.unknownWord([b]);
      i.raws.between = w(c, x, u), (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
      let y = u;
      for (; u < c.length; ) {
        let p = c[u][0];
        if (p !== "space" && p !== "comment") break;
        u++;
      }
      let m = c.slice(y, u);
      c = c.slice(u), this.precheckMissedSemicolon(c);
      for (let p = c.length - 1; p >= 0; p--) {
        if (b = c[p], b[1].toLowerCase() === "!important") {
          i.important = !0;
          let S = this.stringFrom(c, p);
          S = this.spacesFromEnd(c) + S, S !== " !important" && (i.raws.important = S);
          break;
        } else if (b[1].toLowerCase() === "important") {
          let S = c.slice(0), C = "";
          for (let I = p; I > 0; I--) {
            let E = S[I][0];
            if (C.trim().startsWith("!") && E !== "space")
              break;
            C = S.pop()[1] + C;
          }
          C.trim().startsWith("!") && (i.important = !0, i.raws.important = C, c = S);
        }
        if (b[0] !== "space" && b[0] !== "comment")
          break;
      }
      c.some((p) => p[0] !== "space" && p[0] !== "comment") && (i.raws.between += m.map((p) => p[1]).join(""), m = []), this.raw(i, "value", m.concat(c), n), i.value.includes(":") && !n && this.checkMissedSemicolon(c);
    }
    doubleColon(c) {
      throw this.input.error(
        "Double colon",
        { offset: c[2] },
        { offset: c[2] + c[1].length }
      );
    }
    emptyRule(c) {
      let n = new o();
      this.init(n, c[2]), n.selector = "", n.raws.between = "", this.current = n;
    }
    end(c) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(c[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(c);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(c) {
      if (this.spaces += c[1], this.current.nodes) {
        let n = this.current.nodes[this.current.nodes.length - 1];
        n && n.type === "rule" && !n.raws.ownSemicolon && (n.raws.ownSemicolon = this.spaces, this.spaces = "", n.source.end = this.getPosition(c[2]), n.source.end.offset++);
      }
    }
    // Helpers
    getPosition(c) {
      let n = this.input.fromOffset(c);
      return {
        column: n.col,
        line: n.line,
        offset: c
      };
    }
    init(c, n) {
      this.current.push(c), c.source = {
        input: this.input,
        start: this.getPosition(n)
      }, c.raws.before = this.spaces, this.spaces = "", c.type !== "comment" && (this.semicolon = !1);
    }
    other(c) {
      let n = !1, i = null, s = !1, u = null, f = [], x = c[1].startsWith("--"), b = [], y = c;
      for (; y; ) {
        if (i = y[0], b.push(y), i === "(" || i === "[")
          u || (u = y), f.push(i === "(" ? ")" : "]");
        else if (x && s && i === "{")
          u || (u = y), f.push("}");
        else if (f.length === 0)
          if (i === ";")
            if (s) {
              this.decl(b, x);
              return;
            } else
              break;
          else if (i === "{") {
            this.rule(b);
            return;
          } else if (i === "}") {
            this.tokenizer.back(b.pop()), n = !0;
            break;
          } else i === ":" && (s = !0);
        else i === f[f.length - 1] && (f.pop(), f.length === 0 && (u = null));
        y = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (n = !0), f.length > 0 && this.unclosedBracket(u), n && s) {
        if (!x)
          for (; b.length && (y = b[b.length - 1][0], !(y !== "space" && y !== "comment")); )
            this.tokenizer.back(b.pop());
        this.decl(b, x);
      } else
        this.unknownWord(b);
    }
    parse() {
      let c;
      for (; !this.tokenizer.endOfFile(); )
        switch (c = this.tokenizer.nextToken(), c[0]) {
          case "space":
            this.spaces += c[1];
            break;
          case ";":
            this.freeSemicolon(c);
            break;
          case "}":
            this.end(c);
            break;
          case "comment":
            this.comment(c);
            break;
          case "at-word":
            this.atrule(c);
            break;
          case "{":
            this.emptyRule(c);
            break;
          default:
            this.other(c);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(c, n, i, s) {
      let u, f, x = i.length, b = "", y = !0, m, R;
      for (let p = 0; p < x; p += 1)
        u = i[p], f = u[0], f === "space" && p === x - 1 && !s ? y = !1 : f === "comment" ? (R = i[p - 1] ? i[p - 1][0] : "empty", m = i[p + 1] ? i[p + 1][0] : "empty", !h[R] && !h[m] ? b.slice(-1) === "," ? y = !1 : b += u[1] : y = !1) : b += u[1];
      if (!y) {
        let p = i.reduce((S, C) => S + C[1], "");
        c.raws[n] = { raw: p, value: b };
      }
      c[n] = b;
    }
    rule(c) {
      c.pop();
      let n = new o();
      this.init(n, c[0][2]), n.raws.between = this.spacesAndCommentsFromEnd(c), this.raw(n, "selector", c), this.current = n;
    }
    spacesAndCommentsFromEnd(c) {
      let n, i = "";
      for (; c.length && (n = c[c.length - 1][0], !(n !== "space" && n !== "comment")); )
        i = c.pop()[1] + i;
      return i;
    }
    // Errors
    spacesAndCommentsFromStart(c) {
      let n, i = "";
      for (; c.length && (n = c[0][0], !(n !== "space" && n !== "comment")); )
        i += c.shift()[1];
      return i;
    }
    spacesFromEnd(c) {
      let n, i = "";
      for (; c.length && (n = c[c.length - 1][0], n === "space"); )
        i = c.pop()[1] + i;
      return i;
    }
    stringFrom(c, n) {
      let i = "";
      for (let s = n; s < c.length; s++)
        i += c[s][1];
      return c.splice(n, c.length - n), i;
    }
    unclosedBlock() {
      let c = this.current.source.start;
      throw this.input.error("Unclosed block", c.line, c.column);
    }
    unclosedBracket(c) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: c[2] },
        { offset: c[2] + 1 }
      );
    }
    unexpectedClose(c) {
      throw this.input.error(
        "Unexpected }",
        { offset: c[2] },
        { offset: c[2] + 1 }
      );
    }
    unknownWord(c) {
      throw this.input.error(
        "Unknown word " + c[0][1],
        { offset: c[0][2] },
        { offset: c[0][2] + c[0][1].length }
      );
    }
    unnamedAtrule(c, n) {
      throw this.input.error(
        "At-rule without name",
        { offset: n[2] },
        { offset: n[2] + n[1].length }
      );
    }
  }
  return Lt = d, Lt;
}
var Bt, Hr;
function or() {
  if (Hr) return Bt;
  Hr = 1;
  let e = Ie(), t = ut(), r = Ns();
  function a(o, l) {
    let h = new t(o, l), g = new r(h);
    try {
      g.parse();
    } catch (w) {
      throw process.env.NODE_ENV !== "production" && w.name === "CssSyntaxError" && l && l.from && (/\.scss$/i.test(l.from) ? w.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(l.from) ? w.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(l.from) && (w.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), w;
    }
    return g.root;
  }
  return Bt = a, a.default = a, e.registerParse(a), Bt;
}
var Mt, Yr;
function Vi() {
  if (Yr) return Mt;
  Yr = 1;
  let e = Ie(), { my: t } = st();
  class r {
    constructor(o, l = {}) {
      if (this.type = "warning", this.text = o, l.node && l.node.source) {
        l.node[t] || e.rebuild(l.node);
        let h = l.node.rangeBy(l);
        this.line = h.start.line, this.column = h.start.column, this.endLine = h.end.line, this.endColumn = h.end.column;
      }
      for (let h in l) this[h] = l[h];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return Mt = r, r.default = r, Mt;
}
var Pt, $r;
function lr() {
  if ($r) return Pt;
  $r = 1;
  let e = Vi();
  class t {
    get content() {
      return this.css;
    }
    constructor(a, o, l) {
      this.processor = a, this.messages = [], this.root = o, this.opts = l, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(a, o = {}) {
      o.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (o.plugin = this.lastPlugin.postcssPlugin);
      let l = new e(a, o);
      return this.messages.push(l), l;
    }
    warnings() {
      return this.messages.filter((a) => a.type === "warning");
    }
  }
  return Pt = t, t.default = t, Pt;
}
var Ut, Zr;
function Wi() {
  if (Zr) return Ut;
  Zr = 1;
  let e = {};
  return Ut = function(r) {
    e[r] || (e[r] = !0, typeof console < "u" && console.warn && console.warn(r));
  }, Ut;
}
var jt, Xr;
function Gi() {
  if (Xr) return jt;
  Xr = 1;
  let e = Ie(), t = sr(), r = Fi(), a = or(), o = lr(), l = Fe(), h = nt(), { isClean: g, my: w } = st(), d = Wi();
  const v = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, c = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, n = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, i = 0;
  function s(m) {
    return typeof m == "object" && typeof m.then == "function";
  }
  function u(m) {
    let R = !1, p = v[m.type];
    return m.type === "decl" ? R = m.prop.toLowerCase() : m.type === "atrule" && (R = m.name.toLowerCase()), R && m.append ? [
      p,
      p + "-" + R,
      i,
      p + "Exit",
      p + "Exit-" + R
    ] : R ? [p, p + "-" + R, p + "Exit", p + "Exit-" + R] : m.append ? [p, i, p + "Exit"] : [p, p + "Exit"];
  }
  function f(m) {
    let R;
    return m.type === "document" ? R = ["Document", i, "DocumentExit"] : m.type === "root" ? R = ["Root", i, "RootExit"] : R = u(m), {
      eventIndex: 0,
      events: R,
      iterator: 0,
      node: m,
      visitorIndex: 0,
      visitors: []
    };
  }
  function x(m) {
    let R = [m];
    for (; R.length > 0; ) {
      let p = R.pop();
      if (p[g] = !1, p.nodes)
        for (let S of p.nodes) R.push(S);
    }
    return m;
  }
  let b = {};
  class y {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(R, p, S) {
      this.stringified = !1, this.processed = !1;
      let C;
      if (typeof p == "object" && p !== null && (p.type === "root" || p.type === "document"))
        C = x(p);
      else if (p instanceof y || p instanceof o)
        C = x(p.root), p.map && (typeof S.map > "u" && (S.map = {}), S.map.inline || (S.map.inline = !1), S.map.prev = p.map);
      else {
        let I = a;
        S.syntax && (I = S.syntax.parse), S.parser && (I = S.parser), I.parse && (I = I.parse);
        try {
          C = I(p, S);
        } catch (E) {
          this.processed = !0, this.error = E;
        }
        C && !C[w] && e.rebuild(C);
      }
      this.result = new o(R, C, S), this.helpers = { ...b, postcss: b, result: this.result }, this.plugins = this.processor.plugins.map((I) => typeof I == "object" && I.prepare ? { ...I, ...I.prepare(this.result) } : I);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(R) {
      return this.async().catch(R);
    }
    finally(R) {
      return this.async().then(R, R);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(R, p) {
      let S = this.result.lastPlugin;
      try {
        if (p && p.addToError(R), this.error = R, R.name === "CssSyntaxError" && !R.plugin)
          R.plugin = S.postcssPlugin, R.setMessage();
        else if (S.postcssVersion && process.env.NODE_ENV !== "production") {
          let C = S.postcssPlugin, I = S.postcssVersion, E = this.result.processor.version, q = I.split("."), j = E.split(".");
          (q[0] !== j[0] || parseInt(q[1]) > parseInt(j[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + E + ", but " + C + " uses " + I + ". Perhaps this is the source of the error below."
          );
        }
      } catch (C) {
        console && console.error && console.error(C);
      }
      return R;
    }
    prepareVisitors() {
      this.listeners = {};
      let R = (p, S, C) => {
        this.listeners[S] || (this.listeners[S] = []), this.listeners[S].push([p, C]);
      };
      for (let p of this.plugins)
        if (typeof p == "object")
          for (let S in p) {
            if (!c[S] && /^[A-Z]/.test(S))
              throw new Error(
                `Unknown event ${S} in ${p.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!n[S])
              if (typeof p[S] == "object")
                for (let C in p[S])
                  C === "*" ? R(p, S, p[S][C]) : R(
                    p,
                    S + "-" + C.toLowerCase(),
                    p[S][C]
                  );
              else typeof p[S] == "function" && R(p, S, p[S]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let R = 0; R < this.plugins.length; R++) {
        let p = this.plugins[R], S = this.runOnRoot(p);
        if (s(S))
          try {
            await S;
          } catch (C) {
            throw this.handleError(C);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let R = this.result.root;
        for (; !R[g]; ) {
          R[g] = !0;
          let p = [f(R)];
          for (; p.length > 0; ) {
            let S = this.visitTick(p);
            if (s(S))
              try {
                await S;
              } catch (C) {
                let I = p[p.length - 1].node;
                throw this.handleError(C, I);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [p, S] of this.listeners.OnceExit) {
            this.result.lastPlugin = p;
            try {
              if (R.type === "document") {
                let C = R.nodes.map(
                  (I) => S(I, this.helpers)
                );
                await Promise.all(C);
              } else
                await S(R, this.helpers);
            } catch (C) {
              throw this.handleError(C);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(R) {
      this.result.lastPlugin = R;
      try {
        if (typeof R == "object" && R.Once) {
          if (this.result.root.type === "document") {
            let p = this.result.root.nodes.map(
              (S) => R.Once(S, this.helpers)
            );
            return s(p[0]) ? Promise.all(p) : p;
          }
          return R.Once(this.result.root, this.helpers);
        } else if (typeof R == "function")
          return R(this.result.root, this.result);
      } catch (p) {
        throw this.handleError(p);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let R = this.result.opts, p = h;
      R.syntax && (p = R.syntax.stringify), R.stringifier && (p = R.stringifier), p.stringify && (p = p.stringify);
      let S = this.result.root.source;
      if (R.map === void 0 && !(S && S.input && S.input.map)) {
        let E = "";
        return p(this.result.root, (q) => {
          E += q;
        }), this.result.css = E, this.result;
      }
      let I = new r(p, this.result.root, this.result.opts).generate();
      return this.result.css = I[0], this.result.map = I[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let R of this.plugins) {
        let p = this.runOnRoot(R);
        if (s(p))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let R = this.result.root;
        for (; !R[g]; )
          R[g] = !0, this.walkSync(R);
        if (this.listeners.OnceExit)
          if (R.type === "document")
            for (let p of R.nodes)
              this.visitSync(this.listeners.OnceExit, p);
          else
            this.visitSync(this.listeners.OnceExit, R);
      }
      return this.result;
    }
    then(R, p) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || d(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(R, p);
    }
    toString() {
      return this.css;
    }
    visitSync(R, p) {
      for (let [S, C] of R) {
        this.result.lastPlugin = S;
        let I;
        try {
          I = C(p, this.helpers);
        } catch (E) {
          throw this.handleError(E, p.proxyOf);
        }
        if (p.type !== "root" && p.type !== "document" && !p.parent)
          return !0;
        if (s(I))
          throw this.getAsyncError();
      }
    }
    visitTick(R) {
      let p = R[R.length - 1], { node: S, visitors: C } = p;
      if (S.type !== "root" && S.type !== "document" && !S.parent) {
        R.pop();
        return;
      }
      if (C.length > 0 && p.visitorIndex < C.length) {
        let [E, q] = C[p.visitorIndex];
        p.visitorIndex += 1, p.visitorIndex === C.length && (p.visitors = [], p.visitorIndex = 0), this.result.lastPlugin = E;
        try {
          return q(S.toProxy(), this.helpers);
        } catch (j) {
          throw this.handleError(j, S);
        }
      }
      if (p.iterator !== 0) {
        let E = p.iterator;
        p.descending && (p.descending = !1, S.indexes[E] += 1);
        let q;
        for (; q = S.nodes[S.indexes[E]]; ) {
          if (!q[g]) {
            q[g] = !0, p.descending = !0, R.push(f(q));
            return;
          }
          S.indexes[E] += 1;
        }
        p.iterator = 0, delete S.indexes[E];
      }
      let I = p.events;
      for (; p.eventIndex < I.length; ) {
        let E = I[p.eventIndex];
        if (p.eventIndex += 1, E === i) {
          S.nodes && S.nodes.length && (S[g] = !0, p.iterator = S.getIterator());
          return;
        } else if (this.listeners[E]) {
          p.visitors = this.listeners[E];
          return;
        }
      }
      R.pop();
    }
    walkSync(R) {
      R[g] = !0;
      let p = [{ eventIndex: 0, events: u(R), iterator: 0, node: R }];
      for (; p.length > 0; ) {
        let S = p[p.length - 1], C = S.node;
        if (S.iterator !== 0) {
          let I = S.iterator;
          S.descending && (S.descending = !1, C.indexes[I] += 1);
          let E, q = !1;
          for (; E = C.nodes[C.indexes[I]]; ) {
            if (!E[g]) {
              E[g] = !0, S.descending = !0, p.push({
                eventIndex: 0,
                events: u(E),
                iterator: 0,
                node: E
              }), q = !0;
              break;
            }
            C.indexes[I] += 1;
          }
          if (q) continue;
          S.iterator = 0, delete C.indexes[I];
        }
        if (S.eventIndex < S.events.length) {
          let I = S.events[S.eventIndex];
          if (S.eventIndex += 1, I === i)
            C.nodes && C.nodes.length && (S.iterator = C.getIterator());
          else {
            let E = this.listeners[I];
            E && this.visitSync(E, C.toProxy()) && p.pop();
          }
          continue;
        }
        p.pop();
      }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return y.registerPostcss = (m) => {
    b = m;
  }, jt = y, y.default = y, l.registerLazyResult(y), t.registerLazyResult(y), jt;
}
var _t, Kr;
function Is() {
  if (Kr) return _t;
  Kr = 1;
  let e = Fi(), t = or(), r = lr(), a = nt(), o = Wi();
  class l {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let g, w = t;
      try {
        g = w(this._css, this._opts);
      } catch (d) {
        this.error = d;
      }
      if (this.error)
        throw this.error;
      return this._root = g, g;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(g, w, d) {
      w = w.toString(), this.stringified = !1, this._processor = g, this._css = w, this._opts = d, this._map = void 0;
      let v = a;
      this.result = new r(this._processor, void 0, this._opts), this.result.css = w;
      let c = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return c.root;
        }
      });
      let n = new e(v, void 0, this._opts, w);
      if (n.isMap()) {
        let [i, s] = n.generate();
        i && (this.result.css = i), s && (this.result.map = s);
      } else
        n.clearAnnotation(), this.result.css = n.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(g) {
      return this.async().catch(g);
    }
    finally(g) {
      return this.async().then(g, g);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(g, w) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || o(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(g, w);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return _t = l, l.default = l, _t;
}
var Jt, Qr;
function qs() {
  if (Qr) return Jt;
  Qr = 1;
  let e = sr(), t = Gi(), r = Is(), a = Fe();
  class o {
    constructor(h = []) {
      this.version = "8.5.28", this.plugins = this.normalize(h);
    }
    normalize(h) {
      let g = [];
      for (let w of h)
        if (w.postcss === !0 ? w = w() : w.postcss && (w = w.postcss), typeof w == "object" && Array.isArray(w.plugins))
          g = g.concat(w.plugins);
        else if (typeof w == "object" && w.postcssPlugin)
          g.push(w);
        else if (typeof w == "function")
          g.push(w);
        else if (typeof w == "object" && (w.parse || w.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(w + " is not a PostCSS plugin");
      return g;
    }
    process(h, g = {}) {
      return !this.plugins.length && !g.parser && !g.stringifier && !g.syntax ? new r(this, h, g) : new t(this, h, g);
    }
    use(h) {
      return this.plugins = this.plugins.concat(this.normalize([h])), this;
    }
  }
  return Jt = o, o.default = o, a.registerProcessor(o), e.registerProcessor(o), Jt;
}
var zt, ei;
function Cs() {
  if (ei) return zt;
  ei = 1;
  let e = nr(), t = ot(), r = Ie(), a = ir(), o = lt(), l = sr(), h = Ts(), g = ut(), w = Gi(), d = zi(), v = at(), c = or(), n = qs(), i = lr(), s = Fe(), u = ar(), f = nt(), x = Vi();
  function b(...y) {
    return y.length === 1 && Array.isArray(y[0]) && (y = y[0]), new n(y);
  }
  return b.plugin = function(m, R) {
    let p = !1;
    function S(...I) {
      console && console.warn && !p && (p = !0, console.warn(
        m + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("zh") && console.warn(
        m + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let E = R(...I);
      return E.postcssPlugin = m, E.postcssVersion = new n().version, E;
    }
    let C;
    return Object.defineProperty(S, "postcss", {
      get() {
        return C || (C = S()), C;
      }
    }), S.process = function(I, E, q) {
      return b([S(q)]).process(I, E);
    }, S;
  }, b.stringify = f, b.parse = c, b.fromJSON = h, b.list = d, b.comment = (y) => new t(y), b.atRule = (y) => new e(y), b.decl = (y) => new o(y), b.rule = (y) => new u(y), b.root = (y) => new s(y), b.document = (y) => new l(y), b.CssSyntaxError = a, b.Declaration = o, b.Container = r, b.Processor = n, b.Document = l, b.Comment = t, b.Warning = x, b.AtRule = e, b.Result = i, b.Input = g, b.Rule = u, b.Root = s, b.Node = v, w.registerPostcss(b), zt = b, b.default = b, zt;
}
var He = { exports: {} }, Ze = { exports: {} }, ks = Ze.exports, ti;
function Ds() {
  return ti || (ti = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(ks, (function() {
      var r = 1e3, a = 6e4, o = 36e5, l = "millisecond", h = "second", g = "minute", w = "hour", d = "day", v = "week", c = "month", n = "quarter", i = "year", s = "date", u = "Invalid Date", f = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, x = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(M) {
        var A = ["th", "st", "nd", "rd"], O = M % 100;
        return "[" + M + (A[(O - 20) % 10] || A[O] || A[0]) + "]";
      } }, y = function(M, A, O) {
        var L = String(M);
        return !L || L.length >= A ? M : "" + Array(A + 1 - L.length).join(O) + M;
      }, m = { s: y, z: function(M) {
        var A = -M.utcOffset(), O = Math.abs(A), L = Math.floor(O / 60), D = O % 60;
        return (A <= 0 ? "+" : "-") + y(L, 2, "0") + ":" + y(D, 2, "0");
      }, m: function M(A, O) {
        if (A.date() < O.date()) return -M(O, A);
        var L = 12 * (O.year() - A.year()) + (O.month() - A.month()), D = A.clone().add(L, c), U = O - D < 0, J = A.clone().add(L + (U ? -1 : 1), c);
        return +(-(L + (O - D) / (U ? D - J : J - D)) || 0);
      }, a: function(M) {
        return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
      }, p: function(M) {
        return { M: c, y: i, w: v, d, D: s, h: w, m: g, s: h, ms: l, Q: n }[M] || String(M || "").toLowerCase().replace(/s$/, "");
      }, u: function(M) {
        return M === void 0;
      } }, R = "en", p = {};
      p[R] = b;
      var S = "$isDayjsObject", C = function(M) {
        return M instanceof j || !(!M || !M[S]);
      }, I = function M(A, O, L) {
        var D;
        if (!A) return R;
        if (typeof A == "string") {
          var U = A.toLowerCase();
          p[U] && (D = U), O && (p[U] = O, D = U);
          var J = A.split("-");
          if (!D && J.length > 1) return M(J[0]);
        } else {
          var W = A.name;
          p[W] = A, D = W;
        }
        return !L && D && (R = D), D || !L && R;
      }, E = function(M, A) {
        if (C(M)) return M.clone();
        var O = typeof A == "object" ? A : {};
        return O.date = M, O.args = arguments, new j(O);
      }, q = m;
      q.l = I, q.i = C, q.w = function(M, A) {
        return E(M, { locale: A.$L, utc: A.$u, x: A.$x, $offset: A.$offset });
      };
      var j = (function() {
        function M(O) {
          this.$L = I(O.locale, null, !0), this.parse(O), this.$x = this.$x || O.x || {}, this[S] = !0;
        }
        var A = M.prototype;
        return A.parse = function(O) {
          this.$d = (function(L) {
            var D = L.date, U = L.utc;
            if (D === null) return /* @__PURE__ */ new Date(NaN);
            if (q.u(D)) return /* @__PURE__ */ new Date();
            if (D instanceof Date) return new Date(D);
            if (typeof D == "string" && !/Z$/i.test(D)) {
              var J = D.match(f);
              if (J) {
                var W = J[2] - 1 || 0, G = (J[7] || "0").substring(0, 3);
                return U ? new Date(Date.UTC(J[1], W, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, G)) : new Date(J[1], W, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, G);
              }
            }
            return new Date(D);
          })(O), this.init();
        }, A.init = function() {
          var O = this.$d;
          this.$y = O.getFullYear(), this.$M = O.getMonth(), this.$D = O.getDate(), this.$W = O.getDay(), this.$H = O.getHours(), this.$m = O.getMinutes(), this.$s = O.getSeconds(), this.$ms = O.getMilliseconds();
        }, A.$utils = function() {
          return q;
        }, A.isValid = function() {
          return this.$d.toString() !== u;
        }, A.isSame = function(O, L) {
          var D = E(O);
          return this.startOf(L) <= D && D <= this.endOf(L);
        }, A.isAfter = function(O, L) {
          return E(O) < this.startOf(L);
        }, A.isBefore = function(O, L) {
          return this.endOf(L) < E(O);
        }, A.$g = function(O, L, D) {
          return q.u(O) ? this[L] : this.set(D, O);
        }, A.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, A.valueOf = function() {
          return this.$d.getTime();
        }, A.startOf = function(O, L) {
          var D = this, U = !!q.u(L) || L, J = q.p(O), W = function(be, ie) {
            var pe = q.w(D.$u ? Date.UTC(D.$y, ie, be) : new Date(D.$y, ie, be), D);
            return U ? pe : pe.endOf(d);
          }, G = function(be, ie) {
            return q.w(D.toDate()[be].apply(D.toDate("s"), (U ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ie)), D);
          }, B = this.$W, Q = this.$M, te = this.$D, fe = "set" + (this.$u ? "UTC" : "");
          switch (J) {
            case i:
              return U ? W(1, 0) : W(31, 11);
            case c:
              return U ? W(1, Q) : W(0, Q + 1);
            case v:
              var re = this.$locale().weekStart || 0, de = (B < re ? B + 7 : B) - re;
              return W(U ? te - de : te + (6 - de), Q);
            case d:
            case s:
              return G(fe + "Hours", 0);
            case w:
              return G(fe + "Minutes", 1);
            case g:
              return G(fe + "Seconds", 2);
            case h:
              return G(fe + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, A.endOf = function(O) {
          return this.startOf(O, !1);
        }, A.$set = function(O, L) {
          var D, U = q.p(O), J = "set" + (this.$u ? "UTC" : ""), W = (D = {}, D[d] = J + "Date", D[s] = J + "Date", D[c] = J + "Month", D[i] = J + "FullYear", D[w] = J + "Hours", D[g] = J + "Minutes", D[h] = J + "Seconds", D[l] = J + "Milliseconds", D)[U], G = U === d ? this.$D + (L - this.$W) : L;
          if (U === c || U === i) {
            var B = this.clone().set(s, 1);
            B.$d[W](G), B.init(), this.$d = B.set(s, Math.min(this.$D, B.daysInMonth())).$d;
          } else W && this.$d[W](G);
          return this.init(), this;
        }, A.set = function(O, L) {
          return this.clone().$set(O, L);
        }, A.get = function(O) {
          return this[q.p(O)]();
        }, A.add = function(O, L) {
          var D, U = this;
          O = Number(O);
          var J = q.p(L), W = function(Q) {
            var te = E(U);
            return q.w(te.date(te.date() + Math.round(Q * O)), U);
          };
          if (J === c) return this.set(c, this.$M + O);
          if (J === i) return this.set(i, this.$y + O);
          if (J === d) return W(1);
          if (J === v) return W(7);
          var G = (D = {}, D[g] = a, D[w] = o, D[h] = r, D)[J] || 1, B = this.$d.getTime() + O * G;
          return q.w(B, this);
        }, A.subtract = function(O, L) {
          return this.add(-1 * O, L);
        }, A.format = function(O) {
          var L = this, D = this.$locale();
          if (!this.isValid()) return D.invalidDate || u;
          var U = O || "YYYY-MM-DDTHH:mm:ssZ", J = q.z(this), W = this.$H, G = this.$m, B = this.$M, Q = D.weekdays, te = D.months, fe = D.meridiem, re = function(ie, pe, ce, Re) {
            return ie && (ie[pe] || ie(L, U)) || ce[pe].slice(0, Re);
          }, de = function(ie) {
            return q.s(W % 12 || 12, ie, "0");
          }, be = fe || function(ie, pe, ce) {
            var Re = ie < 12 ? "AM" : "PM";
            return ce ? Re.toLowerCase() : Re;
          };
          return U.replace(x, (function(ie, pe) {
            return pe || (function(ce) {
              switch (ce) {
                case "YY":
                  return String(L.$y).slice(-2);
                case "YYYY":
                  return q.s(L.$y, 4, "0");
                case "M":
                  return B + 1;
                case "MM":
                  return q.s(B + 1, 2, "0");
                case "MMM":
                  return re(D.monthsShort, B, te, 3);
                case "MMMM":
                  return re(te, B);
                case "D":
                  return L.$D;
                case "DD":
                  return q.s(L.$D, 2, "0");
                case "d":
                  return String(L.$W);
                case "dd":
                  return re(D.weekdaysMin, L.$W, Q, 2);
                case "ddd":
                  return re(D.weekdaysShort, L.$W, Q, 3);
                case "dddd":
                  return Q[L.$W];
                case "H":
                  return String(W);
                case "HH":
                  return q.s(W, 2, "0");
                case "h":
                  return de(1);
                case "hh":
                  return de(2);
                case "a":
                  return be(W, G, !0);
                case "A":
                  return be(W, G, !1);
                case "m":
                  return String(G);
                case "mm":
                  return q.s(G, 2, "0");
                case "s":
                  return String(L.$s);
                case "ss":
                  return q.s(L.$s, 2, "0");
                case "SSS":
                  return q.s(L.$ms, 3, "0");
                case "Z":
                  return J;
              }
              return null;
            })(ie) || J.replace(":", "");
          }));
        }, A.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, A.diff = function(O, L, D) {
          var U, J = this, W = q.p(L), G = E(O), B = (G.utcOffset() - this.utcOffset()) * a, Q = this - G, te = function() {
            return q.m(J, G);
          };
          switch (W) {
            case i:
              U = te() / 12;
              break;
            case c:
              U = te();
              break;
            case n:
              U = te() / 3;
              break;
            case v:
              U = (Q - B) / 6048e5;
              break;
            case d:
              U = (Q - B) / 864e5;
              break;
            case w:
              U = Q / o;
              break;
            case g:
              U = Q / a;
              break;
            case h:
              U = Q / r;
              break;
            default:
              U = Q;
          }
          return D ? U : q.a(U);
        }, A.daysInMonth = function() {
          return this.endOf(c).$D;
        }, A.$locale = function() {
          return p[this.$L];
        }, A.locale = function(O, L) {
          if (!O) return this.$L;
          var D = this.clone(), U = I(O, L, !0);
          return U && (D.$L = U), D;
        }, A.clone = function() {
          return q.w(this.$d, this);
        }, A.toDate = function() {
          return new Date(this.valueOf());
        }, A.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, A.toISOString = function() {
          return this.$d.toISOString();
        }, A.toString = function() {
          return this.$d.toUTCString();
        }, M;
      })(), K = j.prototype;
      return E.prototype = K, [["$ms", l], ["$s", h], ["$m", g], ["$H", w], ["$W", d], ["$M", c], ["$y", i], ["$D", s]].forEach((function(M) {
        K[M[1]] = function(A) {
          return this.$g(A, M[0], M[1]);
        };
      })), E.extend = function(M, A) {
        return M.$i || (M(A, j, E), M.$i = !0), E;
      }, E.locale = I, E.isDayjs = C, E.unix = function(M) {
        return E(1e3 * M);
      }, E.en = p[R], E.Ls = p, E.p = {}, E;
    }));
  })(Ze)), Ze.exports;
}
var ri;
function Os() {
  if (ri) return He.exports;
  ri = 1;
  const e = Ds();
  function t(a) {
    for (a = a.replace(/[\x00-\x20]+/g, ""); ; ) {
      const o = a.indexOf("<!--");
      if (o === -1)
        break;
      const l = a.indexOf("-->", o + 4);
      if (l === -1)
        break;
      a = a.substring(0, o) + a.substring(l + 3);
    }
    return a;
  }
  function r(a, o) {
    o = o || {};
    const l = o.allowedSchemes || ["http", "https", "ftp", "mailto", "tel", "sms"], h = o.allowProtocolRelative !== !1;
    if (typeof a != "string")
      return !1;
    a = t(a);
    const g = a.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!g)
      return a.match(/^[/\\]{2}/) ? !h : !1;
    const w = g[1].toLowerCase();
    return l.indexOf(w) === -1;
  }
  return He.exports = function(a) {
    const o = {};
    return o.options = a || {}, o.filterTag = o.options.filterTag || function(l) {
      return l = l.trim(), l.toLowerCase();
    }, o.string = function(l, h) {
      return typeof l != "string" && (typeof l == "number" || typeof l == "boolean" ? l += "" : l = ""), l = l.trim(), h !== void 0 && l === "" && (l = h), l;
    }, o.strings = function(l) {
      return Array.isArray(l) ? l.map(function(h) {
        return o.string(h);
      }) : [];
    }, o.integer = function(l, h, g, w) {
      if (h === void 0 && (h = 0), typeof l == "number")
        l = Math.floor(l);
      else
        try {
          l = parseInt(l, 10), isNaN(l) && (l = h);
        } catch {
          l = h;
        }
      return typeof g == "number" && l < g && (l = g), typeof w == "number" && l > w && (l = w), l;
    }, o.padInteger = function(l, h) {
      let g = l + "";
      for (; g.length < h; )
        g = "0" + g;
      return g;
    }, o.float = function(l, h, g, w) {
      if (h === void 0 && (h = 0), typeof l != "number")
        try {
          l = parseFloat(l, 10), isNaN(l) && (l = h);
        } catch {
          l = h;
        }
      return typeof g == "number" && l < g && (l = g), typeof w == "number" && l > w && (l = w), l;
    }, o.naughtyHref = r, o.url = function(l, h, g) {
      if (l = o.string(l, h), l === h)
        return l;
      if (l = t(l), r(l) || (l = w(l), l === null))
        return h;
      return l;
      function w(d) {
        return d.match(/^(((https?|ftp):\/\/)|((mailto|tel|sms):)|#|([^/.]+)?\/|[^/.]+$)/) ? d : d.match(/^[^/.]+\.[^/.]+/) ? (g ? "https://" : "http://") + d : null;
      }
    }, o.select = function(l, h, g) {
      if (l = o.string(l), !h || !h.length)
        return g;
      let w;
      return typeof h[0] == "object" ? (w = h.find(function(d) {
        return d.value === null || d.value === void 0 ? !1 : d.value.toString() === l;
      }), w != null ? w.value : g) : (w = h.find(function(d) {
        return d == null ? !1 : d.toString() === l;
      }), w !== void 0 ? w : g);
    }, o.boolean = function(l, h) {
      return l === !0 ? !0 : l === !1 ? !1 : (l = o.string(l, h), l === h ? l === void 0 ? !1 : l : (l = l.toLowerCase().charAt(0), l === "" || l === "n" || l === "0" || l === "f" ? !1 : l === "t" || l === "y" || l === "1"));
    }, o.addBooleanFilterToCriteria = function(l, h, g, w) {
      w === void 0 && (w = null);
      let d = typeof l == "object" && l !== null ? l[h] : l;
      d = d === void 0 ? w : d, d = o.booleanOrNull(d), d === null || (d ? g[h] = !0 : g[h] = { $ne: !0 });
    }, o.booleanOrNull = function(l, h) {
      return l === !0 || l === !1 || l === null ? l : (l = o.string(l, h), l === h ? h === void 0 ? null : l : l === "null" ? null : (l = l.toLowerCase().charAt(0), l === "" || l === "n" || l === "0" || l === "f" ? !1 : l === "t" || l === "y" || l === "1" ? !0 : l === "a" ? null : h));
    }, o.date = function(l, h, g) {
      let w;
      function d() {
        return h === void 0 && (h = e().format("YYYY-MM-DD")), h;
      }
      if (typeof l == "string") {
        if (l.match(/\//)) {
          if (w = l.split("/"), w.length === 2)
            return (g || /* @__PURE__ */ new Date()).getFullYear() + "-" + o.padInteger(w[0], 2) + "-" + o.padInteger(w[1], 2);
          if (w.length === 3) {
            if (w[2] < 100) {
              const v = g || /* @__PURE__ */ new Date(), c = v.getFullYear() % 100, n = v.getFullYear() - c;
              let i = parseInt(w[2]) + n;
              i - v.getFullYear() > 50 && (i -= 100), w[2] = i;
            }
            return o.padInteger(w[2], 4) + "-" + o.padInteger(w[0], 2) + "-" + o.padInteger(w[1], 2);
          } else
            return d();
        } else if (l.match(/-/))
          return w = l.split("-"), w.length === 2 ? (g || /* @__PURE__ */ new Date()).getFullYear() + "-" + o.padInteger(w[0], 2) + "-" + o.padInteger(w[1], 2) : w.length === 3 ? o.padInteger(w[0], 4) + "-" + o.padInteger(w[1], 2) + "-" + o.padInteger(w[2], 2) : d();
      }
      try {
        return l === null || (l = g || new Date(l), isNaN(l.getTime())) ? d() : l.getFullYear() + "-" + o.padInteger(l.getMonth() + 1, 2) + "-" + o.padInteger(l.getDate(), 2);
      } catch {
        return d();
      }
    }, o.formatDate = function(l) {
      return e(l).format("YYYY-MM-DD");
    }, o.time = function(l, h) {
      l = o.string(l).toLowerCase(), l = l.trim();
      const g = l.match(/^(\d+)([:|.](\d+))?([:|.](\d+))?\s*(am|pm|AM|PM|a|p|A|M)?$/);
      if (g) {
        let w = parseInt(g[1], 10);
        const d = g[3] !== void 0 ? parseInt(g[3], 10) : 0, v = g[5] !== void 0 ? parseInt(g[5], 10) : 0;
        let c = g[6] ? g[6].toLowerCase() : g[6];
        return c = c && c.charAt(0), w === 12 && c === "a" ? w -= 12 : w === 12 && c === "p" || c === "p" && (w += 12), (w === 24 || w === "24") && (w = 0), o.padInteger(w, 2) + ":" + o.padInteger(d, 2) + ":" + o.padInteger(v, 2);
      } else
        return h !== void 0 ? h : e().format("HH:mm");
    }, o.formatTime = function(l) {
      return e(l).format("HH:mm:ss");
    }, o.tags = function(l, h) {
      return typeof l == "string" && (l = l.split(/,\s*/)), Array.isArray(l) ? l.map((v) => o.string(v)).map(h || o.filterTag).filter((v) => v.length > 0) : [];
    }, o.idRegExp = o.options.idRegExp || /^[A-Za-z0-9_]+$/, o.id = function(l, h) {
      const g = o.string(l, h);
      return g === h || g.match(o.idRegExp) ? g : h;
    }, o.ids = function(l) {
      return Array.isArray(l) ? l.filter(function(g) {
        return o.id(g) !== void 0;
      }) : [];
    }, o;
  }, He.exports.naughtyHref = r, He.exports;
}
var Ft, ii;
function Ls() {
  if (ii) return Ft;
  ii = 1;
  const e = gs, t = ms(), { isPlainObject: r } = bs(), a = ws(), o = ys(), { parse: l } = Cs(), { naughtyHref: h } = Os(), g = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], w = ["script", "style"], d = [
    "animate",
    "animatecolor",
    "animatemotion",
    "animatetransform",
    "set"
  ], v = ["href"];
  function c(y, m) {
    y && Object.keys(y).forEach(function(R) {
      m(y[R], R);
    });
  }
  function n(y, m) {
    return {}.hasOwnProperty.call(y, m);
  }
  function i(y, m) {
    const R = [];
    return c(y, function(p) {
      m(p) && R.push(p);
    }), R;
  }
  function s(y) {
    for (const m in y)
      if (n(y, m))
        return !1;
    return !0;
  }
  function u(y) {
    return y.map(function(m) {
      if (!m.url)
        throw new Error("URL missing");
      return m.url + (m.w ? ` ${m.w}w` : "") + (m.h ? ` ${m.h}h` : "") + (m.d ? ` ${m.d}x` : "");
    }).join(", ");
  }
  Ft = x;
  const f = /^[^\0\t\n\f\r /<=>]+$/;
  function x(y, m, R) {
    if (y == null)
      return "";
    typeof y == "number" && (y = y.toString());
    let p = "", S = "";
    function C(N, P) {
      const k = this;
      this.tag = N, this.attribs = P || {}, this.tagPosition = p.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (U.length) {
          const V = U[U.length - 1];
          V.text += k.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        U.length && g.includes(this.tag) && U[U.length - 1].mediaChildren.push(this.tag);
      };
    }
    m = Object.assign({}, x.defaults, m), m.parser = Object.assign({}, b, m.parser);
    const I = function(N) {
      return m.allowedTags === !1 || (m.allowedTags || []).indexOf(N) > -1;
    };
    w.forEach(function(N) {
      I(N) && !m.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${N}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const E = m.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option",
      "xmp"
    ];
    let q, j;
    m.allowedAttributes && (q = {}, j = {}, c(m.allowedAttributes, function(N, P) {
      q[P] = [];
      const k = [];
      N.forEach(function(V) {
        typeof V == "string" && V.indexOf("*") >= 0 ? k.push(t(V).replace(/\\\*/g, ".*")) : q[P].push(V);
      }), k.length && (j[P] = new RegExp("^(" + k.join("|") + ")$"));
    }));
    const K = {}, M = {}, A = {};
    c(m.allowedClasses, function(N, P) {
      if (q && (n(q, P) || (q[P] = []), q[P].push("class")), K[P] = N, Array.isArray(N)) {
        const k = [];
        K[P] = [], A[P] = [], N.forEach(function(V) {
          typeof V == "string" && V.indexOf("*") >= 0 ? k.push(t(V).replace(/\\\*/g, ".*")) : V instanceof RegExp ? A[P].push(V) : K[P].push(V);
        }), k.length && (M[P] = new RegExp("^(" + k.join("|") + ")$"));
      }
    });
    const O = {};
    let L;
    c(m.transformTags, function(N, P) {
      let k;
      typeof N == "function" ? k = N : typeof N == "string" && (k = x.simpleTransform(N)), P === "*" ? L = k : O[P] = k;
    });
    let D, U, J, W, G, B, Q = !1;
    fe();
    const te = new e.Parser({
      onopentag: function(N, P) {
        if (m.onOpenTag && m.onOpenTag(N, P), m.enforceHtmlBoundary && N === "html" && fe(), G) {
          B++;
          return;
        }
        const k = new C(N, P);
        U.push(k);
        let V = !1;
        const ne = !!k.text;
        let ue;
        if (n(O, N) && (ue = O[N](N, P), k.attribs = P = ue.attribs, ue.text !== void 0 && (k.innerText = ue.text), N !== ue.tagName && (k.name = N = ue.tagName, W[D] = ue.tagName)), L && (ue = L(N, P), k.attribs = P = ue.attribs, N !== ue.tagName && (k.name = N = ue.tagName, W[D] = ue.tagName)), (!I(N) || be(N, P) || m.disallowedTagsMode === "recursiveEscape" && !s(J) || m.nestingLimit != null && D >= m.nestingLimit) && (V = !0, J[D] = !0, (m.disallowedTagsMode === "discard" || m.disallowedTagsMode === "completelyDiscard") && E.indexOf(N) !== -1 && (G = !0, B = 1)), D++, V) {
          if (m.disallowedTagsMode === "discard" || m.disallowedTagsMode === "completelyDiscard") {
            if (k.innerText && !ne) {
              const $ = re(k.innerText);
              m.textFilter ? p += m.textFilter($, N) : p += $, Q = !0;
            }
            return;
          }
          S = p, p = "";
        }
        if (p += "<" + N, N === "script" && (m.allowedScriptHostnames || m.allowedScriptDomains) && (k.innerText = ""), V && (m.disallowedTagsMode === "escape" || m.disallowedTagsMode === "recursiveEscape") && m.preserveEscapedAttributes ? c(P, function($, H) {
          p += " " + H + '="' + re($ || "", !0) + '"';
        }) : (!q || n(q, N) || q["*"]) && c(P, function($, H) {
          if (!f.test(H)) {
            delete k.attribs[H];
            return;
          }
          if ($ === "" && !m.allowedEmptyAttributes.includes(H) && (m.nonBooleanAttributes.includes(H) || m.nonBooleanAttributes.includes("*"))) {
            delete k.attribs[H];
            return;
          }
          let ct = !1;
          if (!q || n(q, N) && q[N].indexOf(H) !== -1 || q["*"] && q["*"].indexOf(H) !== -1 || n(j, N) && j[N].test(H) || j["*"] && j["*"].test(H))
            ct = !0;
          else if (q && q[N]) {
            for (const Z of q[N])
              if (r(Z) && Z.name && Z.name === H) {
                ct = !0;
                let X = "";
                if (Z.multiple === !0) {
                  const qe = $.split(" ");
                  for (const Te of qe)
                    Z.values.indexOf(Te) !== -1 && (X === "" ? X = Te : X += " " + Te);
                } else Z.values.indexOf($) >= 0 && (X = $);
                $ = X;
              }
          }
          if (ct) {
            if (m.allowedSchemesAppliedToAttributes.indexOf(H) !== -1 && de(N, $)) {
              delete k.attribs[H];
              return;
            }
            if (N === "script" && H === "src") {
              let Z = !0;
              try {
                const X = ie($);
                if (m.allowedScriptHostnames || m.allowedScriptDomains) {
                  const qe = (m.allowedScriptHostnames || []).find(function(we) {
                    return we === X.url.hostname;
                  }), Te = (m.allowedScriptDomains || []).find(function(we) {
                    return X.url.hostname === we || X.url.hostname.endsWith(`.${we}`);
                  });
                  Z = qe || Te;
                }
              } catch {
                Z = !1;
              }
              if (!Z) {
                delete k.attribs[H];
                return;
              }
            }
            if (N === "iframe" && H === "src") {
              let Z = !0;
              try {
                const X = ie($);
                if (X.isRelativeUrl)
                  Z = n(m, "allowIframeRelativeUrls") ? m.allowIframeRelativeUrls : !m.allowedIframeHostnames && !m.allowedIframeDomains;
                else if (m.allowedIframeHostnames || m.allowedIframeDomains) {
                  const qe = (m.allowedIframeHostnames || []).find(function(we) {
                    return we === X.url.hostname;
                  }), Te = (m.allowedIframeDomains || []).find(function(we) {
                    return X.url.hostname === we || X.url.hostname.endsWith(`.${we}`);
                  });
                  Z = qe || Te;
                }
              } catch {
                Z = !1;
              }
              if (!Z) {
                delete k.attribs[H];
                return;
              }
            }
            if (H === "srcset" || H === "imagesrcset")
              try {
                let Z = o($);
                if (Z.forEach(function(X) {
                  de(H, X.url) && (X.evil = !0);
                }), Z = i(Z, function(X) {
                  return !X.evil;
                }), Z.length)
                  $ = u(i(Z, function(X) {
                    return !X.evil;
                  })), k.attribs[H] = $;
                else {
                  delete k.attribs[H];
                  return;
                }
              } catch {
                delete k.attribs[H];
                return;
              }
            if (H === "class") {
              const Z = K[N], X = K["*"], qe = M[N], Te = A[N], we = A["*"], Ki = M["*"], hr = [
                qe,
                Ki
              ].concat(Te, we).filter(function(Qi) {
                return Qi;
              });
              if (Z && X ? $ = _e(
                $,
                a(Z, X),
                hr
              ) : $ = _e(
                $,
                Z || X,
                hr
              ), !$.length) {
                delete k.attribs[H];
                return;
              }
            }
            if (H === "style") {
              if (m.parseStyleAttributes)
                try {
                  const Z = l(N + " {" + $ + "}", { map: !1 }), X = pe(
                    Z,
                    m.allowedStyles
                  );
                  if ($ = ce(X), $.length === 0) {
                    delete k.attribs[H];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + N + " {" + $ + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete k.attribs[H];
                  return;
                }
              else if (m.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            p += " " + H, $ && $.length ? p += '="' + re($, !0) + '"' : m.allowedEmptyAttributes.includes(H) && (p += '=""');
          } else
            delete k.attribs[H];
        }), m.selfClosing.indexOf(N) !== -1)
          p += " />";
        else if (p += ">", k.innerText && !ne) {
          const $ = re(k.innerText);
          m.textFilter ? p += m.textFilter($, N) : p += $, Q = !0;
        }
        V && (p = S + re(p), S = ""), k.openingTagLength = p.length - k.tagPosition;
      },
      ontext: function(N) {
        if (G)
          return;
        const P = U[U.length - 1];
        let k;
        if (P && (k = P.tag, N = P.innerText !== void 0 ? P.innerText : N), m.disallowedTagsMode === "completelyDiscard" && !I(k))
          N = "";
        else if (k && I(k) && (m.disallowedTagsMode === "discard" || m.disallowedTagsMode === "completelyDiscard") && (k === "script" || k === "style"))
          p += N;
        else if (k && I(k) && (m.disallowedTagsMode === "discard" || m.disallowedTagsMode === "completelyDiscard") && (k === "textarea" || k === "xmp"))
          k === "xmp" ? p += N.replace(/</g, "&lt;").replace(/>/g, "&gt;") : p += re(N, !1);
        else if (!Q) {
          const V = re(N, !1);
          m.textFilter ? p += m.textFilter(V, k) : p += V;
        }
        if (U.length) {
          const V = U[U.length - 1];
          V.text += N;
        }
      },
      onclosetag: function(N, P) {
        if (m.onCloseTag && m.onCloseTag(N, P), G)
          if (B--, !B)
            G = !1;
          else
            return;
        const k = U.pop();
        if (!k)
          return;
        if (k.tag !== N) {
          U.push(k);
          return;
        }
        G = m.enforceHtmlBoundary ? N === "html" : !1, D--;
        const V = J[D];
        if (V) {
          if (delete J[D], m.disallowedTagsMode === "discard" || m.disallowedTagsMode === "completelyDiscard") {
            k.updateParentNodeText();
            return;
          }
          S = p, p = "";
        }
        if (W[D] && (N = W[D], delete W[D]), m.exclusiveFilter) {
          const ne = m.exclusiveFilter(k);
          if (ne === "excludeTag") {
            V && (p = S, S = ""), p = p.substring(0, k.tagPosition) + p.substring(k.tagPosition + k.openingTagLength);
            return;
          } else if (ne) {
            p = p.substring(0, k.tagPosition);
            return;
          }
        }
        if (k.updateParentNodeMediaChildren(), k.updateParentNodeText(), // Already output />
        m.selfClosing.indexOf(N) !== -1 || // Escaped tag, closing tag is implied
        P && !I(N) && ["escape", "recursiveEscape"].indexOf(m.disallowedTagsMode) >= 0) {
          V && (p = S, S = "");
          return;
        }
        p += "</" + N + ">", V && (p = S + re(p), S = ""), Q = !1;
      }
    }, m.parser);
    if (te.write(y), te.end(), m.disallowedTagsMode === "escape" || m.disallowedTagsMode === "recursiveEscape") {
      const N = te.endIndex;
      if (N != null && N >= 0 && N < y.length) {
        const P = y.substring(N);
        p += re(P);
      } else (N == null || N < 0) && y.length > 0 && p === "" && (p = re(y));
    }
    return p;
    function fe() {
      p = "", D = 0, U = [], J = {}, W = {}, G = !1, B = 0;
    }
    function re(N, P) {
      return typeof N != "string" && (N = N + ""), m.parser.decodeEntities && (N = N.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), P && (N = N.replace(/"/g, "&quot;"))), N = N.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), P && (N = N.replace(/"/g, "&quot;")), N;
    }
    function de(N, P) {
      const k = n(m.allowedSchemesByTag, N) ? m.allowedSchemesByTag[N] : m.allowedSchemes || [];
      return h(P, {
        allowedSchemes: k,
        allowProtocolRelative: m.allowProtocolRelative
      });
    }
    function be(N, P) {
      if (d.indexOf(N.toLowerCase()) === -1)
        return !1;
      const k = m.allowedSchemesAppliedToAttributes || [];
      return Object.keys(P || {}).some(function(V) {
        if (V.toLowerCase() !== "attributename")
          return !1;
        const ne = (P[V] || "").trim().toLowerCase(), ue = ne.slice(ne.lastIndexOf(":") + 1);
        return v.indexOf(ue) !== -1 || k.indexOf(ne) !== -1 || k.indexOf(ue) !== -1;
      });
    }
    function ie(N) {
      if (N = N.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), N.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let P = "relative://relative-site";
      for (let ne = 0; ne < 100; ne++)
        P += `/${ne}`;
      const k = new URL(N, P);
      return {
        isRelativeUrl: k && k.hostname === "relative-site" && k.protocol === "relative:",
        url: k
      };
    }
    function pe(N, P) {
      if (!P)
        return N;
      const k = N.nodes[0];
      let V;
      return P[k.selector] && P["*"] ? V = a(
        P[k.selector],
        P["*"]
      ) : V = P[k.selector] || P["*"], V && (N.nodes[0].nodes = k.nodes.reduce(Re(V), [])), N;
    }
    function ce(N) {
      return N.nodes[0].nodes.reduce(function(P, k) {
        return P.push(
          `${k.prop}:${k.value}${k.important ? " !important" : ""}`
        ), P;
      }, []).join(";");
    }
    function Re(N) {
      return function(P, k) {
        return n(N, k.prop) && N[k.prop].some(function(ne) {
          return ne.test(k.value);
        }) && P.push(k), P;
      };
    }
    function _e(N, P, k) {
      return P ? (N = N.split(/\s+/), N.filter(function(V) {
        return P.indexOf(V) !== -1 || k.some(function(ne) {
          return ne.test(V);
        });
      }).join(" ")) : N;
    }
  }
  const b = {
    decodeEntities: !0
  };
  return x.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta", "col"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
      "href",
      "src",
      "cite",
      "action",
      "formaction",
      "data",
      "xlink:href",
      "poster",
      "background",
      "ping",
      "longdesc",
      "usemap",
      "codebase",
      "classid",
      "archive",
      "profile",
      "manifest",
      "itemid",
      "dynsrc",
      "lowsrc"
    ],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, x.simpleTransform = function(y, m, R) {
    return R = R === void 0 ? !0 : R, m = m || {}, function(p, S) {
      let C;
      if (R)
        for (C in m)
          S[C] = m[C];
      else
        S = m;
      return {
        tagName: y,
        attribs: S
      };
    };
  }, Ft;
}
var Bs = /* @__PURE__ */ Ls();
const Ms = /* @__PURE__ */ tn(Bs), rt = ({ value: e, as: t = "span", ...r }) => {
  const a = t, o = en(() => e ? Ms(e) : "", [e]);
  return /* @__PURE__ */ z(a, { dangerouslySetInnerHTML: { __html: o }, ...r });
};
var Be = function() {
  return Be = Object.assign || function(e) {
    for (var t, r = 1, a = arguments.length; r < a; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Be.apply(this, arguments);
}, Ps = "~", Us = "~~";
function ur(e, t) {
  for (var r = {}, a = {}, o = e.split(Us), l = !1, h = 0; o.length > h; h++) {
    for (var g = o[h].split(Ps), w = 0; w < g.length; w += 2) {
      var d = g[w], v = g[w + 1], c = "&" + d + ";";
      r[c] = v, l && (r["&" + d] = v), a[v] = c;
    }
    l = !0;
  }
  return t ? { entities: Be(Be({}, r), t.entities), characters: Be(Be({}, a), t.characters) } : { entities: r, characters: a };
}
var Vt = {
  xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
}, Pe = {};
Pe.xml = ur(`lt~<~gt~>~quot~"~apos~'~amp~&`);
Pe.html4 = ur(`apos~'~OElig~Œ~oelig~œ~Scaron~Š~scaron~š~Yuml~Ÿ~circ~ˆ~tilde~˜~ensp~ ~emsp~ ~thinsp~ ~zwnj~‌~zwj~‍~lrm~‎~rlm~‏~ndash~–~mdash~—~lsquo~‘~rsquo~’~sbquo~‚~ldquo~“~rdquo~”~bdquo~„~dagger~†~Dagger~‡~permil~‰~lsaquo~‹~rsaquo~›~euro~€~fnof~ƒ~Alpha~Α~Beta~Β~Gamma~Γ~Delta~Δ~Epsilon~Ε~Zeta~Ζ~Eta~Η~Theta~Θ~Iota~Ι~Kappa~Κ~Lambda~Λ~Mu~Μ~Nu~Ν~Xi~Ξ~Omicron~Ο~Pi~Π~Rho~Ρ~Sigma~Σ~Tau~Τ~Upsilon~Υ~Phi~Φ~Chi~Χ~Psi~Ψ~Omega~Ω~alpha~α~beta~β~gamma~γ~delta~δ~epsilon~ε~zeta~ζ~eta~η~theta~θ~iota~ι~kappa~κ~lambda~λ~mu~μ~nu~ν~xi~ξ~omicron~ο~pi~π~rho~ρ~sigmaf~ς~sigma~σ~tau~τ~upsilon~υ~phi~φ~chi~χ~psi~ψ~omega~ω~thetasym~ϑ~upsih~ϒ~piv~ϖ~bull~•~hellip~…~prime~′~Prime~″~oline~‾~frasl~⁄~weierp~℘~image~ℑ~real~ℜ~trade~™~alefsym~ℵ~larr~←~uarr~↑~rarr~→~darr~↓~harr~↔~crarr~↵~lArr~⇐~uArr~⇑~rArr~⇒~dArr~⇓~hArr~⇔~forall~∀~part~∂~exist~∃~empty~∅~nabla~∇~isin~∈~notin~∉~ni~∋~prod~∏~sum~∑~minus~−~lowast~∗~radic~√~prop~∝~infin~∞~ang~∠~and~∧~or~∨~cap~∩~cup~∪~int~∫~there4~∴~sim~∼~cong~≅~asymp~≈~ne~≠~equiv~≡~le~≤~ge~≥~sub~⊂~sup~⊃~nsub~⊄~sube~⊆~supe~⊇~oplus~⊕~otimes~⊗~perp~⊥~sdot~⋅~lceil~⌈~rceil~⌉~lfloor~⌊~rfloor~⌋~lang~〈~rang~〉~loz~◊~spades~♠~clubs~♣~hearts~♥~diams~♦~~nbsp~ ~iexcl~¡~cent~¢~pound~£~curren~¤~yen~¥~brvbar~¦~sect~§~uml~¨~copy~©~ordf~ª~laquo~«~not~¬~shy~­~reg~®~macr~¯~deg~°~plusmn~±~sup2~²~sup3~³~acute~´~micro~µ~para~¶~middot~·~cedil~¸~sup1~¹~ordm~º~raquo~»~frac14~¼~frac12~½~frac34~¾~iquest~¿~Agrave~À~Aacute~Á~Acirc~Â~Atilde~Ã~Auml~Ä~Aring~Å~AElig~Æ~Ccedil~Ç~Egrave~È~Eacute~É~Ecirc~Ê~Euml~Ë~Igrave~Ì~Iacute~Í~Icirc~Î~Iuml~Ï~ETH~Ð~Ntilde~Ñ~Ograve~Ò~Oacute~Ó~Ocirc~Ô~Otilde~Õ~Ouml~Ö~times~×~Oslash~Ø~Ugrave~Ù~Uacute~Ú~Ucirc~Û~Uuml~Ü~Yacute~Ý~THORN~Þ~szlig~ß~agrave~à~aacute~á~acirc~â~atilde~ã~auml~ä~aring~å~aelig~æ~ccedil~ç~egrave~è~eacute~é~ecirc~ê~euml~ë~igrave~ì~iacute~í~icirc~î~iuml~ï~eth~ð~ntilde~ñ~ograve~ò~oacute~ó~ocirc~ô~otilde~õ~ouml~ö~divide~÷~oslash~ø~ugrave~ù~uacute~ú~ucirc~û~uuml~ü~yacute~ý~thorn~þ~yuml~ÿ~quot~"~amp~&~lt~<~gt~>`);
Pe.html5 = ur('Abreve~Ă~Acy~А~Afr~𝔄~Amacr~Ā~And~⩓~Aogon~Ą~Aopf~𝔸~ApplyFunction~⁡~Ascr~𝒜~Assign~≔~Backslash~∖~Barv~⫧~Barwed~⌆~Bcy~Б~Because~∵~Bernoullis~ℬ~Bfr~𝔅~Bopf~𝔹~Breve~˘~Bscr~ℬ~Bumpeq~≎~CHcy~Ч~Cacute~Ć~Cap~⋒~CapitalDifferentialD~ⅅ~Cayleys~ℭ~Ccaron~Č~Ccirc~Ĉ~Cconint~∰~Cdot~Ċ~Cedilla~¸~CenterDot~·~Cfr~ℭ~CircleDot~⊙~CircleMinus~⊖~CirclePlus~⊕~CircleTimes~⊗~ClockwiseContourIntegral~∲~CloseCurlyDoubleQuote~”~CloseCurlyQuote~’~Colon~∷~Colone~⩴~Congruent~≡~Conint~∯~ContourIntegral~∮~Copf~ℂ~Coproduct~∐~CounterClockwiseContourIntegral~∳~Cross~⨯~Cscr~𝒞~Cup~⋓~CupCap~≍~DD~ⅅ~DDotrahd~⤑~DJcy~Ђ~DScy~Ѕ~DZcy~Џ~Darr~↡~Dashv~⫤~Dcaron~Ď~Dcy~Д~Del~∇~Dfr~𝔇~DiacriticalAcute~´~DiacriticalDot~˙~DiacriticalDoubleAcute~˝~DiacriticalGrave~`~DiacriticalTilde~˜~Diamond~⋄~DifferentialD~ⅆ~Dopf~𝔻~Dot~¨~DotDot~⃜~DotEqual~≐~DoubleContourIntegral~∯~DoubleDot~¨~DoubleDownArrow~⇓~DoubleLeftArrow~⇐~DoubleLeftRightArrow~⇔~DoubleLeftTee~⫤~DoubleLongLeftArrow~⟸~DoubleLongLeftRightArrow~⟺~DoubleLongRightArrow~⟹~DoubleRightArrow~⇒~DoubleRightTee~⊨~DoubleUpArrow~⇑~DoubleUpDownArrow~⇕~DoubleVerticalBar~∥~DownArrow~↓~DownArrowBar~⤓~DownArrowUpArrow~⇵~DownBreve~̑~DownLeftRightVector~⥐~DownLeftTeeVector~⥞~DownLeftVector~↽~DownLeftVectorBar~⥖~DownRightTeeVector~⥟~DownRightVector~⇁~DownRightVectorBar~⥗~DownTee~⊤~DownTeeArrow~↧~Downarrow~⇓~Dscr~𝒟~Dstrok~Đ~ENG~Ŋ~Ecaron~Ě~Ecy~Э~Edot~Ė~Efr~𝔈~Element~∈~Emacr~Ē~EmptySmallSquare~◻~EmptyVerySmallSquare~▫~Eogon~Ę~Eopf~𝔼~Equal~⩵~EqualTilde~≂~Equilibrium~⇌~Escr~ℰ~Esim~⩳~Exists~∃~ExponentialE~ⅇ~Fcy~Ф~Ffr~𝔉~FilledSmallSquare~◼~FilledVerySmallSquare~▪~Fopf~𝔽~ForAll~∀~Fouriertrf~ℱ~Fscr~ℱ~GJcy~Ѓ~Gammad~Ϝ~Gbreve~Ğ~Gcedil~Ģ~Gcirc~Ĝ~Gcy~Г~Gdot~Ġ~Gfr~𝔊~Gg~⋙~Gopf~𝔾~GreaterEqual~≥~GreaterEqualLess~⋛~GreaterFullEqual~≧~GreaterGreater~⪢~GreaterLess~≷~GreaterSlantEqual~⩾~GreaterTilde~≳~Gscr~𝒢~Gt~≫~HARDcy~Ъ~Hacek~ˇ~Hat~^~Hcirc~Ĥ~Hfr~ℌ~HilbertSpace~ℋ~Hopf~ℍ~HorizontalLine~─~Hscr~ℋ~Hstrok~Ħ~HumpDownHump~≎~HumpEqual~≏~IEcy~Е~IJlig~Ĳ~IOcy~Ё~Icy~И~Idot~İ~Ifr~ℑ~Im~ℑ~Imacr~Ī~ImaginaryI~ⅈ~Implies~⇒~Int~∬~Integral~∫~Intersection~⋂~InvisibleComma~⁣~InvisibleTimes~⁢~Iogon~Į~Iopf~𝕀~Iscr~ℐ~Itilde~Ĩ~Iukcy~І~Jcirc~Ĵ~Jcy~Й~Jfr~𝔍~Jopf~𝕁~Jscr~𝒥~Jsercy~Ј~Jukcy~Є~KHcy~Х~KJcy~Ќ~Kcedil~Ķ~Kcy~К~Kfr~𝔎~Kopf~𝕂~Kscr~𝒦~LJcy~Љ~Lacute~Ĺ~Lang~⟪~Laplacetrf~ℒ~Larr~↞~Lcaron~Ľ~Lcedil~Ļ~Lcy~Л~LeftAngleBracket~⟨~LeftArrow~←~LeftArrowBar~⇤~LeftArrowRightArrow~⇆~LeftCeiling~⌈~LeftDoubleBracket~⟦~LeftDownTeeVector~⥡~LeftDownVector~⇃~LeftDownVectorBar~⥙~LeftFloor~⌊~LeftRightArrow~↔~LeftRightVector~⥎~LeftTee~⊣~LeftTeeArrow~↤~LeftTeeVector~⥚~LeftTriangle~⊲~LeftTriangleBar~⧏~LeftTriangleEqual~⊴~LeftUpDownVector~⥑~LeftUpTeeVector~⥠~LeftUpVector~↿~LeftUpVectorBar~⥘~LeftVector~↼~LeftVectorBar~⥒~Leftarrow~⇐~Leftrightarrow~⇔~LessEqualGreater~⋚~LessFullEqual~≦~LessGreater~≶~LessLess~⪡~LessSlantEqual~⩽~LessTilde~≲~Lfr~𝔏~Ll~⋘~Lleftarrow~⇚~Lmidot~Ŀ~LongLeftArrow~⟵~LongLeftRightArrow~⟷~LongRightArrow~⟶~Longleftarrow~⟸~Longleftrightarrow~⟺~Longrightarrow~⟹~Lopf~𝕃~LowerLeftArrow~↙~LowerRightArrow~↘~Lscr~ℒ~Lsh~↰~Lstrok~Ł~Lt~≪~Map~⤅~Mcy~М~MediumSpace~ ~Mellintrf~ℳ~Mfr~𝔐~MinusPlus~∓~Mopf~𝕄~Mscr~ℳ~NJcy~Њ~Nacute~Ń~Ncaron~Ň~Ncedil~Ņ~Ncy~Н~NegativeMediumSpace~​~NegativeThickSpace~​~NegativeThinSpace~​~NegativeVeryThinSpace~​~NestedGreaterGreater~≫~NestedLessLess~≪~NewLine~\n~Nfr~𝔑~NoBreak~⁠~NonBreakingSpace~ ~Nopf~ℕ~Not~⫬~NotCongruent~≢~NotCupCap~≭~NotDoubleVerticalBar~∦~NotElement~∉~NotEqual~≠~NotEqualTilde~≂̸~NotExists~∄~NotGreater~≯~NotGreaterEqual~≱~NotGreaterFullEqual~≧̸~NotGreaterGreater~≫̸~NotGreaterLess~≹~NotGreaterSlantEqual~⩾̸~NotGreaterTilde~≵~NotHumpDownHump~≎̸~NotHumpEqual~≏̸~NotLeftTriangle~⋪~NotLeftTriangleBar~⧏̸~NotLeftTriangleEqual~⋬~NotLess~≮~NotLessEqual~≰~NotLessGreater~≸~NotLessLess~≪̸~NotLessSlantEqual~⩽̸~NotLessTilde~≴~NotNestedGreaterGreater~⪢̸~NotNestedLessLess~⪡̸~NotPrecedes~⊀~NotPrecedesEqual~⪯̸~NotPrecedesSlantEqual~⋠~NotReverseElement~∌~NotRightTriangle~⋫~NotRightTriangleBar~⧐̸~NotRightTriangleEqual~⋭~NotSquareSubset~⊏̸~NotSquareSubsetEqual~⋢~NotSquareSuperset~⊐̸~NotSquareSupersetEqual~⋣~NotSubset~⊂⃒~NotSubsetEqual~⊈~NotSucceeds~⊁~NotSucceedsEqual~⪰̸~NotSucceedsSlantEqual~⋡~NotSucceedsTilde~≿̸~NotSuperset~⊃⃒~NotSupersetEqual~⊉~NotTilde~≁~NotTildeEqual~≄~NotTildeFullEqual~≇~NotTildeTilde~≉~NotVerticalBar~∤~Nscr~𝒩~Ocy~О~Odblac~Ő~Ofr~𝔒~Omacr~Ō~Oopf~𝕆~OpenCurlyDoubleQuote~“~OpenCurlyQuote~‘~Or~⩔~Oscr~𝒪~Otimes~⨷~OverBar~‾~OverBrace~⏞~OverBracket~⎴~OverParenthesis~⏜~PartialD~∂~Pcy~П~Pfr~𝔓~PlusMinus~±~Poincareplane~ℌ~Popf~ℙ~Pr~⪻~Precedes~≺~PrecedesEqual~⪯~PrecedesSlantEqual~≼~PrecedesTilde~≾~Product~∏~Proportion~∷~Proportional~∝~Pscr~𝒫~Qfr~𝔔~Qopf~ℚ~Qscr~𝒬~RBarr~⤐~Racute~Ŕ~Rang~⟫~Rarr~↠~Rarrtl~⤖~Rcaron~Ř~Rcedil~Ŗ~Rcy~Р~Re~ℜ~ReverseElement~∋~ReverseEquilibrium~⇋~ReverseUpEquilibrium~⥯~Rfr~ℜ~RightAngleBracket~⟩~RightArrow~→~RightArrowBar~⇥~RightArrowLeftArrow~⇄~RightCeiling~⌉~RightDoubleBracket~⟧~RightDownTeeVector~⥝~RightDownVector~⇂~RightDownVectorBar~⥕~RightFloor~⌋~RightTee~⊢~RightTeeArrow~↦~RightTeeVector~⥛~RightTriangle~⊳~RightTriangleBar~⧐~RightTriangleEqual~⊵~RightUpDownVector~⥏~RightUpTeeVector~⥜~RightUpVector~↾~RightUpVectorBar~⥔~RightVector~⇀~RightVectorBar~⥓~Rightarrow~⇒~Ropf~ℝ~RoundImplies~⥰~Rrightarrow~⇛~Rscr~ℛ~Rsh~↱~RuleDelayed~⧴~SHCHcy~Щ~SHcy~Ш~SOFTcy~Ь~Sacute~Ś~Sc~⪼~Scedil~Ş~Scirc~Ŝ~Scy~С~Sfr~𝔖~ShortDownArrow~↓~ShortLeftArrow~←~ShortRightArrow~→~ShortUpArrow~↑~SmallCircle~∘~Sopf~𝕊~Sqrt~√~Square~□~SquareIntersection~⊓~SquareSubset~⊏~SquareSubsetEqual~⊑~SquareSuperset~⊐~SquareSupersetEqual~⊒~SquareUnion~⊔~Sscr~𝒮~Star~⋆~Sub~⋐~Subset~⋐~SubsetEqual~⊆~Succeeds~≻~SucceedsEqual~⪰~SucceedsSlantEqual~≽~SucceedsTilde~≿~SuchThat~∋~Sum~∑~Sup~⋑~Superset~⊃~SupersetEqual~⊇~Supset~⋑~TRADE~™~TSHcy~Ћ~TScy~Ц~Tab~	~Tcaron~Ť~Tcedil~Ţ~Tcy~Т~Tfr~𝔗~Therefore~∴~ThickSpace~  ~ThinSpace~ ~Tilde~∼~TildeEqual~≃~TildeFullEqual~≅~TildeTilde~≈~Topf~𝕋~TripleDot~⃛~Tscr~𝒯~Tstrok~Ŧ~Uarr~↟~Uarrocir~⥉~Ubrcy~Ў~Ubreve~Ŭ~Ucy~У~Udblac~Ű~Ufr~𝔘~Umacr~Ū~UnderBar~_~UnderBrace~⏟~UnderBracket~⎵~UnderParenthesis~⏝~Union~⋃~UnionPlus~⊎~Uogon~Ų~Uopf~𝕌~UpArrow~↑~UpArrowBar~⤒~UpArrowDownArrow~⇅~UpDownArrow~↕~UpEquilibrium~⥮~UpTee~⊥~UpTeeArrow~↥~Uparrow~⇑~Updownarrow~⇕~UpperLeftArrow~↖~UpperRightArrow~↗~Upsi~ϒ~Uring~Ů~Uscr~𝒰~Utilde~Ũ~VDash~⊫~Vbar~⫫~Vcy~В~Vdash~⊩~Vdashl~⫦~Vee~⋁~Verbar~‖~Vert~‖~VerticalBar~∣~VerticalLine~|~VerticalSeparator~❘~VerticalTilde~≀~VeryThinSpace~ ~Vfr~𝔙~Vopf~𝕍~Vscr~𝒱~Vvdash~⊪~Wcirc~Ŵ~Wedge~⋀~Wfr~𝔚~Wopf~𝕎~Wscr~𝒲~Xfr~𝔛~Xopf~𝕏~Xscr~𝒳~YAcy~Я~YIcy~Ї~YUcy~Ю~Ycirc~Ŷ~Ycy~Ы~Yfr~𝔜~Yopf~𝕐~Yscr~𝒴~ZHcy~Ж~Zacute~Ź~Zcaron~Ž~Zcy~З~Zdot~Ż~ZeroWidthSpace~​~Zfr~ℨ~Zopf~ℤ~Zscr~𝒵~abreve~ă~ac~∾~acE~∾̳~acd~∿~acy~а~af~⁡~afr~𝔞~aleph~ℵ~amacr~ā~amalg~⨿~andand~⩕~andd~⩜~andslope~⩘~andv~⩚~ange~⦤~angle~∠~angmsd~∡~angmsdaa~⦨~angmsdab~⦩~angmsdac~⦪~angmsdad~⦫~angmsdae~⦬~angmsdaf~⦭~angmsdag~⦮~angmsdah~⦯~angrt~∟~angrtvb~⊾~angrtvbd~⦝~angsph~∢~angst~Å~angzarr~⍼~aogon~ą~aopf~𝕒~ap~≈~apE~⩰~apacir~⩯~ape~≊~apid~≋~approx~≈~approxeq~≊~ascr~𝒶~ast~*~asympeq~≍~awconint~∳~awint~⨑~bNot~⫭~backcong~≌~backepsilon~϶~backprime~‵~backsim~∽~backsimeq~⋍~barvee~⊽~barwed~⌅~barwedge~⌅~bbrk~⎵~bbrktbrk~⎶~bcong~≌~bcy~б~becaus~∵~because~∵~bemptyv~⦰~bepsi~϶~bernou~ℬ~beth~ℶ~between~≬~bfr~𝔟~bigcap~⋂~bigcirc~◯~bigcup~⋃~bigodot~⨀~bigoplus~⨁~bigotimes~⨂~bigsqcup~⨆~bigstar~★~bigtriangledown~▽~bigtriangleup~△~biguplus~⨄~bigvee~⋁~bigwedge~⋀~bkarow~⤍~blacklozenge~⧫~blacksquare~▪~blacktriangle~▴~blacktriangledown~▾~blacktriangleleft~◂~blacktriangleright~▸~blank~␣~blk12~▒~blk14~░~blk34~▓~block~█~bne~=⃥~bnequiv~≡⃥~bnot~⌐~bopf~𝕓~bot~⊥~bottom~⊥~bowtie~⋈~boxDL~╗~boxDR~╔~boxDl~╖~boxDr~╓~boxH~═~boxHD~╦~boxHU~╩~boxHd~╤~boxHu~╧~boxUL~╝~boxUR~╚~boxUl~╜~boxUr~╙~boxV~║~boxVH~╬~boxVL~╣~boxVR~╠~boxVh~╫~boxVl~╢~boxVr~╟~boxbox~⧉~boxdL~╕~boxdR~╒~boxdl~┐~boxdr~┌~boxh~─~boxhD~╥~boxhU~╨~boxhd~┬~boxhu~┴~boxminus~⊟~boxplus~⊞~boxtimes~⊠~boxuL~╛~boxuR~╘~boxul~┘~boxur~└~boxv~│~boxvH~╪~boxvL~╡~boxvR~╞~boxvh~┼~boxvl~┤~boxvr~├~bprime~‵~breve~˘~bscr~𝒷~bsemi~⁏~bsim~∽~bsime~⋍~bsol~\\~bsolb~⧅~bsolhsub~⟈~bullet~•~bump~≎~bumpE~⪮~bumpe~≏~bumpeq~≏~cacute~ć~capand~⩄~capbrcup~⩉~capcap~⩋~capcup~⩇~capdot~⩀~caps~∩︀~caret~⁁~caron~ˇ~ccaps~⩍~ccaron~č~ccirc~ĉ~ccups~⩌~ccupssm~⩐~cdot~ċ~cemptyv~⦲~centerdot~·~cfr~𝔠~chcy~ч~check~✓~checkmark~✓~cir~○~cirE~⧃~circeq~≗~circlearrowleft~↺~circlearrowright~↻~circledR~®~circledS~Ⓢ~circledast~⊛~circledcirc~⊚~circleddash~⊝~cire~≗~cirfnint~⨐~cirmid~⫯~cirscir~⧂~clubsuit~♣~colon~:~colone~≔~coloneq~≔~comma~,~commat~@~comp~∁~compfn~∘~complement~∁~complexes~ℂ~congdot~⩭~conint~∮~copf~𝕔~coprod~∐~copysr~℗~cross~✗~cscr~𝒸~csub~⫏~csube~⫑~csup~⫐~csupe~⫒~ctdot~⋯~cudarrl~⤸~cudarrr~⤵~cuepr~⋞~cuesc~⋟~cularr~↶~cularrp~⤽~cupbrcap~⩈~cupcap~⩆~cupcup~⩊~cupdot~⊍~cupor~⩅~cups~∪︀~curarr~↷~curarrm~⤼~curlyeqprec~⋞~curlyeqsucc~⋟~curlyvee~⋎~curlywedge~⋏~curvearrowleft~↶~curvearrowright~↷~cuvee~⋎~cuwed~⋏~cwconint~∲~cwint~∱~cylcty~⌭~dHar~⥥~daleth~ℸ~dash~‐~dashv~⊣~dbkarow~⤏~dblac~˝~dcaron~ď~dcy~д~dd~ⅆ~ddagger~‡~ddarr~⇊~ddotseq~⩷~demptyv~⦱~dfisht~⥿~dfr~𝔡~dharl~⇃~dharr~⇂~diam~⋄~diamond~⋄~diamondsuit~♦~die~¨~digamma~ϝ~disin~⋲~div~÷~divideontimes~⋇~divonx~⋇~djcy~ђ~dlcorn~⌞~dlcrop~⌍~dollar~$~dopf~𝕕~dot~˙~doteq~≐~doteqdot~≑~dotminus~∸~dotplus~∔~dotsquare~⊡~doublebarwedge~⌆~downarrow~↓~downdownarrows~⇊~downharpoonleft~⇃~downharpoonright~⇂~drbkarow~⤐~drcorn~⌟~drcrop~⌌~dscr~𝒹~dscy~ѕ~dsol~⧶~dstrok~đ~dtdot~⋱~dtri~▿~dtrif~▾~duarr~⇵~duhar~⥯~dwangle~⦦~dzcy~џ~dzigrarr~⟿~eDDot~⩷~eDot~≑~easter~⩮~ecaron~ě~ecir~≖~ecolon~≕~ecy~э~edot~ė~ee~ⅇ~efDot~≒~efr~𝔢~eg~⪚~egs~⪖~egsdot~⪘~el~⪙~elinters~⏧~ell~ℓ~els~⪕~elsdot~⪗~emacr~ē~emptyset~∅~emptyv~∅~emsp13~ ~emsp14~ ~eng~ŋ~eogon~ę~eopf~𝕖~epar~⋕~eparsl~⧣~eplus~⩱~epsi~ε~epsiv~ϵ~eqcirc~≖~eqcolon~≕~eqsim~≂~eqslantgtr~⪖~eqslantless~⪕~equals~=~equest~≟~equivDD~⩸~eqvparsl~⧥~erDot~≓~erarr~⥱~escr~ℯ~esdot~≐~esim~≂~excl~!~expectation~ℰ~exponentiale~ⅇ~fallingdotseq~≒~fcy~ф~female~♀~ffilig~ﬃ~fflig~ﬀ~ffllig~ﬄ~ffr~𝔣~filig~ﬁ~fjlig~fj~flat~♭~fllig~ﬂ~fltns~▱~fopf~𝕗~fork~⋔~forkv~⫙~fpartint~⨍~frac13~⅓~frac15~⅕~frac16~⅙~frac18~⅛~frac23~⅔~frac25~⅖~frac35~⅗~frac38~⅜~frac45~⅘~frac56~⅚~frac58~⅝~frac78~⅞~frown~⌢~fscr~𝒻~gE~≧~gEl~⪌~gacute~ǵ~gammad~ϝ~gap~⪆~gbreve~ğ~gcirc~ĝ~gcy~г~gdot~ġ~gel~⋛~geq~≥~geqq~≧~geqslant~⩾~ges~⩾~gescc~⪩~gesdot~⪀~gesdoto~⪂~gesdotol~⪄~gesl~⋛︀~gesles~⪔~gfr~𝔤~gg~≫~ggg~⋙~gimel~ℷ~gjcy~ѓ~gl~≷~glE~⪒~gla~⪥~glj~⪤~gnE~≩~gnap~⪊~gnapprox~⪊~gne~⪈~gneq~⪈~gneqq~≩~gnsim~⋧~gopf~𝕘~grave~`~gscr~ℊ~gsim~≳~gsime~⪎~gsiml~⪐~gtcc~⪧~gtcir~⩺~gtdot~⋗~gtlPar~⦕~gtquest~⩼~gtrapprox~⪆~gtrarr~⥸~gtrdot~⋗~gtreqless~⋛~gtreqqless~⪌~gtrless~≷~gtrsim~≳~gvertneqq~≩︀~gvnE~≩︀~hairsp~ ~half~½~hamilt~ℋ~hardcy~ъ~harrcir~⥈~harrw~↭~hbar~ℏ~hcirc~ĥ~heartsuit~♥~hercon~⊹~hfr~𝔥~hksearow~⤥~hkswarow~⤦~hoarr~⇿~homtht~∻~hookleftarrow~↩~hookrightarrow~↪~hopf~𝕙~horbar~―~hscr~𝒽~hslash~ℏ~hstrok~ħ~hybull~⁃~hyphen~‐~ic~⁣~icy~и~iecy~е~iff~⇔~ifr~𝔦~ii~ⅈ~iiiint~⨌~iiint~∭~iinfin~⧜~iiota~℩~ijlig~ĳ~imacr~ī~imagline~ℐ~imagpart~ℑ~imath~ı~imof~⊷~imped~Ƶ~in~∈~incare~℅~infintie~⧝~inodot~ı~intcal~⊺~integers~ℤ~intercal~⊺~intlarhk~⨗~intprod~⨼~iocy~ё~iogon~į~iopf~𝕚~iprod~⨼~iscr~𝒾~isinE~⋹~isindot~⋵~isins~⋴~isinsv~⋳~isinv~∈~it~⁢~itilde~ĩ~iukcy~і~jcirc~ĵ~jcy~й~jfr~𝔧~jmath~ȷ~jopf~𝕛~jscr~𝒿~jsercy~ј~jukcy~є~kappav~ϰ~kcedil~ķ~kcy~к~kfr~𝔨~kgreen~ĸ~khcy~х~kjcy~ќ~kopf~𝕜~kscr~𝓀~lAarr~⇚~lAtail~⤛~lBarr~⤎~lE~≦~lEg~⪋~lHar~⥢~lacute~ĺ~laemptyv~⦴~lagran~ℒ~langd~⦑~langle~⟨~lap~⪅~larrb~⇤~larrbfs~⤟~larrfs~⤝~larrhk~↩~larrlp~↫~larrpl~⤹~larrsim~⥳~larrtl~↢~lat~⪫~latail~⤙~late~⪭~lates~⪭︀~lbarr~⤌~lbbrk~❲~lbrace~{~lbrack~[~lbrke~⦋~lbrksld~⦏~lbrkslu~⦍~lcaron~ľ~lcedil~ļ~lcub~{~lcy~л~ldca~⤶~ldquor~„~ldrdhar~⥧~ldrushar~⥋~ldsh~↲~leftarrow~←~leftarrowtail~↢~leftharpoondown~↽~leftharpoonup~↼~leftleftarrows~⇇~leftrightarrow~↔~leftrightarrows~⇆~leftrightharpoons~⇋~leftrightsquigarrow~↭~leftthreetimes~⋋~leg~⋚~leq~≤~leqq~≦~leqslant~⩽~les~⩽~lescc~⪨~lesdot~⩿~lesdoto~⪁~lesdotor~⪃~lesg~⋚︀~lesges~⪓~lessapprox~⪅~lessdot~⋖~lesseqgtr~⋚~lesseqqgtr~⪋~lessgtr~≶~lesssim~≲~lfisht~⥼~lfr~𝔩~lg~≶~lgE~⪑~lhard~↽~lharu~↼~lharul~⥪~lhblk~▄~ljcy~љ~ll~≪~llarr~⇇~llcorner~⌞~llhard~⥫~lltri~◺~lmidot~ŀ~lmoust~⎰~lmoustache~⎰~lnE~≨~lnap~⪉~lnapprox~⪉~lne~⪇~lneq~⪇~lneqq~≨~lnsim~⋦~loang~⟬~loarr~⇽~lobrk~⟦~longleftarrow~⟵~longleftrightarrow~⟷~longmapsto~⟼~longrightarrow~⟶~looparrowleft~↫~looparrowright~↬~lopar~⦅~lopf~𝕝~loplus~⨭~lotimes~⨴~lowbar~_~lozenge~◊~lozf~⧫~lpar~(~lparlt~⦓~lrarr~⇆~lrcorner~⌟~lrhar~⇋~lrhard~⥭~lrtri~⊿~lscr~𝓁~lsh~↰~lsim~≲~lsime~⪍~lsimg~⪏~lsqb~[~lsquor~‚~lstrok~ł~ltcc~⪦~ltcir~⩹~ltdot~⋖~lthree~⋋~ltimes~⋉~ltlarr~⥶~ltquest~⩻~ltrPar~⦖~ltri~◃~ltrie~⊴~ltrif~◂~lurdshar~⥊~luruhar~⥦~lvertneqq~≨︀~lvnE~≨︀~mDDot~∺~male~♂~malt~✠~maltese~✠~map~↦~mapsto~↦~mapstodown~↧~mapstoleft~↤~mapstoup~↥~marker~▮~mcomma~⨩~mcy~м~measuredangle~∡~mfr~𝔪~mho~℧~mid~∣~midast~*~midcir~⫰~minusb~⊟~minusd~∸~minusdu~⨪~mlcp~⫛~mldr~…~mnplus~∓~models~⊧~mopf~𝕞~mp~∓~mscr~𝓂~mstpos~∾~multimap~⊸~mumap~⊸~nGg~⋙̸~nGt~≫⃒~nGtv~≫̸~nLeftarrow~⇍~nLeftrightarrow~⇎~nLl~⋘̸~nLt~≪⃒~nLtv~≪̸~nRightarrow~⇏~nVDash~⊯~nVdash~⊮~nacute~ń~nang~∠⃒~nap~≉~napE~⩰̸~napid~≋̸~napos~ŉ~napprox~≉~natur~♮~natural~♮~naturals~ℕ~nbump~≎̸~nbumpe~≏̸~ncap~⩃~ncaron~ň~ncedil~ņ~ncong~≇~ncongdot~⩭̸~ncup~⩂~ncy~н~neArr~⇗~nearhk~⤤~nearr~↗~nearrow~↗~nedot~≐̸~nequiv~≢~nesear~⤨~nesim~≂̸~nexist~∄~nexists~∄~nfr~𝔫~ngE~≧̸~nge~≱~ngeq~≱~ngeqq~≧̸~ngeqslant~⩾̸~nges~⩾̸~ngsim~≵~ngt~≯~ngtr~≯~nhArr~⇎~nharr~↮~nhpar~⫲~nis~⋼~nisd~⋺~niv~∋~njcy~њ~nlArr~⇍~nlE~≦̸~nlarr~↚~nldr~‥~nle~≰~nleftarrow~↚~nleftrightarrow~↮~nleq~≰~nleqq~≦̸~nleqslant~⩽̸~nles~⩽̸~nless~≮~nlsim~≴~nlt~≮~nltri~⋪~nltrie~⋬~nmid~∤~nopf~𝕟~notinE~⋹̸~notindot~⋵̸~notinva~∉~notinvb~⋷~notinvc~⋶~notni~∌~notniva~∌~notnivb~⋾~notnivc~⋽~npar~∦~nparallel~∦~nparsl~⫽⃥~npart~∂̸~npolint~⨔~npr~⊀~nprcue~⋠~npre~⪯̸~nprec~⊀~npreceq~⪯̸~nrArr~⇏~nrarr~↛~nrarrc~⤳̸~nrarrw~↝̸~nrightarrow~↛~nrtri~⋫~nrtrie~⋭~nsc~⊁~nsccue~⋡~nsce~⪰̸~nscr~𝓃~nshortmid~∤~nshortparallel~∦~nsim~≁~nsime~≄~nsimeq~≄~nsmid~∤~nspar~∦~nsqsube~⋢~nsqsupe~⋣~nsubE~⫅̸~nsube~⊈~nsubset~⊂⃒~nsubseteq~⊈~nsubseteqq~⫅̸~nsucc~⊁~nsucceq~⪰̸~nsup~⊅~nsupE~⫆̸~nsupe~⊉~nsupset~⊃⃒~nsupseteq~⊉~nsupseteqq~⫆̸~ntgl~≹~ntlg~≸~ntriangleleft~⋪~ntrianglelefteq~⋬~ntriangleright~⋫~ntrianglerighteq~⋭~num~#~numero~№~numsp~ ~nvDash~⊭~nvHarr~⤄~nvap~≍⃒~nvdash~⊬~nvge~≥⃒~nvgt~>⃒~nvinfin~⧞~nvlArr~⤂~nvle~≤⃒~nvlt~<⃒~nvltrie~⊴⃒~nvrArr~⤃~nvrtrie~⊵⃒~nvsim~∼⃒~nwArr~⇖~nwarhk~⤣~nwarr~↖~nwarrow~↖~nwnear~⤧~oS~Ⓢ~oast~⊛~ocir~⊚~ocy~о~odash~⊝~odblac~ő~odiv~⨸~odot~⊙~odsold~⦼~ofcir~⦿~ofr~𝔬~ogon~˛~ogt~⧁~ohbar~⦵~ohm~Ω~oint~∮~olarr~↺~olcir~⦾~olcross~⦻~olt~⧀~omacr~ō~omid~⦶~ominus~⊖~oopf~𝕠~opar~⦷~operp~⦹~orarr~↻~ord~⩝~order~ℴ~orderof~ℴ~origof~⊶~oror~⩖~orslope~⩗~orv~⩛~oscr~ℴ~osol~⊘~otimesas~⨶~ovbar~⌽~par~∥~parallel~∥~parsim~⫳~parsl~⫽~pcy~п~percnt~%~period~.~pertenk~‱~pfr~𝔭~phiv~ϕ~phmmat~ℳ~phone~☎~pitchfork~⋔~planck~ℏ~planckh~ℎ~plankv~ℏ~plus~+~plusacir~⨣~plusb~⊞~pluscir~⨢~plusdo~∔~plusdu~⨥~pluse~⩲~plussim~⨦~plustwo~⨧~pm~±~pointint~⨕~popf~𝕡~pr~≺~prE~⪳~prap~⪷~prcue~≼~pre~⪯~prec~≺~precapprox~⪷~preccurlyeq~≼~preceq~⪯~precnapprox~⪹~precneqq~⪵~precnsim~⋨~precsim~≾~primes~ℙ~prnE~⪵~prnap~⪹~prnsim~⋨~profalar~⌮~profline~⌒~profsurf~⌓~propto~∝~prsim~≾~prurel~⊰~pscr~𝓅~puncsp~ ~qfr~𝔮~qint~⨌~qopf~𝕢~qprime~⁗~qscr~𝓆~quaternions~ℍ~quatint~⨖~quest~?~questeq~≟~rAarr~⇛~rAtail~⤜~rBarr~⤏~rHar~⥤~race~∽̱~racute~ŕ~raemptyv~⦳~rangd~⦒~range~⦥~rangle~⟩~rarrap~⥵~rarrb~⇥~rarrbfs~⤠~rarrc~⤳~rarrfs~⤞~rarrhk~↪~rarrlp~↬~rarrpl~⥅~rarrsim~⥴~rarrtl~↣~rarrw~↝~ratail~⤚~ratio~∶~rationals~ℚ~rbarr~⤍~rbbrk~❳~rbrace~}~rbrack~]~rbrke~⦌~rbrksld~⦎~rbrkslu~⦐~rcaron~ř~rcedil~ŗ~rcub~}~rcy~р~rdca~⤷~rdldhar~⥩~rdquor~”~rdsh~↳~realine~ℛ~realpart~ℜ~reals~ℝ~rect~▭~rfisht~⥽~rfr~𝔯~rhard~⇁~rharu~⇀~rharul~⥬~rhov~ϱ~rightarrow~→~rightarrowtail~↣~rightharpoondown~⇁~rightharpoonup~⇀~rightleftarrows~⇄~rightleftharpoons~⇌~rightrightarrows~⇉~rightsquigarrow~↝~rightthreetimes~⋌~ring~˚~risingdotseq~≓~rlarr~⇄~rlhar~⇌~rmoust~⎱~rmoustache~⎱~rnmid~⫮~roang~⟭~roarr~⇾~robrk~⟧~ropar~⦆~ropf~𝕣~roplus~⨮~rotimes~⨵~rpar~)~rpargt~⦔~rppolint~⨒~rrarr~⇉~rscr~𝓇~rsh~↱~rsqb~]~rsquor~’~rthree~⋌~rtimes~⋊~rtri~▹~rtrie~⊵~rtrif~▸~rtriltri~⧎~ruluhar~⥨~rx~℞~sacute~ś~sc~≻~scE~⪴~scap~⪸~sccue~≽~sce~⪰~scedil~ş~scirc~ŝ~scnE~⪶~scnap~⪺~scnsim~⋩~scpolint~⨓~scsim~≿~scy~с~sdotb~⊡~sdote~⩦~seArr~⇘~searhk~⤥~searr~↘~searrow~↘~semi~;~seswar~⤩~setminus~∖~setmn~∖~sext~✶~sfr~𝔰~sfrown~⌢~sharp~♯~shchcy~щ~shcy~ш~shortmid~∣~shortparallel~∥~sigmav~ς~simdot~⩪~sime~≃~simeq~≃~simg~⪞~simgE~⪠~siml~⪝~simlE~⪟~simne~≆~simplus~⨤~simrarr~⥲~slarr~←~smallsetminus~∖~smashp~⨳~smeparsl~⧤~smid~∣~smile~⌣~smt~⪪~smte~⪬~smtes~⪬︀~softcy~ь~sol~/~solb~⧄~solbar~⌿~sopf~𝕤~spadesuit~♠~spar~∥~sqcap~⊓~sqcaps~⊓︀~sqcup~⊔~sqcups~⊔︀~sqsub~⊏~sqsube~⊑~sqsubset~⊏~sqsubseteq~⊑~sqsup~⊐~sqsupe~⊒~sqsupset~⊐~sqsupseteq~⊒~squ~□~square~□~squarf~▪~squf~▪~srarr~→~sscr~𝓈~ssetmn~∖~ssmile~⌣~sstarf~⋆~star~☆~starf~★~straightepsilon~ϵ~straightphi~ϕ~strns~¯~subE~⫅~subdot~⪽~subedot~⫃~submult~⫁~subnE~⫋~subne~⊊~subplus~⪿~subrarr~⥹~subset~⊂~subseteq~⊆~subseteqq~⫅~subsetneq~⊊~subsetneqq~⫋~subsim~⫇~subsub~⫕~subsup~⫓~succ~≻~succapprox~⪸~succcurlyeq~≽~succeq~⪰~succnapprox~⪺~succneqq~⪶~succnsim~⋩~succsim~≿~sung~♪~supE~⫆~supdot~⪾~supdsub~⫘~supedot~⫄~suphsol~⟉~suphsub~⫗~suplarr~⥻~supmult~⫂~supnE~⫌~supne~⊋~supplus~⫀~supset~⊃~supseteq~⊇~supseteqq~⫆~supsetneq~⊋~supsetneqq~⫌~supsim~⫈~supsub~⫔~supsup~⫖~swArr~⇙~swarhk~⤦~swarr~↙~swarrow~↙~swnwar~⤪~target~⌖~tbrk~⎴~tcaron~ť~tcedil~ţ~tcy~т~tdot~⃛~telrec~⌕~tfr~𝔱~therefore~∴~thetav~ϑ~thickapprox~≈~thicksim~∼~thkap~≈~thksim~∼~timesb~⊠~timesbar~⨱~timesd~⨰~tint~∭~toea~⤨~top~⊤~topbot~⌶~topcir~⫱~topf~𝕥~topfork~⫚~tosa~⤩~tprime~‴~triangle~▵~triangledown~▿~triangleleft~◃~trianglelefteq~⊴~triangleq~≜~triangleright~▹~trianglerighteq~⊵~tridot~◬~trie~≜~triminus~⨺~triplus~⨹~trisb~⧍~tritime~⨻~trpezium~⏢~tscr~𝓉~tscy~ц~tshcy~ћ~tstrok~ŧ~twixt~≬~twoheadleftarrow~↞~twoheadrightarrow~↠~uHar~⥣~ubrcy~ў~ubreve~ŭ~ucy~у~udarr~⇅~udblac~ű~udhar~⥮~ufisht~⥾~ufr~𝔲~uharl~↿~uharr~↾~uhblk~▀~ulcorn~⌜~ulcorner~⌜~ulcrop~⌏~ultri~◸~umacr~ū~uogon~ų~uopf~𝕦~uparrow~↑~updownarrow~↕~upharpoonleft~↿~upharpoonright~↾~uplus~⊎~upsi~υ~upuparrows~⇈~urcorn~⌝~urcorner~⌝~urcrop~⌎~uring~ů~urtri~◹~uscr~𝓊~utdot~⋰~utilde~ũ~utri~▵~utrif~▴~uuarr~⇈~uwangle~⦧~vArr~⇕~vBar~⫨~vBarv~⫩~vDash~⊨~vangrt~⦜~varepsilon~ϵ~varkappa~ϰ~varnothing~∅~varphi~ϕ~varpi~ϖ~varpropto~∝~varr~↕~varrho~ϱ~varsigma~ς~varsubsetneq~⊊︀~varsubsetneqq~⫋︀~varsupsetneq~⊋︀~varsupsetneqq~⫌︀~vartheta~ϑ~vartriangleleft~⊲~vartriangleright~⊳~vcy~в~vdash~⊢~vee~∨~veebar~⊻~veeeq~≚~vellip~⋮~verbar~|~vert~|~vfr~𝔳~vltri~⊲~vnsub~⊂⃒~vnsup~⊃⃒~vopf~𝕧~vprop~∝~vrtri~⊳~vscr~𝓋~vsubnE~⫋︀~vsubne~⊊︀~vsupnE~⫌︀~vsupne~⊋︀~vzigzag~⦚~wcirc~ŵ~wedbar~⩟~wedge~∧~wedgeq~≙~wfr~𝔴~wopf~𝕨~wp~℘~wr~≀~wreath~≀~wscr~𝓌~xcap~⋂~xcirc~◯~xcup~⋃~xdtri~▽~xfr~𝔵~xhArr~⟺~xharr~⟷~xlArr~⟸~xlarr~⟵~xmap~⟼~xnis~⋻~xodot~⨀~xopf~𝕩~xoplus~⨁~xotime~⨂~xrArr~⟹~xrarr~⟶~xscr~𝓍~xsqcup~⨆~xuplus~⨄~xutri~△~xvee~⋁~xwedge~⋀~yacy~я~ycirc~ŷ~ycy~ы~yfr~𝔶~yicy~ї~yopf~𝕪~yscr~𝓎~yucy~ю~zacute~ź~zcaron~ž~zcy~з~zdot~ż~zeetrf~ℨ~zfr~𝔷~zhcy~ж~zigrarr~⇝~zopf~𝕫~zscr~𝓏~~AMP~&~COPY~©~GT~>~LT~<~QUOT~"~REG~®', Pe.html4);
var js = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, _s = String.fromCodePoint || function(e) {
  return String.fromCharCode(Math.floor((e - 65536) / 1024) + 55296, (e - 65536) % 1024 + 56320);
}, Ue = function() {
  return Ue = Object.assign || function(e) {
    for (var t, r = 1, a = arguments.length; r < a; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ue.apply(this, arguments);
}, Js = Ue(Ue({}, Pe), { all: Pe.html5 }), zs = {
  scope: "body",
  level: "all"
}, Wt = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, Gt = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, ni = {
  xml: {
    strict: Wt,
    attribute: Gt,
    body: Vt.xml
  },
  html4: {
    strict: Wt,
    attribute: Gt,
    body: Vt.html4
  },
  html5: {
    strict: Wt,
    attribute: Gt,
    body: Vt.html5
  }
}, Fs = Ue(Ue({}, ni), { all: ni.html5 }), Hi = String.fromCharCode, Vs = Hi(65533);
function Ws(e, t, r, a) {
  var o = e, l = e[e.length - 1];
  if (r && l === "=")
    o = e;
  else if (a && l !== ";")
    o = e;
  else {
    var h = t[e];
    if (h)
      o = h;
    else if (e[0] === "&" && e[1] === "#") {
      var g = e[2], w = g == "x" || g == "X" ? parseInt(e.substr(3), 16) : parseInt(e.substr(2));
      o = w >= 1114111 ? Vs : w > 65535 ? _s(w) : Hi(js[w] || w);
    }
  }
  return o;
}
function it(e, t) {
  var r = zs, a = r.level, o = a === void 0 ? "all" : a, l = r.scope, h = l === void 0 ? o === "xml" ? "strict" : "body" : l;
  if (!e)
    return "";
  var g = Fs[o][h], w = Js[o].entities, d = h === "attribute", v = h === "strict";
  return e.replace(g, function(c) {
    return Ws(c, w, d, v);
  });
}
const Yi = ({ cents: e, locale: t, showCents: r = !1 }) => new Intl.NumberFormat(t, {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: r ? 2 : 0,
  maximumFractionDigits: r ? 2 : 0
}).format(e / 100), xa = ({
  project: e,
  locale: t = document.documentElement.lang || "de",
  href: r,
  onClick: a,
  className: o,
  showDescription: l,
  openInTab: h,
  bottomContent: g,
  children: w,
  showCarrierName: d
}) => {
  const v = Yi({ cents: e.open_amount_in_cents, locale: t }), c = new Intl.NumberFormat(t).format(e.donations_count), n = t === "de" ? "fehlen noch" : "still needed", i = t === "de" ? "Spenden" : "donations", s = r || e.links.find((b) => b.rel === "platform")?.href, u = e.profile_picture?.links.find((b) => b.rel === "fill_410x214")?.href, f = e.carrier?.picture?.links.find((b) => b.rel === "fill_100x100")?.href, x = (b) => {
    a?.(b, e);
  };
  return /* @__PURE__ */ ae(
    "a",
    {
      title: e.title ? it(e.title) : "",
      onClick: x,
      className: `donatable-teaser ${o ?? ""} ${l ? "donatable-teaser--with-description" : ""} ${g ? "donatable-teaser--with-bottom-content" : ""}`,
      href: s,
      target: h ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        w,
        /* @__PURE__ */ z(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${u})` },
            title: e.title ? it(e.title) : ""
          }
        ),
        /* @__PURE__ */ z(rt, { as: "h2", className: "donatable-teaser--title", value: e.title }),
        l && /* @__PURE__ */ z(rt, { className: "donatable-teaser--description", as: "div", value: e.description }),
        /* @__PURE__ */ ae("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ ae("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ ae("div", { children: [
              e.city && /* @__PURE__ */ ae(fr, { children: [
                /* @__PURE__ */ z("span", { children: e.city }),
                ",",
                " "
              ] }),
              e.country
            ] }),
            /* @__PURE__ */ z("div", { children: d ? /* @__PURE__ */ z("span", { children: e.carrier?.name }) : /* @__PURE__ */ ae(fr, { children: [
              /* @__PURE__ */ z("span", { children: c }),
              " ",
              i
            ] }) }),
            /* @__PURE__ */ ae("div", { children: [
              /* @__PURE__ */ z("span", { children: v }),
              " ",
              n
            ] })
          ] }),
          /* @__PURE__ */ z("img", { src: f, alt: e.carrier?.name, className: "donatable-teaser--carrier-logo" })
        ] }),
        /* @__PURE__ */ z("div", { className: "donatable-teaser--progress", children: /* @__PURE__ */ z("div", { className: "donatable-teaser--progress-bar", style: { width: `${e.progress_percentage}%` } }) }),
        g
      ]
    }
  );
}, Gs = (e, t) => t === 1 ? e === "de" ? "Spende" : "donation" : e === "de" ? "Spenden" : "donations", ya = ({
  fundraisingEvent: e,
  locale: t = document.documentElement.lang || "de",
  href: r,
  onClick: a,
  openInTab: o,
  children: l
}) => {
  const h = r || e.links.find((n) => n.rel === "platform")?.href, g = e.profile_picture?.links.find(
    (n) => n.rel === "fill_410x214"
  )?.href, w = Yi({ cents: e.donated_amount_in_cents, locale: t }), d = e.contact?.picture?.links.find((n) => n.rel === "fill_100x100")?.href, v = (n) => {
    a?.(n, e);
  }, c = Gs(t, e.donations_count);
  return /* @__PURE__ */ ae(
    "a",
    {
      title: e.title ? it(e.title) : "",
      onClick: v,
      className: "donatable-teaser",
      href: h,
      target: o ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        l,
        /* @__PURE__ */ z(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${g})` },
            title: e.title ? it(e.title) : ""
          }
        ),
        /* @__PURE__ */ z(rt, { as: "h2", className: "donatable-teaser--title", value: e.title }),
        /* @__PURE__ */ ae("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ ae("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ z("div", { children: /* @__PURE__ */ z(rt, { as: "span", value: e.contact?.name }) }),
            /* @__PURE__ */ ae("div", { children: [
              /* @__PURE__ */ z("span", { children: e.donations_count }),
              " ",
              c
            ] }),
            /* @__PURE__ */ ae("div", { children: [
              /* @__PURE__ */ z("span", { children: w }),
              " ",
              t === "de" ? "gesammelt" : "collected"
            ] })
          ] }),
          /* @__PURE__ */ z(
            "img",
            {
              style: { borderRadius: "50%", border: "1px solid #cccccc" },
              src: d,
              alt: e.contact?.name ?? "",
              className: "donatable-teaser--carrier-logo"
            }
          )
        ] })
      ]
    }
  );
}, Hs = ({
  icon: e,
  content: t,
  className: r = "",
  boxShadow: a,
  buttonClassName: o = "",
  ...l
}) => {
  const h = e;
  return /* @__PURE__ */ ae(
    "a",
    {
      ...l,
      className: `share-button--full ${a ? "share-button--box-shadowed" : ""} ${o} ${r}`,
      children: [
        /* @__PURE__ */ z("div", { className: "share-button--full-icon-wrapper", children: /* @__PURE__ */ z(h, { className: "share-button--icon" }) }),
        /* @__PURE__ */ z("span", { className: "share-button--text", children: t })
      ]
    }
  );
}, Ys = ({
  icon: e,
  content: t,
  className: r = "",
  buttonClassName: a = "",
  boxShadow: o,
  ...l
}) => {
  const h = e;
  return /* @__PURE__ */ ae("a", { ...l, className: `share-button--minimal ${a} ${r}`, children: [
    /* @__PURE__ */ z(h, { className: "share-button--icon" }),
    /* @__PURE__ */ z("span", { className: "share-button--text", children: t })
  ] });
}, $s = ({ icon: e, className: t = "", boxShadow: r, buttonClassName: a = "", ...o }) => {
  const l = e;
  return /* @__PURE__ */ z(
    "a",
    {
      ...o,
      className: `share-button--round ${r ? "share-button--box-shadowed" : ""} ${a} ${t}`,
      children: /* @__PURE__ */ z(l, {})
    }
  );
}, Zs = ({
  icon: e,
  className: t = "",
  buttonClassName: r = "",
  boxShadow: a,
  ...o
}) => {
  const l = e;
  return /* @__PURE__ */ z("a", { ...o, className: `share-button--square ${r} ${t}`, children: /* @__PURE__ */ z(l, {}) });
}, Xs = ({
  icon: e,
  content: t,
  className: r = "",
  boxShadow: a,
  buttonClassName: o = "",
  ...l
}) => {
  const h = e;
  return /* @__PURE__ */ ae("div", { className: `share-button--round-with-label ${r}`, children: [
    /* @__PURE__ */ z(
      "a",
      {
        ...l,
        className: `share-button--round ${a ? "share-button--box-shadowed" : ""} ${o}`,
        children: /* @__PURE__ */ z(h, {})
      }
    ),
    t
  ] });
}, Ks = {
  full: Hs,
  minimal: Ys,
  round: $s,
  square: Zs,
  roundWithLabel: Xs
}, ke = ({
  action: e,
  ariaLabel: t,
  buttonLabel: r,
  className: a,
  icon: o
}) => (h) => {
  const g = Ks[h.shape], w = (d) => {
    d.preventDefault(), h.beforeOnClick?.(d), e(h);
  };
  return /* @__PURE__ */ z(
    g,
    {
      "aria-label": t,
      boxShadow: h.boxShadow,
      className: h.className || "",
      buttonClassName: a,
      href: "#",
      onClick: w,
      role: "button",
      title: h.title || "",
      label: r || t,
      icon: o,
      content: h.content
    }
  );
}, Qs = ({ size: e = "60%" }) => /* @__PURE__ */ z(
  "svg",
  {
    className: "share-button--icon",
    width: e,
    height: e,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
      }
    )
  }
), ea = ({ size: e = "60%" }) => /* @__PURE__ */ z(
  "svg",
  {
    className: "share-button--icon",
    width: e,
    height: e,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 512",
    children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
      }
    )
  }
), ta = ({ size: e = "60%" }) => /* @__PURE__ */ z(
  "svg",
  {
    className: "share-button--icon",
    width: e,
    height: e,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"
      }
    )
  }
), ra = ({ size: e = "60%" }) => /* @__PURE__ */ z(
  "svg",
  {
    className: "share-button--icon",
    width: e,
    height: e,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
      }
    )
  }
), ia = ({ size: e = "60%" }) => /* @__PURE__ */ z(
  "svg",
  {
    className: "share-button--icon",
    width: e,
    height: e,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
      }
    )
  }
), na = ({ size: e = "60%" }) => /* @__PURE__ */ z(
  "svg",
  {
    className: "share-button--icon",
    width: e,
    height: e,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    children: /* @__PURE__ */ ae("g", { children: [
      /* @__PURE__ */ z(
        "path",
        {
          fill: "currentColor",
          d: `M337.5,448c-5.7,0-11.4-1.7-16.4-5.2c-5.6-3.9-10.8-8.5-15.5-13.5l-19.3-20.6c-48.9-52.1-46.2-134.3,5.9-183.2l95-89.1
		c52.1-48.9,134.3-46.2,183.2,5.9c48.9,52.1,46.2,134.3-5.9,183.2l-31.8,29.8c-11.5,10.8-29.6,10.2-40.4-1.3
		c-10.8-11.5-10.2-29.6,1.3-40.4l31.8-29.8c29.2-27.3,30.7-73.3,3.3-102.5c-27.3-29.2-73.3-30.7-102.5-3.3l-95,89.1
		c-29.2,27.3-30.7,73.3-3.3,102.5l19.3,20.6c2,2.2,4.3,4.1,6.7,5.9c12.9,9.1,16,26.9,6.9,39.8C355.3,443.8,346.5,448,337.5,448z`
        }
      ),
      /* @__PURE__ */ z(
        "path",
        {
          fill: "currentColor",
          d: `M245.8,617.8c-34.6,0-69.1-13.7-94.6-40.9c-48.9-52.1-46.2-134.3,5.9-183.2l31.8-29.8c11.5-10.8,29.6-10.2,40.4,1.3
		c10.8,11.5,10.2,29.6-1.3,40.4l-31.8,29.8c-29.2,27.3-30.7,73.3-3.3,102.5c27.3,29.2,73.3,30.7,102.5,3.3l95-89.1
		c29.2-27.3,30.7-73.3,3.3-102.5L374.4,329c-2-2.2-4.3-4.1-6.7-5.9c-12.9-9.1-16-26.9-6.9-39.8c9.1-12.9,26.9-16,39.8-6.9
		c5.6,3.9,10.8,8.5,15.5,13.5l19.3,20.6c48.9,52.1,46.2,134.3-5.9,183.2l-95,89.1C309.5,606.3,277.6,617.8,245.8,617.8z`
        }
      )
    ] })
  }
), sa = ({ size: e = "60%" }) => /* @__PURE__ */ ae(
  "svg",
  {
    className: "share-button--icon",
    width: e,
    height: e,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.486 40.912",
    children: [
      /* @__PURE__ */ z(
        "path",
        {
          fill: "currentColor",
          d: "M95.09,109.768c.137-.971.242-1.947.417-2.911.991-5.459,4.855-9.173,10.381-9.364,6.654-.229,13.327-.241,19.98,0a10.692,10.692,0,0,1,10.558,10.687q.3,9.583,0,19.182a10.691,10.691,0,0,1-10.558,10.687c-6.653.24-13.328.246-19.98,0-6.016-.226-10.174-4.69-10.576-10.715-.035-.521-.147-1.038-.223-1.557Zm20.749,24.713c3.045,0,6.092.091,9.133-.021,4.767-.177,7.7-3.022,7.811-7.785q.207-8.9,0-17.812c-.111-4.762-3.046-7.673-7.811-7.775q-9.072-.192-18.151,0c-4.729.1-7.67,2.952-7.8,7.661q-.245,9.014,0,18.039c.128,4.709,3.069,7.5,7.8,7.671C109.823,134.572,112.832,134.482,115.839,134.482Zm0,0",
          transform: "translate(-95.09 -97.317)"
        }
      ),
      /* @__PURE__ */ z(
        "path",
        {
          fill: "currentColor",
          d: "M184.564,174a10.572,10.572,0,1,0,10.572,10.571A10.572,10.572,0,0,0,184.564,174Zm0,17.5a6.932,6.932,0,1,1,6.932-6.932A6.932,6.932,0,0,1,184.564,191.5Zm0,0",
          transform: "translate(-163.821 -164.111)"
        }
      ),
      /* @__PURE__ */ z(
        "path",
        {
          fill: "currentColor",
          d: "M328.315,153.258a2.515,2.515,0,1,1-2.515-2.515A2.515,2.515,0,0,1,328.315,153.258Zm0,0",
          transform: "translate(-293.868 -143.855)"
        }
      )
    ]
  }
);
function aa(e) {
  return e.toLowerCase().startsWith("utm_");
}
const oa = (e) => new URLSearchParams(Object.entries(e).filter(([r, a]) => a !== void 0)), cr = (e, t = {}) => {
  if (!e) return e;
  const r = e.startsWith("http") ? e : `https://${e}`, a = new URL(r);
  return a.searchParams.forEach((l, h, g) => {
    aa(h) && g.delete(h);
  }), oa(t).forEach((l, h) => a.searchParams.set(h, l)), a.toString();
}, Ve = (e, t = {}, r = "") => {
  const a = cr(e, t);
  return encodeURIComponent(r + a);
}, $i = (e) => window.open(e, "sharer", "toolbar=no,width=1042,height=436"), Zi = (e) => {
  const t = document.createElement("textarea");
  t.value = e, document.body.appendChild(t), t.select();
  const r = document.execCommand("copy");
  if (document.body.removeChild(t), !r) {
    const o = (document.documentElement.lang || "de") === "de" ? "Sorry, dein Browser unterstützt diese Funktion nicht." : "Sorry, your Browser doesn't support this feature.";
    alert(o);
  }
  return r;
}, Xi = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent), la = ({
  shareUrl: e,
  subject: t = null,
  teaser: r = "",
  utmParams: a
}) => {
  const o = encodeURIComponent(t || r), l = Ve(e, a, `${r} `);
  return window.open(`mailto:?subject=${o}&body=${l}`, "_self");
}, va = ke({
  action: la,
  ariaLabel: "Email",
  className: "share-button--email",
  icon: Qs
}), ua = ({ shareUrl: e, utmParams: t }) => $i(`https://www.facebook.com/sharer/sharer.php?u=${Ve(e, t)}`), Ra = ke({
  action: ua,
  ariaLabel: "Facebook",
  className: "share-button--facebook",
  icon: ea
}), ca = ({
  facebookAppId: e,
  shareUrl: t,
  utmParams: r
}) => {
  const a = Xi(), o = Ve(t, r);
  return a ? window.open(`fb-messenger://share?link=${o}&app_id=${e}`) : $i(
    `http://www.facebook.com/dialog/send?app_id=${e}&link=${o}&redirect_uri=${encodeURIComponent(t)}`
  );
}, Sa = ke({
  action: ca,
  ariaLabel: "Facebook Messenger",
  buttonLabel: "Messenger",
  className: "share-button--facebook-messenger",
  icon: ta
}), ha = ({ shareUrl: e, teaser: t = "", utmParams: r }) => window.open(
  `https://telegram.me/share/url?url=${Ve(e, r)}&text=${encodeURIComponent(t)}`
), Aa = ke({
  action: ha,
  ariaLabel: "Telegram",
  className: "share-button--telegram",
  icon: ra
}), fa = ({ shareUrl: e, utmParams: t }) => window.open(
  `https://${Xi() ? "api" : "web"}.whatsapp.com/send?text=${Ve(e, t)}`
), Ta = ke({
  action: fa,
  ariaLabel: "WhatsApp",
  className: "share-button--whatsapp",
  icon: ia
}), da = ({ shareUrl: e, utmParams: t }) => {
  Zi(cr(e, t));
}, Ea = ke({
  action: da,
  ariaLabel: "ShareLink",
  buttonLabel: "Link",
  className: "share-button--share-link",
  icon: na
}), pa = ({ shareUrl: e, utmParams: t }) => {
  Zi(cr(e, t));
}, Na = ke({
  action: pa,
  ariaLabel: "Instagram",
  className: "share-button--instagram",
  icon: sa
}), Ia = (e, t) => e.replace(
  /\w\w/g,
  (r) => ("0" + Math.min(255, Math.max(0, parseInt(r, 16) + t)).toString(16)).substr(-2)
);
export {
  va as EmailButton,
  Ra as FacebookButton,
  Sa as FacebookMessengerButton,
  ya as FundraisingEventTeaser,
  Na as InstagramButton,
  Ea as LinkButton,
  xa as ProjectTeaser,
  Aa as TelegramButton,
  Ta as WhatsappButton,
  Ia as changeBrightness,
  Zi as copyToClipboard,
  la as emailShareAction,
  Ve as encodeShareURL,
  ca as facebookMessengerShareAction,
  ua as facebookShareAction,
  Yi as formatAmount,
  cr as getShareURL,
  pa as instagramAction,
  Xi as isMobileOrTablet,
  da as linkAction,
  $i as openPopup,
  ha as telegramShareAction,
  oa as toSearchParams,
  fa as whatsappShareAction
};
